export enum LanguageKey {
  Automation_flow_templates = "Automation_flow_templates",
  Automation_ai_templates = "Automation_ai_templates",
  Automation_sample = "Automation_sample",
  Automation_sample_notice = "Automation_sample_notice",
  Automation_template_number = "Automation_template_number",
  Automation_beginner = "Automation_beginner",
  Automation_intermediate = "Automation_intermediate",
  Automation_advanced = "Automation_advanced",
  Automation_trending = "Automation_trending",
  Automation_sample_cart = "Automation_sample_cart",
  Automation_sample_cart_description = "Automation_sample_cart_description",
  Automation_sample_language = "Automation_sample_language",
  Automation_sample_language_description = "Automation_sample_language_description",
  Automation_sample_support = "Automation_sample_support",
  Automation_sample_support_description = "Automation_sample_support_description",
  Automation_sample_welcome = "Automation_sample_welcome",
  Automation_sample_welcome_description = "Automation_sample_welcome_description",
  Automation_flow_history = "Automation_flow_history",
  Automation_ai_history = "Automation_ai_history",
  Automation_loaded_count = "Automation_loaded_count",
  Automation_sort_newest = "Automation_sort_newest",
  Automation_sort_oldest = "Automation_sort_oldest",
  Automation_sort_title = "Automation_sort_title",
  Automation_connected_posts = "Automation_connected_posts",
  Automation_not_connected = "Automation_not_connected",
  Automation_connections_access = "Automation_connections_access",
  Automation_checking_connections = "Automation_checking_connections",
  Automation_connections_retry = "Automation_connections_retry",
  //*️⃣0️⃣1️⃣2️⃣3️⃣4️⃣5️⃣6️⃣7️⃣8️⃣9️⃣🔟
  // #region 0️⃣ General Section
  // #region landing page
  toggleShowAll = "toggleShowAll",
  toggleShowmonthly = "toggleShowmonthly",
  unpin = "unpin",
  pin = "pin",
  quantity = "quantity",
  allquantity = "allquantity",
  remainingquantity = "remainingquantity",
  Connecting = "Connecting",
  Connected = "Connected",
  EmailNotification = "EmailNotification",
  EmailNotificationExplain = "EmailNotificationExplain",
  MobileNotification = "MobileNotification",
  MobileNotificationExplain = "MobileNotificationExplain",
  loading = "loading",
  menu = "menu",
  daysAgo = "daysAgo",
  hoursAgo = "hoursAgo",
  minutesAgo = "minutesAgo",
  justNow = "justNow",
  services = "services",
  markets = "markets",
  Lottery = "Lottery",
  pricing = "pricing",
  how = "how",
  unselect = "unselect",
  // #region  landing page
  shopper = "shopper",
  advertiser = "advertiser",
  influencer = "influencer",
  onlinestore = "onlinestore",
  onlinestoreExplain = "onlinestoreExplain",
  influencerExplain = "influencerExplain",
  freedays = "freedays",
  freedaysExplain = "freedaysExplain",
  skip = "skip",
  instagramerplanactive = "instagramerplanactive",
  influencerplanactive = "influencerplanactive",
  onlinestoreplanactive = "onlinestoreplanactive",
  skipfornow = "skipfornow",
  welcomeToBrancy = "welcomeToBrancy",
  welcomeToBrancyExplain = "welcomeToBrancyExplain",
  notloginexplain = "notloginexplain",
  instagramTutorialTitle = "instagramTutorialTitle",
  instagramTutorialStep1Title = "instagramTutorialStep1Title",
  instagramTutorialStep1Text = "instagramTutorialStep1Text",
  instagramTutorialStep2Title = "instagramTutorialStep2Title",
  instagramTutorialStep2Text = "instagramTutorialStep2Text",
  understood = "understood",
  previous = "previous",
  welcomeToBrancyExplainPhone = "welcomeToBrancyExplainPhone",
  loginWithGoogle = "loginWithGoogle",
  loginWithMobile = "loginWithMobile",
  or = "or",
  InstagramID = "InstagramID",
  EmptyNotification = "EmptyNotification",
  Notification_NewMessage = "Notification_NewMessage",
  Notification_NewOrder = "Notification_NewOrder",
  Notification_ImagesCreatedBy = "Notification_ImagesCreatedBy",
  Notification_VideoCreatedBy = "Notification_VideoCreatedBy",
  Notification_MediaCreationFailed = "Notification_MediaCreationFailed",
  Notification_VideoCreationFailed = "Notification_VideoCreationFailed",
  Notification_NewPost = "Notification_NewPost",
  Notification_UploadPostFailed = "Notification_UploadPostFailed",
  Notification_NewStory = "Notification_NewStory",
  Notification_UploadStoryFailed = "Notification_UploadStoryFailed",
  Notification_NewVideo = "Notification_NewVideo",
  Notification_VideoCreationFailedTitle = "Notification_VideoCreationFailedTitle",
  Notification_YouHaveNewMessage = "Notification_YouHaveNewMessage",
  Notification_AccountDeauthorized = "Notification_AccountDeauthorized",
  EnterYourText = "EnterYourText",
  EnterYourphonenumber = "EnterYourphonenumber",
  CopyText = "CopyText",
  successfulCopy = "successfulCopy",
  download = "download",
  automatic = "automatic",
  manual = "manual",
  phonenumber = "phonenumber",
  SendVerificationCode = "SendVerificationCode",
  ShowUserDashboard = "ShowUserDashboard",
  VerificationCode = "VerificationCode",
  VerificationCodeExplain = "VerificationCodeExplain",
  remainingTime = "remainingTime",
  ResendVerificationCode = "ResendVerificationCode",
  Verify = "Verify",
  VerifyAddress = "VerifyAddress",
  VerifyCode = "VerifyCode",
  Continue = "Continue",
  metaRedirect_aiAnalysisNotice = "metaRedirect_aiAnalysisNotice",
  Efficiency = "Efficiency",
  logout = "logout",
  notallowed = "notallowed",
  notallowedExplain = "notallowedExplain",
  notallowedExplainPage = "notallowedExplainPage",
  max = "max",
  logoutExplain = "logoutExplain",
  sending = "sending",
  uploadsRemaining = "uploadsRemaining",
  inSystem = "inSystem",
  color = "color",
  button = "button",
  Liter = "Liter",
  FrontFace = "FrontFace",
  SideFace = "SideFace",
  TopFace = "TopFace",
  Area = "Area",
  Perimeter = "Perimeter",
  Volume = "Volume",
  reject = "reject",
  rejected = "rejected",
  approved = "approved",
  ExpirationTime = "ExpirationTime",
  send = "send",
  accept = "accept",
  needPass = "needPass",
  selectall = "selectall",
  General = "General",
  Business = "Business",
  needPassExplain = "needPassExplain",
  soon = "soon",
  soonExplain = "soonExplain",
  underdevelop = "underdevelop",
  total = "total",
  Unknown = "Unknown",
  close = "close",
  installPromptMessage = "installPromptMessage",
  install = "install",
  installStep1 = "installStep1",
  installStep2 = "installStep2",
  installStep3 = "installStep3",
  closed = "closed",

  admin = "admin",
  user = "user",
  stop = "stop",
  save = "save",
  discard = "discard",
  back = "back",
  dismiss = "dismiss",
  empty = "empty",
  select = "select",
  next = "next",
  cancel = "cancel",
  usethisPrompt = "usethisPrompt",
  canceled = "canceled",
  like = "like",
  dislike = "dislike",
  comment = "comment",
  mention = "mention",
  add = "add",
  start = "start",
  country = "country",
  device = "device",
  yourdevice = "yourdevice",
  otherdevice = "otherdevice",
  SessionID = "SessionID",
  header = "header",
  upload = "upload",
  active = "active",
  deactive = "deactive",
  activate = "activate",
  Deactivate = "Deactivate",
  activateAll = "activateAll",
  DeactivateAll = "DeactivateAll",
  signout = "signout",
  switchaccount = "switchaccount",
  instagramConnect = "instagramConnect",
  upgrade = "upgrade",
  Renew_Subscription = "Renew_Subscription",
  done = "done",
  text = "text",
  PlaceHolder = "PlaceHolder",
  media = "media",
  ReplyStory = "ReplyStory",
  photo = "photo",
  audio = "audio",
  Generic = "Generic",
  StoryMention = "StoryMention",
  FileShare = "FileShare",
  voice = "voice",

  abort = "abort",
  Pending = "Pending",
  Preparing = "Preparing",
  Finished = "Finished",
  finish = "finish",
  searchMessage = "searchMessage",
  searchKeyword = "searchKeyword",
  search = "search",
  searchLocation = "searchLocation",
  searchPeople = "searchPeople",
  edit = "edit",
  delete = "delete",
  deletecover = "deletecover",
  exportJPG = "exportJPG",
  exportPDF = "exportPDF",
  exportXlxs = "exportXlxs",
  shareStory = "shareStory",
  details = "details",
  Insights = "Insights",
  priceHistory = "priceHistory",
  new = "new",
  comments = "comments",
  nocomment = "nocomment",
  SimilarProducts = "SimilarProducts",
  QandA = "QandA",
  caption = "caption",
  collaborator = "collaborator",
  collaboratorpost = "collaboratorpost",
  ExportPDF = "ExportPDF",
  ExportJPG = "ExportJPG",
  ShareTo = "ShareTo",
  Expand = "Expand",
  message = "message",
  icon = "icon",
  reply = "reply",
  replies = "replies",
  PrivateReply = "PrivateReply",
  copy = "copy",
  everywhere = "everywhere",
  UnHide = "UnHide",
  show = "show",
  Hide = "Hide",
  Ignore = "Ignore",
  Orange = "Orange",
  Purple = "Purple",
  Green = "Green",
  White = "White",
  DarkGray = "DarkGray",
  Blue = "Blue",
  LightGray = "LightGray",
  Brown = "Brown",
  Pink = "Pink",
  Yellow = "Yellow",
  Silver = "Silver",
  Black = "Black",
  Red = "Red",
  CollaboratorExplain = "CollaboratorExplain",
  CreateAutomationFlow = "CreateAutomationFlow",
  CreateAutomationFlowExplain = "CreateAutomationFlowExplain",
  CreateAutomationAI = "CreateAutomationAI",
  CreateAutomationAIExplain = "CreateAutomationAIExplain",
  ConnectProduct = "ConnectProduct",
  flowProperties_notworking_privateReply = "flowProperties_notworking_privateReply",
  flowProperties_privateReply_requiresFollower = "flowProperties_privateReply_requiresFollower",
  //0️⃣ General -> sidebar
  sidebar_Home = "sidebar_Home",
  sidebar_Page = "sidebar_Page",
  sidebar_Message = "sidebar_Message",
  sidebar_Wallet = "sidebar_Wallet",
  sidebar_biolink = "sidebar_biolink",
  sidebar_Advertise = "sidebar_Advertise",
  sidebar_Store = "sidebar_Store",
  sidebar_Stores = "sidebar_Stores",
  sidebar_Business = "sidebar_Business",
  sidebar_Setting = "sidebar_Setting",
  //0️⃣ General -> navbar

  navbar_Post = "navbar_Post",
  navbar_Live = "navbar_Live",
  navbar_Story = "navbar_Story",
  navbar_Feed = "navbar_Feed",
  navbar_Reels = "navbar_Reels",
  navbar_Statistics = "navbar_Statistics",
  navbarTools = "navbarTools",
  navbar_Direct = "navbar_Direct",
  navbar_Comments = "navbar_Comments",
  navbar_Ticket = "navbar_Ticket",
  navbar_AI = "navbar_AI",
  navbar_ContentCreator = "navbar_ContentCreator",
  navbar_Payment = "navbar_Payment",
  navbar_Title = "navbar_Title",
  navbar_Home = "navbar_Home",
  navbar_Biolink = "navbar_Biolink",
  navbar_Properties = "navbar_Properties",
  navbar_AIAndFlow = "navbar_AIAndFlow",
  navbar_Calendar = "navbar_Calendar",
  navbar_AdList = "navbar_AdList",
  navbar_General = "navbar_General",
  navbar_SubAdmin = "navbar_SubAdmin",
  navbar_Products = "navbar_Products",
  navbar_Orders = "navbar_Orders",
  navbar_totalOrders = "navbar_totalOrders",
  navbar_HelpCenter = "navbar_HelpCenter",
  //0️⃣ countdown
  ago = "ago",
  countdown_Days = "countdown_Days",
  countdown_Hours = "countdown_Hours",
  countdown_Minutes = "countdown_Minutes",
  Expired = "Expired",
  justnow = "justnow",
  LessThanAMinute = "LessThanAMinute",
  ExpiresIn = "ExpiresIn",
  all = "all",
  // #endregion General Section
  // #region 1️⃣home Section
  // 1️⃣ Home -> cards
  home_FollowRequest = "home_FollowRequest",
  home_UnreadNewComments = "home_UnreadNewComments",
  home_Last24H = "home_Last24H",
  home_Last30Days = "home_Last30Days",
  home_LastLikes = "home_LastLikes",
  home_LastPost = "home_LastPost",
  home_Followings = "home_Followings",
  home_Followers = "home_Followers",
  AudienceGender = "AudienceGender",
  AudienceGenderStats = "AudienceGenderStats",
  AudienceAge = "AudienceAge",
  AudienceAgeStats = "AudienceAgeStats",
  AgeCategoryYoung = "AgeCategoryYoung",
  AgeCategoryMiddleAged = "AgeCategoryMiddleAged",
  AgeCategoryOlder = "AgeCategoryOlder",
  AudienceLocation = "AudienceLocation",
  AudienceLocationStats = "AudienceLocationStats",
  // 1️⃣ Home -> last like
  lastLike = "lastLike",
  // 1️⃣ Home -> last message
  lastMessage = "lastMessage",
  lastOrder = "lastOrder",
  lastTransaction = "lastTransaction",
  // 1️⃣ Home -> last follower
  LastFollowers = "LastFollowers",
  // #endregion home Section
  // #region 2️⃣Page Section
  // 1️⃣ Page -> Post
  NewScheduledPost = "NewScheduledPost",
  ScheduledPost = "ScheduledPost",
  thereAreNoPost = "thereAreNoPost",
  PostDraft = "PostDraft",
  StoryDraft = "StoryDraft",
  publishError = "publishError",
  DeletedPost = "DeletedPost",
  CreateNewPost = "CreateNewPost",
  CreateNewStrory = "CreateNewStrory",
  errorDraft_title = "errorDraft_title",
  errorDraft_configFailed = "errorDraft_configFailed",
  errorDraft_invalidTags = "errorDraft_invalidTags",
  errorDraft_unknown = "errorDraft_unknown",
  errorDraft_uploadError = "errorDraft_uploadError",
  errorDraft_userCancel = "errorDraft_userCancel",

  InvalidAspectRatio = "InvalidAspectRatio",
  SizeLimitExceed = "SizeLimitExceed",
  UnSupportMediaType = "UnSupportMediaType",
  NotPublishedAtTheTime = "NotPublishedAtTheTime",
  NotSuccessLogin = "NotSuccessLogin",

  // 2️⃣ Page -> story
  pageStory_CreateNewStory = "pageStory_CreateNewStory",
  pageStory_CreateNewStories = "pageStory_CreateNewStories",
  pageStory_ScheduledStories = "pageStory_ScheduledStories",
  pageStory_thereAreNoStories = "pageStory_thereAreNoStories",
  pageStory_highlightManagement = "pageStory_highlightManagement",
  pageStory_thereAreNoHighlight = "pageStory_thereAreNoHighlight",
  pageStory_HighlightTitle = "pageStory_HighlightTitle",
  // 3️⃣ Page -> statistics
  pageStatistics_YourBestFollowers = "pageStatistics_YourBestFollowers",
  pageStatistics_YourBestFollowersExplain = "pageStatistics_YourBestFollowersExplain",
  pageStatistics_LoadMore = "pageStatistics_LoadMore",
  pageStatistics_UnFollowers = "pageStatistics_UnFollowers",
  pageStatistics_Followers = "pageStatistics_Followers",
  pageStatistics_NewFollowers = "pageStatistics_NewFollowers",
  pageStatistics_ActiveFollowers = "pageStatistics_ActiveFollowers",
  pageStatistics_MediaFollows = "pageStatistics_MediaFollows",
  pageStatistics_Reach = "pageStatistics_Reach",
  pageStatistics_ProfileVisit = "pageStatistics_ProfileVisit",
  pageStatistics_30Days = "pageStatistics_30Days",
  pageStatistics_60Days = "pageStatistics_60Days",
  pageStatistics_90Days = "pageStatistics_90Days",
  pageStatistics_120Days = "pageStatistics_120Days",
  pageStatistics_BestTime = "pageStatistics_BestTime",
  pageStatistics_WorstTime = "pageStatistics_WorstTime",
  pageStatistics_likes = "pageStatistics_likes",
  pageStatistics_Impression = "pageStatistics_Impression",
  pageStatistics_Engagements = "pageStatistics_Engagements",
  pageStatistics_Views = "pageStatistics_Views",
  pageStatistics_RePosts = "pageStatistics_RePosts",
  pageStatistics_followerViews = "pageStatistics_followerViews",
  pageStatistics_ghostViewers = "pageStatistics_ghostViewers",
  pageStatistics_Comments = "pageStatistics_Comments",
  pageStatistics_Shares = "pageStatistics_Shares",
  pageStatistics_Engagement = "pageStatistics_Engagement",
  pageStatistics_summary = "pageStatistics_summary",
  pageStatistics_EmptyList = "pageStatistics_EmptyList",
  pageStatistics_from = "pageStatistics_from",
  pageStatistics_post = "pageStatistics_post",
  pageStatistics_stories = "pageStatistics_stories",
  pageStatistics_MaxView = "pageStatistics_MaxView",
  pageStatistics_MinView = "pageStatistics_MinView",
  pageStatistics_MaxCommentLike = "pageStatistics_MaxCommentLike",
  pageStatistics_MinCommentLike = "pageStatistics_MinCommentLike",
  pageStatistics_PostTimeAnalysis = "pageStatistics_PostTimeAnalysis",
  pageStatistics_Rate = "pageStatistics_Rate",
  pageStatistics_RateExplain = "pageStatistics_RateExplain",
  pageStatistics_24HourHeatmap = "pageStatistics_24HourHeatmap",
  pageStatistics_Low = "pageStatistics_Low",
  pageStatistics_High = "pageStatistics_High",
  pageStatistics_TopHour = "pageStatistics_TopHour",
  pageStatistics_WeakHour = "pageStatistics_WeakHour",
  pageStatistics_AverageHour = "pageStatistics_AverageHour",
  pageStatistics_TopMinute = "pageStatistics_TopMinute",
  pageStatistics_WeakMinute = "pageStatistics_WeakMinute",
  pageStatistics_AverageMinute = "pageStatistics_AverageMinute",
  pageStatistics_HourExcellentLevel = "pageStatistics_HourExcellentLevel",
  pageStatistics_HourGoodLevel = "pageStatistics_HourGoodLevel",
  pageStatistics_HourAverageLevel = "pageStatistics_HourAverageLevel",
  pageStatistics_HourWeakLevel = "pageStatistics_HourWeakLevel",
  pageStatistics_HourVeryWeakLevel = "pageStatistics_HourVeryWeakLevel",
  pageStatistics_MinuteTopDescription = "pageStatistics_MinuteTopDescription",
  pageStatistics_MinuteWeakDescription = "pageStatistics_MinuteWeakDescription",
  pageStatistics_MinuteAverageDescription = "pageStatistics_MinuteAverageDescription",
  pageStatistics_PeakEngagement = "pageStatistics_PeakEngagement",
  pageStatistics_StableGrowth = "pageStatistics_StableGrowth",
  pageStatistics_HighEngagementProbability = "pageStatistics_HighEngagementProbability",
  pageStatistics_LowestEngagement = "pageStatistics_LowestEngagement",
  pageStatistics_SustainedLowPeriod = "pageStatistics_SustainedLowPeriod",
  pageStatistics_LowEngagementProbability = "pageStatistics_LowEngagementProbability",
  pageStatistics_BestTimes = "pageStatistics_BestTimes",
  pageStatistics_WorstTimes = "pageStatistics_WorstTimes",
  pageStatistics_EngagementPrediction = "pageStatistics_EngagementPrediction",
  pageStatistics_PeakTimeDescription = "pageStatistics_PeakTimeDescription",
  pageStatistics_StableTimeDescription = "pageStatistics_StableTimeDescription",
  pageStatistics_SecondaryTimeDescription = "pageStatistics_SecondaryTimeDescription",
  pageStatistics_LowestTimeDescription = "pageStatistics_LowestTimeDescription",
  pageStatistics_SustainedLowTimeDescription = "pageStatistics_SustainedLowTimeDescription",
  pageStatistics_SecondaryLowTimeDescription = "pageStatistics_SecondaryLowTimeDescription",
  pageStatistics_HourEngagementTooltip = "pageStatistics_HourEngagementTooltip",
  pageStatistics_MinuteEngagementTooltip = "pageStatistics_MinuteEngagementTooltip",
  // statistics suggestion box
  Statistics_UnFollowers_up_title = "Statistics_UnFollowers_up_title",
  Statistics_UnFollowers_up_summary = "Statistics_UnFollowers_up_summary",
  Statistics_UnFollowers_up_action1 = "Statistics_UnFollowers_up_action1",
  Statistics_UnFollowers_up_action2 = "Statistics_UnFollowers_up_action2",
  Statistics_UnFollowers_up_action3 = "Statistics_UnFollowers_up_action3",
  Statistics_UnFollowers_up_urgency = "Statistics_UnFollowers_up_urgency",
  Statistics_UnFollowers_neutral_title = "Statistics_UnFollowers_neutral_title",
  Statistics_UnFollowers_neutral_summary = "Statistics_UnFollowers_neutral_summary",
  Statistics_UnFollowers_neutral_action1 = "Statistics_UnFollowers_neutral_action1",
  Statistics_UnFollowers_neutral_action2 = "Statistics_UnFollowers_neutral_action2",
  Statistics_UnFollowers_neutral_action3 = "Statistics_UnFollowers_neutral_action3",
  Statistics_UnFollowers_neutral_urgency = "Statistics_UnFollowers_neutral_urgency",
  Statistics_UnFollowers_down_title = "Statistics_UnFollowers_down_title",
  Statistics_UnFollowers_down_summary = "Statistics_UnFollowers_down_summary",
  Statistics_UnFollowers_down_action1 = "Statistics_UnFollowers_down_action1",
  Statistics_UnFollowers_down_action2 = "Statistics_UnFollowers_down_action2",
  Statistics_UnFollowers_down_action3 = "Statistics_UnFollowers_down_action3",
  Statistics_UnFollowers_down_urgency = "Statistics_UnFollowers_down_urgency",
  Statistics_UnFollowers_zero_title = "Statistics_UnFollowers_zero_title",
  Statistics_UnFollowers_zero_summary = "Statistics_UnFollowers_zero_summary",
  Statistics_UnFollowers_zero_action1 = "Statistics_UnFollowers_zero_action1",
  Statistics_UnFollowers_zero_action2 = "Statistics_UnFollowers_zero_action2",
  Statistics_UnFollowers_zero_action3 = "Statistics_UnFollowers_zero_action3",
  Statistics_UnFollowers_zero_urgency = "Statistics_UnFollowers_zero_urgency",
  Statistics_Followers_up_title = "Statistics_Followers_up_title",
  Statistics_Followers_up_summary = "Statistics_Followers_up_summary",
  Statistics_Followers_up_action1 = "Statistics_Followers_up_action1",
  Statistics_Followers_up_action2 = "Statistics_Followers_up_action2",
  Statistics_Followers_up_action3 = "Statistics_Followers_up_action3",
  Statistics_Followers_up_urgency = "Statistics_Followers_up_urgency",
  Statistics_Followers_neutral_title = "Statistics_Followers_neutral_title",
  Statistics_Followers_neutral_summary = "Statistics_Followers_neutral_summary",
  Statistics_Followers_neutral_action1 = "Statistics_Followers_neutral_action1",
  Statistics_Followers_neutral_action2 = "Statistics_Followers_neutral_action2",
  Statistics_Followers_neutral_action3 = "Statistics_Followers_neutral_action3",
  Statistics_Followers_neutral_urgency = "Statistics_Followers_neutral_urgency",
  Statistics_Followers_down_title = "Statistics_Followers_down_title",
  Statistics_Followers_down_summary = "Statistics_Followers_down_summary",
  Statistics_Followers_down_action1 = "Statistics_Followers_down_action1",
  Statistics_Followers_down_action2 = "Statistics_Followers_down_action2",
  Statistics_Followers_down_action3 = "Statistics_Followers_down_action3",
  Statistics_Followers_down_urgency = "Statistics_Followers_down_urgency",
  Statistics_Followers_zero_title = "Statistics_Followers_zero_title",
  Statistics_Followers_zero_summary = "Statistics_Followers_zero_summary",
  Statistics_Followers_zero_action1 = "Statistics_Followers_zero_action1",
  Statistics_Followers_zero_action2 = "Statistics_Followers_zero_action2",
  Statistics_Followers_zero_action3 = "Statistics_Followers_zero_action3",
  Statistics_Followers_zero_urgency = "Statistics_Followers_zero_urgency",
  Statistics_MediaFollows_up_title = "Statistics_MediaFollows_up_title",
  Statistics_MediaFollows_up_summary = "Statistics_MediaFollows_up_summary",
  Statistics_MediaFollows_up_action1 = "Statistics_MediaFollows_up_action1",
  Statistics_MediaFollows_up_action2 = "Statistics_MediaFollows_up_action2",
  Statistics_MediaFollows_up_action3 = "Statistics_MediaFollows_up_action3",
  Statistics_MediaFollows_up_urgency = "Statistics_MediaFollows_up_urgency",
  Statistics_MediaFollows_neutral_title = "Statistics_MediaFollows_neutral_title",
  Statistics_MediaFollows_neutral_summary = "Statistics_MediaFollows_neutral_summary",
  Statistics_MediaFollows_neutral_action1 = "Statistics_MediaFollows_neutral_action1",
  Statistics_MediaFollows_neutral_action2 = "Statistics_MediaFollows_neutral_action2",
  Statistics_MediaFollows_neutral_action3 = "Statistics_MediaFollows_neutral_action3",
  Statistics_MediaFollows_neutral_urgency = "Statistics_MediaFollows_neutral_urgency",
  Statistics_MediaFollows_down_title = "Statistics_MediaFollows_down_title",
  Statistics_MediaFollows_down_summary = "Statistics_MediaFollows_down_summary",
  Statistics_MediaFollows_down_action1 = "Statistics_MediaFollows_down_action1",
  Statistics_MediaFollows_down_action2 = "Statistics_MediaFollows_down_action2",
  Statistics_MediaFollows_down_action3 = "Statistics_MediaFollows_down_action3",
  Statistics_MediaFollows_down_urgency = "Statistics_MediaFollows_down_urgency",
  Statistics_MediaFollows_zero_title = "Statistics_MediaFollows_zero_title",
  Statistics_MediaFollows_zero_summary = "Statistics_MediaFollows_zero_summary",
  Statistics_MediaFollows_zero_action1 = "Statistics_MediaFollows_zero_action1",
  Statistics_MediaFollows_zero_action2 = "Statistics_MediaFollows_zero_action2",
  Statistics_MediaFollows_zero_action3 = "Statistics_MediaFollows_zero_action3",
  Statistics_MediaFollows_zero_urgency = "Statistics_MediaFollows_zero_urgency",
  Statistics_Reach_up_title = "Statistics_Reach_up_title",
  Statistics_Reach_up_summary = "Statistics_Reach_up_summary",
  Statistics_Reach_up_action_1 = "Statistics_Reach_up_action_1",
  Statistics_Reach_up_action_2 = "Statistics_Reach_up_action_2",
  Statistics_Reach_up_action_3 = "Statistics_Reach_up_action_3",
  Statistics_Reach_up_urgency = "Statistics_Reach_up_urgency",
  Statistics_Reach_neutral_title = "Statistics_Reach_neutral_title",
  Statistics_Reach_neutral_summary = "Statistics_Reach_neutral_summary",
  Statistics_Reach_neutral_action_1 = "Statistics_Reach_neutral_action_1",
  Statistics_Reach_neutral_action_2 = "Statistics_Reach_neutral_action_2",
  Statistics_Reach_neutral_action_3 = "Statistics_Reach_neutral_action_3",
  Statistics_Reach_neutral_urgency = "Statistics_Reach_neutral_urgency",
  Statistics_Reach_down_title = "Statistics_Reach_down_title",
  Statistics_Reach_down_summary = "Statistics_Reach_down_summary",
  Statistics_Reach_down_action_1 = "Statistics_Reach_down_action_1",
  Statistics_Reach_down_action_2 = "Statistics_Reach_down_action_2",
  Statistics_Reach_down_action_3 = "Statistics_Reach_down_action_3",
  Statistics_Reach_down_urgency = "Statistics_Reach_down_urgency",
  Statistics_Reach_zero_title = "Statistics_Reach_zero_title",
  Statistics_Reach_zero_summary = "Statistics_Reach_zero_summary",
  Statistics_Reach_zero_action_1 = "Statistics_Reach_zero_action_1",
  Statistics_Reach_zero_action_2 = "Statistics_Reach_zero_action_2",
  Statistics_Reach_zero_action_3 = "Statistics_Reach_zero_action_3",
  Statistics_Reach_zero_urgency = "Statistics_Reach_zero_urgency",
  Statistics_ProfileVisit_up_title = "Statistics_ProfileVisit_up_title",
  Statistics_ProfileVisit_up_summary = "Statistics_ProfileVisit_up_summary",
  Statistics_ProfileVisit_up_action_1 = "Statistics_ProfileVisit_up_action_1",
  Statistics_ProfileVisit_up_action_2 = "Statistics_ProfileVisit_up_action_2",
  Statistics_ProfileVisit_up_action_3 = "Statistics_ProfileVisit_up_action_3",
  Statistics_ProfileVisit_up_urgency = "Statistics_ProfileVisit_up_urgency",
  Statistics_ProfileVisit_neutral_title = "Statistics_ProfileVisit_neutral_title",
  Statistics_ProfileVisit_neutral_summary = "Statistics_ProfileVisit_neutral_summary",
  Statistics_ProfileVisit_neutral_action_1 = "Statistics_ProfileVisit_neutral_action_1",
  Statistics_ProfileVisit_neutral_action_2 = "Statistics_ProfileVisit_neutral_action_2",
  Statistics_ProfileVisit_neutral_action_3 = "Statistics_ProfileVisit_neutral_action_3",
  Statistics_ProfileVisit_neutral_urgency = "Statistics_ProfileVisit_neutral_urgency",
  Statistics_ProfileVisit_down_title = "Statistics_ProfileVisit_down_title",
  Statistics_ProfileVisit_down_summary = "Statistics_ProfileVisit_down_summary",
  Statistics_ProfileVisit_down_action_1 = "Statistics_ProfileVisit_down_action_1",
  Statistics_ProfileVisit_down_action_2 = "Statistics_ProfileVisit_down_action_2",
  Statistics_ProfileVisit_down_action_3 = "Statistics_ProfileVisit_down_action_3",
  Statistics_ProfileVisit_down_urgency = "Statistics_ProfileVisit_down_urgency",
  Statistics_ProfileVisit_zero_title = "Statistics_ProfileVisit_zero_title",
  Statistics_ProfileVisit_zero_summary = "Statistics_ProfileVisit_zero_summary",
  Statistics_ProfileVisit_zero_action_1 = "Statistics_ProfileVisit_zero_action_1",
  Statistics_ProfileVisit_zero_action_2 = "Statistics_ProfileVisit_zero_action_2",
  Statistics_ProfileVisit_zero_action_3 = "Statistics_ProfileVisit_zero_action_3",
  Statistics_ProfileVisit_zero_urgency = "Statistics_ProfileVisit_zero_urgency",
  Statistics_Likes_up_title = "Statistics_Likes_up_title",
  Statistics_Likes_up_summary = "Statistics_Likes_up_summary",
  Statistics_Likes_up_action_1 = "Statistics_Likes_up_action_1",
  Statistics_Likes_up_action_2 = "Statistics_Likes_up_action_2",
  Statistics_Likes_up_action_3 = "Statistics_Likes_up_action_3",
  Statistics_Likes_up_urgency = "Statistics_Likes_up_urgency",
  Statistics_Likes_neutral_title = "Statistics_Likes_neutral_title",
  Statistics_Likes_neutral_summary = "Statistics_Likes_neutral_summary",
  Statistics_Likes_neutral_action_1 = "Statistics_Likes_neutral_action_1",
  Statistics_Likes_neutral_action_2 = "Statistics_Likes_neutral_action_2",
  Statistics_Likes_neutral_action_3 = "Statistics_Likes_neutral_action_3",
  Statistics_Likes_neutral_urgency = "Statistics_Likes_neutral_urgency",
  Statistics_Likes_down_title = "Statistics_Likes_down_title",
  Statistics_Likes_down_summary = "Statistics_Likes_down_summary",
  Statistics_Likes_down_action_1 = "Statistics_Likes_down_action_1",
  Statistics_Likes_down_action_2 = "Statistics_Likes_down_action_2",
  Statistics_Likes_down_action_3 = "Statistics_Likes_down_action_3",
  Statistics_Likes_down_urgency = "Statistics_Likes_down_urgency",
  Statistics_Likes_zero_title = "Statistics_Likes_zero_title",
  Statistics_Likes_zero_summary = "Statistics_Likes_zero_summary",
  Statistics_Likes_zero_action_1 = "Statistics_Likes_zero_action_1",
  Statistics_Likes_zero_action_2 = "Statistics_Likes_zero_action_2",
  Statistics_Likes_zero_action_3 = "Statistics_Likes_zero_action_3",
  Statistics_Likes_zero_urgency = "Statistics_Likes_zero_urgency",
  Statistics_Comments_up_title = "Statistics_Comments_up_title",
  Statistics_Comments_up_summary = "Statistics_Comments_up_summary",
  Statistics_Comments_up_action1 = "Statistics_Comments_up_action1",
  Statistics_Comments_up_action2 = "Statistics_Comments_up_action2",
  Statistics_Comments_up_action3 = "Statistics_Comments_up_action3",
  Statistics_Comments_up_urgency = "Statistics_Comments_up_urgency",
  Statistics_Comments_neutral_title = "Statistics_Comments_neutral_title",
  Statistics_Comments_neutral_summary = "Statistics_Comments_neutral_summary",
  Statistics_Comments_neutral_action1 = "Statistics_Comments_neutral_action1",
  Statistics_Comments_neutral_action2 = "Statistics_Comments_neutral_action2",
  Statistics_Comments_neutral_action3 = "Statistics_Comments_neutral_action3",
  Statistics_Comments_neutral_urgency = "Statistics_Comments_neutral_urgency",
  Statistics_Comments_down_title = "Statistics_Comments_down_title",
  Statistics_Comments_down_summary = "Statistics_Comments_down_summary",
  Statistics_Comments_down_action1 = "Statistics_Comments_down_action1",
  Statistics_Comments_down_action2 = "Statistics_Comments_down_action2",
  Statistics_Comments_down_action3 = "Statistics_Comments_down_action3",
  Statistics_Comments_down_urgency = "Statistics_Comments_down_urgency",
  Statistics_Comments_zero_title = "Statistics_Comments_zero_title",
  Statistics_Comments_zero_summary = "Statistics_Comments_zero_summary",
  Statistics_Comments_zero_action1 = "Statistics_Comments_zero_action1",
  Statistics_Comments_zero_action2 = "Statistics_Comments_zero_action2",
  Statistics_Comments_zero_action3 = "Statistics_Comments_zero_action3",
  Statistics_Comments_zero_urgency = "Statistics_Comments_zero_urgency",
  Statistics_Views_up_title = "Statistics_Views_up_title",
  Statistics_Views_up_summary = "Statistics_Views_up_summary",
  Statistics_Views_up_action1 = "Statistics_Views_up_action1",
  Statistics_Views_up_action2 = "Statistics_Views_up_action2",
  Statistics_Views_up_action3 = "Statistics_Views_up_action3",
  Statistics_Views_up_urgency = "Statistics_Views_up_urgency",
  Statistics_Views_neutral_title = "Statistics_Views_neutral_title",
  Statistics_Views_neutral_summary = "Statistics_Views_neutral_summary",
  Statistics_Views_neutral_action1 = "Statistics_Views_neutral_action1",
  Statistics_Views_neutral_action2 = "Statistics_Views_neutral_action2",
  Statistics_Views_neutral_action3 = "Statistics_Views_neutral_action3",
  Statistics_Views_neutral_urgency = "Statistics_Views_neutral_urgency",
  Statistics_Views_down_title = "Statistics_Views_down_title",
  Statistics_Views_down_summary = "Statistics_Views_down_summary",
  Statistics_Views_down_action1 = "Statistics_Views_down_action1",
  Statistics_Views_down_action2 = "Statistics_Views_down_action2",
  Statistics_Views_down_action3 = "Statistics_Views_down_action3",
  Statistics_Views_down_urgency = "Statistics_Views_down_urgency",
  Statistics_Views_zero_title = "Statistics_Views_zero_title",
  Statistics_Views_zero_summary = "Statistics_Views_zero_summary",
  Statistics_Views_zero_action1 = "Statistics_Views_zero_action1",
  Statistics_Views_zero_action2 = "Statistics_Views_zero_action2",
  Statistics_Views_zero_action3 = "Statistics_Views_zero_action3",
  Statistics_Views_zero_urgency = "Statistics_Views_zero_urgency",
  Statistics_FollowerViews_up_title = "Statistics_FollowerViews_up_title",
  Statistics_FollowerViews_up_summary = "Statistics_FollowerViews_up_summary",
  Statistics_FollowerViews_up_action1 = "Statistics_FollowerViews_up_action1",
  Statistics_FollowerViews_up_action2 = "Statistics_FollowerViews_up_action2",
  Statistics_FollowerViews_up_action3 = "Statistics_FollowerViews_up_action3",
  Statistics_FollowerViews_up_urgency = "Statistics_FollowerViews_up_urgency",
  Statistics_FollowerViews_neutral_title = "Statistics_FollowerViews_neutral_title",
  Statistics_FollowerViews_neutral_summary = "Statistics_FollowerViews_neutral_summary",
  Statistics_FollowerViews_neutral_action1 = "Statistics_FollowerViews_neutral_action1",
  Statistics_FollowerViews_neutral_action2 = "Statistics_FollowerViews_neutral_action2",
  Statistics_FollowerViews_neutral_action3 = "Statistics_FollowerViews_neutral_action3",
  Statistics_FollowerViews_neutral_urgency = "Statistics_FollowerViews_neutral_urgency",
  Statistics_FollowerViews_down_title = "Statistics_FollowerViews_down_title",
  Statistics_FollowerViews_down_summary = "Statistics_FollowerViews_down_summary",
  Statistics_FollowerViews_down_action1 = "Statistics_FollowerViews_down_action1",
  Statistics_FollowerViews_down_action2 = "Statistics_FollowerViews_down_action2",
  Statistics_FollowerViews_down_action3 = "Statistics_FollowerViews_down_action3",
  Statistics_FollowerViews_down_urgency = "Statistics_FollowerViews_down_urgency",
  Statistics_FollowerViews_zero_title = "Statistics_FollowerViews_zero_title",
  Statistics_FollowerViews_zero_summary = "Statistics_FollowerViews_zero_summary",
  Statistics_FollowerViews_zero_action1 = "Statistics_FollowerViews_zero_action1",
  Statistics_FollowerViews_zero_action2 = "Statistics_FollowerViews_zero_action2",
  Statistics_FollowerViews_zero_action3 = "Statistics_FollowerViews_zero_action3",
  Statistics_FollowerViews_zero_urgency = "Statistics_FollowerViews_zero_urgency",
  Statistics_NonFollowerViews_up_title = "Statistics_NonFollowerViews_up_title",
  Statistics_NonFollowerViews_up_summary = "Statistics_NonFollowerViews_up_summary",
  Statistics_NonFollowerViews_up_action1 = "Statistics_NonFollowerViews_up_action1",
  Statistics_NonFollowerViews_up_action2 = "Statistics_NonFollowerViews_up_action2",
  Statistics_NonFollowerViews_up_action3 = "Statistics_NonFollowerViews_up_action3",
  Statistics_NonFollowerViews_up_urgency = "Statistics_NonFollowerViews_up_urgency",
  Statistics_NonFollowerViews_neutral_title = "Statistics_NonFollowerViews_neutral_title",
  Statistics_NonFollowerViews_neutral_summary = "Statistics_NonFollowerViews_neutral_summary",
  Statistics_NonFollowerViews_neutral_action1 = "Statistics_NonFollowerViews_neutral_action1",
  Statistics_NonFollowerViews_neutral_action2 = "Statistics_NonFollowerViews_neutral_action2",
  Statistics_NonFollowerViews_neutral_action3 = "Statistics_NonFollowerViews_neutral_action3",
  Statistics_NonFollowerViews_neutral_urgency = "Statistics_NonFollowerViews_neutral_urgency",
  Statistics_NonFollowerViews_down_title = "Statistics_NonFollowerViews_down_title",
  Statistics_NonFollowerViews_down_summary = "Statistics_NonFollowerViews_down_summary",
  Statistics_NonFollowerViews_down_action1 = "Statistics_NonFollowerViews_down_action1",
  Statistics_NonFollowerViews_down_action2 = "Statistics_NonFollowerViews_down_action2",
  Statistics_NonFollowerViews_down_action3 = "Statistics_NonFollowerViews_down_action3",
  Statistics_NonFollowerViews_down_urgency = "Statistics_NonFollowerViews_down_urgency",
  Statistics_NonFollowerViews_zero_title = "Statistics_NonFollowerViews_zero_title",
  Statistics_NonFollowerViews_zero_summary = "Statistics_NonFollowerViews_zero_summary",
  Statistics_NonFollowerViews_zero_action1 = "Statistics_NonFollowerViews_zero_action1",
  Statistics_NonFollowerViews_zero_action2 = "Statistics_NonFollowerViews_zero_action2",
  Statistics_NonFollowerViews_zero_action3 = "Statistics_NonFollowerViews_zero_action3",
  Statistics_NonFollowerViews_zero_urgency = "Statistics_NonFollowerViews_zero_urgency",
  Statistics_Shares_up_title = "Statistics_Shares_up_title",
  Statistics_Shares_up_summary = "Statistics_Shares_up_summary",
  Statistics_Shares_up_action1 = "Statistics_Shares_up_action1",
  Statistics_Shares_up_action2 = "Statistics_Shares_up_action2",
  Statistics_Shares_up_action3 = "Statistics_Shares_up_action3",
  Statistics_Shares_up_urgency = "Statistics_Shares_up_urgency",
  Statistics_Shares_neutral_title = "Statistics_Shares_neutral_title",
  Statistics_Shares_neutral_summary = "Statistics_Shares_neutral_summary",
  Statistics_Shares_neutral_action1 = "Statistics_Shares_neutral_action1",
  Statistics_Shares_neutral_action2 = "Statistics_Shares_neutral_action2",
  Statistics_Shares_neutral_action3 = "Statistics_Shares_neutral_action3",
  Statistics_Shares_neutral_urgency = "Statistics_Shares_neutral_urgency",
  Statistics_Shares_down_title = "Statistics_Shares_down_title",
  Statistics_Shares_down_summary = "Statistics_Shares_down_summary",
  Statistics_Shares_down_action1 = "Statistics_Shares_down_action1",
  Statistics_Shares_down_action2 = "Statistics_Shares_down_action2",
  Statistics_Shares_down_action3 = "Statistics_Shares_down_action3",
  Statistics_Shares_down_urgency = "Statistics_Shares_down_urgency",
  Statistics_Shares_zero_title = "Statistics_Shares_zero_title",
  Statistics_Shares_zero_summary = "Statistics_Shares_zero_summary",
  Statistics_Shares_zero_action1 = "Statistics_Shares_zero_action1",
  Statistics_Shares_zero_action2 = "Statistics_Shares_zero_action2",
  Statistics_Shares_zero_action3 = "Statistics_Shares_zero_action3",
  Statistics_Shares_zero_urgency = "Statistics_Shares_zero_urgency",
  Statistics_Engagement_up_title = "Statistics_Engagement_up_title",
  Statistics_Engagement_up_summary = "Statistics_Engagement_up_summary",
  Statistics_Engagement_up_action1 = "Statistics_Engagement_up_action1",
  Statistics_Engagement_up_action2 = "Statistics_Engagement_up_action2",
  Statistics_Engagement_up_action3 = "Statistics_Engagement_up_action3",
  Statistics_Engagement_up_urgency = "Statistics_Engagement_up_urgency",
  Statistics_Engagement_neutral_title = "Statistics_Engagement_neutral_title",
  Statistics_Engagement_neutral_summary = "Statistics_Engagement_neutral_summary",
  Statistics_Engagement_neutral_action1 = "Statistics_Engagement_neutral_action1",
  Statistics_Engagement_neutral_action2 = "Statistics_Engagement_neutral_action2",
  Statistics_Engagement_neutral_action3 = "Statistics_Engagement_neutral_action3",
  Statistics_Engagement_neutral_urgency = "Statistics_Engagement_neutral_urgency",
  Statistics_Engagement_down_title = "Statistics_Engagement_down_title",
  Statistics_Engagement_down_summary = "Statistics_Engagement_down_summary",
  Statistics_Engagement_down_action1 = "Statistics_Engagement_down_action1",
  Statistics_Engagement_down_action2 = "Statistics_Engagement_down_action2",
  Statistics_Engagement_down_action3 = "Statistics_Engagement_down_action3",
  Statistics_Engagement_down_urgency = "Statistics_Engagement_down_urgency",
  Statistics_Engagement_zero_title = "Statistics_Engagement_zero_title",
  Statistics_Engagement_zero_summary = "Statistics_Engagement_zero_summary",
  Statistics_Engagement_zero_action1 = "Statistics_Engagement_zero_action1",
  Statistics_Engagement_zero_action2 = "Statistics_Engagement_zero_action2",
  Statistics_Engagement_zero_action3 = "Statistics_Engagement_zero_action3",
  Statistics_Engagement_zero_urgency = "Statistics_Engagement_zero_urgency",
  Statistics_Replies_up_title = "Statistics_Replies_up_title",
  Statistics_Replies_up_summary = "Statistics_Replies_up_summary",
  Statistics_Replies_up_action_1 = "Statistics_Replies_up_action_1",
  Statistics_Replies_up_action_2 = "Statistics_Replies_up_action_2",
  Statistics_Replies_up_action_3 = "Statistics_Replies_up_action_3",
  Statistics_Replies_up_urgency = "Statistics_Replies_up_urgency",
  Statistics_Replies_neutral_title = "Statistics_Replies_neutral_title",
  Statistics_Replies_neutral_summary = "Statistics_Replies_neutral_summary",
  Statistics_Replies_neutral_action_1 = "Statistics_Replies_neutral_action_1",
  Statistics_Replies_neutral_action_2 = "Statistics_Replies_neutral_action_2",
  Statistics_Replies_neutral_action_3 = "Statistics_Replies_neutral_action_3",
  Statistics_Replies_neutral_urgency = "Statistics_Replies_neutral_urgency",
  Statistics_Replies_down_title = "Statistics_Replies_down_title",
  Statistics_Replies_down_summary = "Statistics_Replies_down_summary",
  Statistics_Replies_down_action_1 = "Statistics_Replies_down_action_1",
  Statistics_Replies_down_action_2 = "Statistics_Replies_down_action_2",
  Statistics_Replies_down_action_3 = "Statistics_Replies_down_action_3",
  Statistics_Replies_down_urgency = "Statistics_Replies_down_urgency",
  Statistics_Replies_zero_title = "Statistics_Replies_zero_title",
  Statistics_Replies_zero_summary = "Statistics_Replies_zero_summary",
  Statistics_Replies_zero_action_1 = "Statistics_Replies_zero_action_1",
  Statistics_Replies_zero_action_2 = "Statistics_Replies_zero_action_2",
  Statistics_Replies_zero_action_3 = "Statistics_Replies_zero_action_3",
  Statistics_Replies_zero_urgency = "Statistics_Replies_zero_urgency",
  Statistics_TotalTime_up_title = "Statistics_TotalTime_up_title",
  Statistics_TotalTime_up_summary = "Statistics_TotalTime_up_summary",
  Statistics_TotalTime_up_action_1 = "Statistics_TotalTime_up_action_1",
  Statistics_TotalTime_up_action_2 = "Statistics_TotalTime_up_action_2",
  Statistics_TotalTime_up_action_3 = "Statistics_TotalTime_up_action_3",
  Statistics_TotalTime_up_urgency = "Statistics_TotalTime_up_urgency",
  Statistics_TotalTime_neutral_title = "Statistics_TotalTime_neutral_title",
  Statistics_TotalTime_neutral_summary = "Statistics_TotalTime_neutral_summary",
  Statistics_TotalTime_neutral_action_1 = "Statistics_TotalTime_neutral_action_1",
  Statistics_TotalTime_neutral_action_2 = "Statistics_TotalTime_neutral_action_2",
  Statistics_TotalTime_neutral_action_3 = "Statistics_TotalTime_neutral_action_3",
  Statistics_TotalTime_neutral_urgency = "Statistics_TotalTime_neutral_urgency",
  Statistics_TotalTime_down_title = "Statistics_TotalTime_down_title",
  Statistics_TotalTime_down_summary = "Statistics_TotalTime_down_summary",
  Statistics_TotalTime_down_action_1 = "Statistics_TotalTime_down_action_1",
  Statistics_TotalTime_down_action_2 = "Statistics_TotalTime_down_action_2",
  Statistics_TotalTime_down_action_3 = "Statistics_TotalTime_down_action_3",
  Statistics_TotalTime_down_urgency = "Statistics_TotalTime_down_urgency",
  Statistics_TotalTime_zero_title = "Statistics_TotalTime_zero_title",
  Statistics_TotalTime_zero_summary = "Statistics_TotalTime_zero_summary",
  Statistics_TotalTime_zero_action_1 = "Statistics_TotalTime_zero_action_1",
  Statistics_TotalTime_zero_action_2 = "Statistics_TotalTime_zero_action_2",
  Statistics_TotalTime_zero_action_3 = "Statistics_TotalTime_zero_action_3",
  Statistics_TotalTime_zero_urgency = "Statistics_TotalTime_zero_urgency",
  Statistics_ReachMonth_up_title = "Statistics_ReachMonth_up_title",
  Statistics_ReachMonth_up_summary = "Statistics_ReachMonth_up_summary",
  Statistics_ReachMonth_up_action_1 = "Statistics_ReachMonth_up_action_1",
  Statistics_ReachMonth_up_action_2 = "Statistics_ReachMonth_up_action_2",
  Statistics_ReachMonth_up_action_3 = "Statistics_ReachMonth_up_action_3",
  Statistics_ReachMonth_up_urgency = "Statistics_ReachMonth_up_urgency",
  Statistics_ReachMonth_neutral_title = "Statistics_ReachMonth_neutral_title",
  Statistics_ReachMonth_neutral_summary = "Statistics_ReachMonth_neutral_summary",
  Statistics_ReachMonth_neutral_action_1 = "Statistics_ReachMonth_neutral_action_1",
  Statistics_ReachMonth_neutral_action_2 = "Statistics_ReachMonth_neutral_action_2",
  Statistics_ReachMonth_neutral_action_3 = "Statistics_ReachMonth_neutral_action_3",
  Statistics_ReachMonth_neutral_urgency = "Statistics_ReachMonth_neutral_urgency",
  Statistics_ReachMonth_down_title = "Statistics_ReachMonth_down_title",
  Statistics_ReachMonth_down_summary = "Statistics_ReachMonth_down_summary",
  Statistics_ReachMonth_down_action_1 = "Statistics_ReachMonth_down_action_1",
  Statistics_ReachMonth_down_action_2 = "Statistics_ReachMonth_down_action_2",
  Statistics_ReachMonth_down_action_3 = "Statistics_ReachMonth_down_action_3",
  Statistics_ReachMonth_down_urgency = "Statistics_ReachMonth_down_urgency",
  Statistics_ReachMonth_zero_title = "Statistics_ReachMonth_zero_title",
  Statistics_ReachMonth_zero_summary = "Statistics_ReachMonth_zero_summary",
  Statistics_ReachMonth_zero_action_1 = "Statistics_ReachMonth_zero_action_1",
  Statistics_ReachMonth_zero_action_2 = "Statistics_ReachMonth_zero_action_2",
  Statistics_ReachMonth_zero_action_3 = "Statistics_ReachMonth_zero_action_3",
  Statistics_ReachMonth_zero_urgency = "Statistics_ReachMonth_zero_urgency",
  Statistics_MonthEngagement_up_title = "Statistics_MonthEngagement_up_title",
  Statistics_MonthEngagement_up_summary = "Statistics_MonthEngagement_up_summary",
  Statistics_MonthEngagement_up_action_1 = "Statistics_MonthEngagement_up_action_1",
  Statistics_MonthEngagement_up_action_2 = "Statistics_MonthEngagement_up_action_2",
  Statistics_MonthEngagement_up_action_3 = "Statistics_MonthEngagement_up_action_3",
  Statistics_MonthEngagement_up_urgency = "Statistics_MonthEngagement_up_urgency",
  Statistics_MonthEngagement_neutral_title = "Statistics_MonthEngagement_neutral_title",
  Statistics_MonthEngagement_neutral_summary = "Statistics_MonthEngagement_neutral_summary",
  Statistics_MonthEngagement_neutral_action_1 = "Statistics_MonthEngagement_neutral_action_1",
  Statistics_MonthEngagement_neutral_action_2 = "Statistics_MonthEngagement_neutral_action_2",
  Statistics_MonthEngagement_neutral_action_3 = "Statistics_MonthEngagement_neutral_action_3",
  Statistics_MonthEngagement_neutral_urgency = "Statistics_MonthEngagement_neutral_urgency",
  Statistics_MonthEngagement_down_title = "Statistics_MonthEngagement_down_title",
  Statistics_MonthEngagement_down_summary = "Statistics_MonthEngagement_down_summary",
  Statistics_MonthEngagement_down_action_1 = "Statistics_MonthEngagement_down_action_1",
  Statistics_MonthEngagement_down_action_2 = "Statistics_MonthEngagement_down_action_2",
  Statistics_MonthEngagement_down_action_3 = "Statistics_MonthEngagement_down_action_3",
  Statistics_MonthEngagement_down_urgency = "Statistics_MonthEngagement_down_urgency",
  Statistics_MonthEngagement_zero_title = "Statistics_MonthEngagement_zero_title",
  Statistics_MonthEngagement_zero_summary = "Statistics_MonthEngagement_zero_summary",
  Statistics_MonthEngagement_zero_action_1 = "Statistics_MonthEngagement_zero_action_1",
  Statistics_MonthEngagement_zero_action_2 = "Statistics_MonthEngagement_zero_action_2",
  Statistics_MonthEngagement_zero_action_3 = "Statistics_MonthEngagement_zero_action_3",
  Statistics_MonthEngagement_zero_urgency = "Statistics_MonthEngagement_zero_urgency",
  Statistics_MonthView_up_title = "Statistics_MonthView_up_title",
  Statistics_MonthView_up_summary = "Statistics_MonthView_up_summary",
  Statistics_MonthView_up_action_1 = "Statistics_MonthView_up_action_1",
  Statistics_MonthView_up_action_2 = "Statistics_MonthView_up_action_2",
  Statistics_MonthView_up_action_3 = "Statistics_MonthView_up_action_3",
  Statistics_MonthView_up_urgency = "Statistics_MonthView_up_urgency",
  Statistics_MonthView_neutral_title = "Statistics_MonthView_neutral_title",
  Statistics_MonthView_neutral_summary = "Statistics_MonthView_neutral_summary",
  Statistics_MonthView_neutral_action_1 = "Statistics_MonthView_neutral_action_1",
  Statistics_MonthView_neutral_action_2 = "Statistics_MonthView_neutral_action_2",
  Statistics_MonthView_neutral_action_3 = "Statistics_MonthView_neutral_action_3",
  Statistics_MonthView_neutral_urgency = "Statistics_MonthView_neutral_urgency",
  Statistics_MonthView_down_title = "Statistics_MonthView_down_title",
  Statistics_MonthView_down_summary = "Statistics_MonthView_down_summary",
  Statistics_MonthView_down_action_1 = "Statistics_MonthView_down_action_1",
  Statistics_MonthView_down_action_2 = "Statistics_MonthView_down_action_2",
  Statistics_MonthView_down_action_3 = "Statistics_MonthView_down_action_3",
  Statistics_MonthView_down_urgency = "Statistics_MonthView_down_urgency",
  Statistics_MonthView_zero_title = "Statistics_MonthView_zero_title",
  Statistics_MonthView_zero_summary = "Statistics_MonthView_zero_summary",
  Statistics_MonthView_zero_action_1 = "Statistics_MonthView_zero_action_1",
  Statistics_MonthView_zero_action_2 = "Statistics_MonthView_zero_action_2",
  Statistics_MonthView_zero_action_3 = "Statistics_MonthView_zero_action_3",
  Statistics_MonthView_zero_urgency = "Statistics_MonthView_zero_urgency",
  Statistics_RePosts_up_title = "Statistics_RePosts_up_title",
  Statistics_RePosts_up_summary = "Statistics_RePosts_up_summary",
  Statistics_RePosts_up_action_1 = "Statistics_RePosts_up_action_1",
  Statistics_RePosts_up_action_2 = "Statistics_RePosts_up_action_2",
  Statistics_RePosts_up_action_3 = "Statistics_RePosts_up_action_3",
  Statistics_RePosts_up_urgency = "Statistics_RePosts_up_urgency",
  Statistics_RePosts_neutral_title = "Statistics_RePosts_neutral_title",
  Statistics_RePosts_neutral_summary = "Statistics_RePosts_neutral_summary",
  Statistics_RePosts_neutral_action_1 = "Statistics_RePosts_neutral_action_1",
  Statistics_RePosts_neutral_action_2 = "Statistics_RePosts_neutral_action_2",
  Statistics_RePosts_neutral_action_3 = "Statistics_RePosts_neutral_action_3",
  Statistics_RePosts_neutral_urgency = "Statistics_RePosts_neutral_urgency",
  Statistics_RePosts_down_title = "Statistics_RePosts_down_title",
  Statistics_RePosts_down_summary = "Statistics_RePosts_down_summary",
  Statistics_RePosts_down_action_1 = "Statistics_RePosts_down_action_1",
  Statistics_RePosts_down_action_2 = "Statistics_RePosts_down_action_2",
  Statistics_RePosts_down_action_3 = "Statistics_RePosts_down_action_3",
  Statistics_RePosts_down_urgency = "Statistics_RePosts_down_urgency",
  Statistics_RePosts_zero_title = "Statistics_RePosts_zero_title",
  Statistics_RePosts_zero_summary = "Statistics_RePosts_zero_summary",
  Statistics_RePosts_zero_action_1 = "Statistics_RePosts_zero_action_1",
  Statistics_RePosts_zero_action_2 = "Statistics_RePosts_zero_action_2",
  Statistics_RePosts_zero_action_3 = "Statistics_RePosts_zero_action_3",
  Statistics_RePosts_zero_urgency = "Statistics_RePosts_zero_urgency",
  // statistics suggestion box
  // 4️⃣ Page -> tools
  pageTools_hashtags = "pageTools_hashtags",
  pageTools_MyList = "pageTools_MyList",
  Analyzer = "Analyzer",
  pageTools_CreateNewList = "pageTools_CreateNewList",
  pageTools_CustomFont = "pageTools_CustomFont",
  pageTools_CustomFontExplain = "pageTools_CustomFontExplain",
  pageTools_global = "pageTools_global",
  pageTools_FA_AR = "pageTools_FA_AR",
  pageTools_Overall = "pageTools_Overall",
  pageTools_year = "pageTools_year",
  pageTools_Month = "pageTools_Month",
  pageTools_Week = "pageTools_Week",
  pageTools_Day = "pageTools_Day",
  pageTools_hashtag = "pageTools_hashtag",
  pageTools_USED = "pageTools_USED",
  pageTools_SearchedHashtag = "pageTools_SearchedHashtag",
  pageTools_TrendHashtags = "pageTools_TrendHashtags",
  pageTools_AutoInterAction = "pageTools_AutoInterAction",
  pageTools_AcceptPendingRequests = "pageTools_AcceptPendingRequests",
  pageTools_LikeAllNewComments = "pageTools_LikeAllNewComments",
  pageTools_LikeNewFollowersPosts = "pageTools_LikeNewFollowersPosts",
  pageTools_RemoveAllFollowings = "pageTools_RemoveAllFollowings",
  pageTools_WinnerPicker = "pageTools_WinnerPicker",
  pageTools_DayEvents = "pageTools_DayEvents",
  pageTools_EventDateRange = "pageTools_EventDateRange",
  pageTools_EventLanguage = "pageTools_EventLanguage",
  pageTools_EventSelectDate = "pageTools_EventSelectDate",
  pageTools_EventSearch = "pageTools_EventSearch",
  pageTools_EventEmpty = "pageTools_EventEmpty",
  pageTools_EventReligious = "pageTools_EventReligious",
  pageTools_EventIdeas = "pageTools_EventIdeas",
  pageTools_IdeaCreate = "pageTools_IdeaCreate",
  pageTools_IdeaExplain = "pageTools_IdeaExplain",
  pageTools_CreateEventIdea = "pageTools_CreateEventIdea",
  pageTools_CreateEventIdeaPrompt = "pageTools_CreateEventIdeaPrompt",
  pageTools_CreateEventIdeaPromptPlaceholder = "pageTools_CreateEventIdeaPromptPlaceholder",
  pageTools_CreateEventIdeaOptional = "pageTools_CreateEventIdeaOptional",
  pageTools_CreateEventIdeaSubmit = "pageTools_CreateEventIdeaSubmit",
  pageTools_CreateEventIdeaCancel = "pageTools_CreateEventIdeaCancel",
  pageTools_EventIdeasLanguage = "pageTools_EventIdeasLanguage",
  pageTools_EventIdeasFetch = "pageTools_EventIdeasFetch",
  pageTools_EventIdeasEmpty = "pageTools_EventIdeasEmpty",
  pageTools_EventIdeasLoadMore = "pageTools_EventIdeasLoadMore",
  pageTools_EventIdeasIdea = "pageTools_EventIdeasIdea",
  pageTools_EventIdeasCountry = "pageTools_EventIdeasCountry",
  pageTools_EventIdeasPrompt = "pageTools_EventIdeasPrompt",
  pageTools_EventIdeasCreatedTime = "pageTools_EventIdeasCreatedTime",
  pageTools_CustomEvent = "pageTools_CustomEvent",
  pageTools_exportcomments = "pageTools_exportcomments",
  pageTools_Lottery = "pageTools_Lottery",
  pageTools_emptylotteryList = "pageTools_emptylotteryList",
  pageTools_LotteryExplain = "pageTools_LotteryExplain",
  pageTools_fromFollowers = "pageTools_fromFollowers",
  pageTools_FromFollowersExplain = "pageTools_FromFollowersExplain",
  pageTools_Result = "pageTools_Result",
  pageTools_ResultExplain = "pageTools_ResultExplain",
  pageTools_popup_detail = "pageTools_popup_detail",
  pageTools_popup_history = "pageTools_popup_history",
  pageTools_LikeAllNewCommentsExplain = "pageTools_LikeAllNewCommentsExplain",
  pageTools_AcceptType = "pageTools_AcceptType",
  pageTools_popup_AlwaysActive = "pageTools_popup_AlwaysActive",
  pageTools_popup_JustOnce = "pageTools_popup_JustOnce",
  advertiseProperties_discard = "advertiseProperties_discard",
  advertiseProperties_stop = "advertiseProperties_stop",
  pageTools_AcceptPendingRequestsexplain = "pageTools_AcceptPendingRequestsexplain",
  pageTools_onlyprivate = "pageTools_onlyprivate",
  pageTools_LikeNewFollowersPostsexplain = "pageTools_LikeNewFollowersPostsexplain",
  pageTools_RemoveAllFollowingsexplain = "pageTools_RemoveAllFollowingsexplain",
  pageTools_progress = "pageTools_progress",
  pageTools_JustUnfollowwho = "pageTools_JustUnfollowwho",
  pageTools_AllmyFollowings = "pageTools_AllmyFollowings",
  pageLottery_Step = "pageLottery_Step",
  pageLottery_Specifications = "pageLottery_Specifications",
  pageLottery_SelectaPost = "pageLottery_SelectaPost",
  pageLottery_SetDateTime = "pageLottery_SetDateTime",
  pageLottery_WinnersTasks = "pageLottery_WinnersTasks",
  pageLottery_WinnersTasksexplain = "pageLottery_WinnersTasksexplain",
  pageLottery_NumberofWinners = "pageLottery_NumberofWinners",
  pageLottery_SetScoreForLottery = "pageLottery_SetScoreForLottery",
  pageLottery_SetScoreForLotteryexplain = "pageLottery_SetScoreForLotteryexplain",
  pageLottery_MinimumMention = "pageLottery_MinimumMention",
  pageLottery_MinimumMentionexplain = "pageLottery_MinimumMentionexplain",
  pageLottery_FollowedPage = "pageLottery_FollowedPage",
  pageLottery_FollowedPageexplain = "pageLottery_FollowedPageexplain",
  pageLottery_FollowmyPage = "pageLottery_FollowmyPage",
  pageLottery_FollowalternativePages = "pageLottery_FollowalternativePages",
  pageLottery_publishTermsconditions = "pageLottery_publishTermsconditions",
  pageLottery_previewTermsconditions = "pageLottery_previewTermsconditions",
  pageLottery_previewTermsconditionsexplain = "pageLottery_previewTermsconditionsexplain",
  pageLottery_Termsconditionsbanner = "pageLottery_Termsconditionsbanner",
  pageLottery_Termsconditionsbannerexplain = "pageLottery_Termsconditionsbannerexplain",
  pageLottery_model = "pageLottery_model",
  pageLottery_Solid = "pageLottery_Solid",
  pageLottery_Radial = "pageLottery_Radial",
  pageLottery_Linear = "pageLottery_Linear",
  pageLottery_Background = "pageLottery_Background",
  pageLottery_Color = "pageLottery_Color",
  pageLottery_Position = "pageLottery_Position",
  pageLottery_Degree = "pageLottery_Degree",
  pageLottery_TextBox = "pageLottery_TextBox",
  pageLottery_Opacity = "pageLottery_Opacity",
  pageLottery_Blur = "pageLottery_Blur",
  pageLottery_Font = "pageLottery_Font",
  pageLottery_Termsconditions = "pageLottery_Termsconditions",
  pageLottery_Winnerannouncement = "pageLottery_Winnerannouncement",
  pageLottery_participants1 = "pageLottery_participants1",
  pageLottery_participants2 = "pageLottery_participants2",
  pageLottery_participantsexplain = "pageLottery_participantsexplain",
  pageLottery_Addtocaption = "pageLottery_Addtocaption",
  pageLottery_Publishasstory = "pageLottery_Publishasstory",
  pageLottery_Winnerpickersstatus = "pageLottery_Winnerpickersstatus",
  pageLottery_scoreLotteryWinners = "pageLottery_scoreLotteryWinners",
  pageLottery_NoWinners = "pageLottery_NoWinners",
  pageLottery_RandomFollowersWinners = "pageLottery_RandomFollowersWinners",
  pageLottery_StoryAgain = "pageLottery_StoryAgain",
  ShareTermsAndCondition = "ShareTermsAndCondition",
  pageLottery_specifickeywordexplain = "pageLottery_specifickeywordexplain",
  pageLottery_FollowmyPageexplain = "pageLottery_FollowmyPageexplain",
  pageLottery_ShareRemainingTime = "pageLottery_ShareRemainingTime",
  pageLottery_LotteryRemainingTime = "pageLottery_LotteryRemainingTime",
  pageLottery_Winnerpickerisrunning = "pageLottery_Winnerpickerisrunning",
  pageLottery_ViewandEditDetails = "pageLottery_ViewandEditDetails",
  pageLottery_ActiveWinnerpickers = "pageLottery_ActiveWinnerpickers",
  pageTools_WinnerPickertooltip24hour = "pageTools_WinnerPickertooltip24hour",
  specifickeywordstooltip = "specifickeywordstooltip",
  pageLottery_FilterKeywords = "pageLottery_FilterKeywords",
  pageLottery_NumberofWinnersexplain = "pageLottery_NumberofWinnersexplain",
  pageLottery_permanentlinktooltip = "pageLottery_permanentlinktooltip",
  pageLottery_permanentlinkexplain = "pageLottery_permanentlinkexplain",
  pageTools_randomly = "pageTools_randomly",
  pageTools_BestEngagement = "pageTools_BestEngagement",
  pageTools_BestEngagementexplain = "pageTools_BestEngagementexplain",
  pageTools_pageanAnalyzer = "pageTools_pageanAnalyzer",
  pageTools_pictureanAnalyzer = "pageTools_pictureanAnalyzer",
  pageTools_CreateNewListexplain = "pageTools_CreateNewListexplain",
  pageTools_CreateNewListpic = "pageTools_CreateNewListpic",
  pageTools_CreateNewListpicexplain = "pageTools_CreateNewListpicexplain",
  pageTools_CreateNewListpage = "pageTools_CreateNewListpage",
  pageTools_CreateNewListpageexplain = "pageTools_CreateNewListpageexplain",
  pageToolspopup_CreateNewListexplain = "pageToolspopup_CreateNewListexplain",
  pageToolspopup_Listname = "pageToolspopup_Listname",
  pageToolspopup_hashtags = "pageToolspopup_hashtags",
  pageToolspopup_typehere = "pageToolspopup_typehere",
  pageTools_hashtagList = "pageTools_hashtagList",
  pageTools_StartAnalysis = "pageTools_StartAnalysis",
  pageToolspopup_pageURL = "pageToolspopup_pageURL",
  pageLottery_deleteexplain = "pageLottery_deleteexplain",
  update = "update",
  pageToolspopup_HideLikeandViewCounts = "pageToolspopup_HideLikeandViewCounts",
  pageToolspopup_TurnoffCommenting = "pageToolspopup_TurnoffCommenting",
  pageToolspopup_TurnoffCommentingExplain = "pageToolspopup_TurnoffCommentingExplain",
  pageToolspopup_TurnoffCommentingexplainforlottery = "pageToolspopup_TurnoffCommentingexplainforlottery",
  pageToolspopup_TopHashtag = "pageToolspopup_TopHashtag",
  pageToolspopup_TopHashtagexplain = "pageToolspopup_TopHashtagexplain",
  pageToolspopup_allRepliedcomments = "pageToolspopup_allRepliedcomments",
  pageTools_Reacceptfollowerexplain = "pageTools_Reacceptfollowerexplain",
  pageTools_Reacceptfollower = "pageTools_Reacceptfollower",
  pageTools_MaxLike = "pageTools_MaxLike",
  waitday = "waitday",
  waitdayexplain = "waitdayexplain",
  waitdayexplain2 = "waitdayexplain2",
  messagesetting_icebreakerexplain = "messagesetting_icebreakerexplain",
  messagesetting_icebreaker = "messagesetting_icebreaker",
  messagesetting_addNewButton = "messagesetting_addNewButton",
  messagesetting_addicebreakerexplain = "messagesetting_addicebreakerexplain",
  messagesetting_PersistentMenuexplain = "messagesetting_PersistentMenuexplain",
  messagesetting_PersistentMenu = "messagesetting_PersistentMenu",
  messagesetting_addPersistentMenuexplain = "messagesetting_addPersistentMenuexplain",
  tool_token_usage_guide = "tool_token_usage_guide",
  tool_how_use = "tool_how_use",
  tool_how_work = "tool_how_work",
  send_sms_ir_code_description = "send_sms_ir_code_description",
  send_sms_ir_code_completeDescription = "send_sms_ir_code_completeDescription",
  send_sms_ir_code_howUse = "send_sms_ir_code_howUse",
  send_sms_ir_code_howWork = "send_sms_ir_code_howWork",
  send_to_telegram_description = "send_to_telegram_description",
  send_to_telegram_completeDescription = "send_to_telegram_completeDescription",
  send_to_telegram_howUse = "send_to_telegram_howUse",
  send_to_telegram_howWork = "send_to_telegram_howWork",
  sender_username_description = "sender_username_description",
  sender_username_completeDescription = "sender_username_completeDescription",
  sender_username_howUse = "sender_username_howUse",
  sender_username_howWork = "sender_username_howWork",

  noresult = "noresult",
  viewreplies = "viewreplies",
  allRepliedcomments = "allRepliedcomments",
  Followers = "Followers",
  NonFollowers = "NonFollowers",
  pageToolspopup_ViewersLikes = "pageToolspopup_ViewersLikes",
  supportedformat = "supportedformat",
  limitsize = "limitsize",
  TagMention = "TagMention",
  cover = "cover",
  Pleaseselect = "Pleaseselect",
  replace = "replace",
  Album = "Album",
  SavedHashtagList = "SavedHashtagList",
  SavedHashtagListexplain = "SavedHashtagListexplain",
  FirstComment = "FirstComment",
  PinFirstComment = "PinFirstComment",
  Addpeopleexplain = "Addpeopleexplain",
  AdvanceSettings = "AdvanceSettings",
  sharepreviewtofeed = "sharepreviewtofeed",
  Videocopyrightbypass = "Videocopyrightbypass",
  SetScheduledPost = "SetScheduledPost",
  RecommendedDateTime = "RecommendedDateTime",
  RecommendedDateTimeexplain = "RecommendedDateTimeexplain",
  publish = "publish",
  areyousure = "areyousure",
  shouldFollower = "shouldFollower",
  draftexplain = "draftexplain",
  deletedraftexplain = "deletedraftexplain",
  deleteorderexplain = "deleteorderexplain",
  // #endregion Page Section
  // #region 6️⃣advertise Section
  // advertise -> calendar
  advertisecalendar_calendar = "advertisecalendar_calendar",
  advertisecalendar_nextday = "advertisecalendar_nextday",
  advertisecalendar_Timeline = "advertisecalendar_Timeline",
  advertisecalendar_TODAY = "advertisecalendar_TODAY",
  advertisecalendar_BookaTime = "advertisecalendar_BookaTime",
  advertisecalendar_TIMELINEZOOM = "advertisecalendar_TIMELINEZOOM",
  // advertise -> statistics
  advertisestatistics_lasttwomonth = "advertisestatistics_lasttwomonth",
  advertisestatistics_lastmonth = "advertisestatistics_lastmonth",
  advertisestatistics_thismonth = "advertisestatistics_thismonth",
  advertisestatistics_ads = "advertisestatistics_ads",
  advertisestatistics_fromlast = "advertisestatistics_fromlast",
  advertisestatistics_totalADSstatistics = "advertisestatistics_totalADSstatistics",
  advertisestatistics_TotalAds = "advertisestatistics_TotalAds",
  advertisestatistics_TotalIncome = "advertisestatistics_TotalIncome",
  advertisestatistics_totaladsreport = "advertisestatistics_totaladsreport",
  advertisestatistics_adno = "advertisestatistics_adno",
  advertisestatistics_advertiser = "advertisestatistics_advertiser",
  advertisestatistics_type = "advertisestatistics_type",
  advertisestatistics_status = "advertisestatistics_status",
  advertisestatistics_price = "advertisestatistics_price",
  advertisestatistics_date = "advertisestatistics_date",
  advertisestatistics_share = "advertisestatistics_share",
  // advertise -> adlist
  advertiseadlist_activeAd = "advertiseadlist_activeAd",
  advertiseadlist_AwaitingApproval = "advertiseadlist_AwaitingApproval",
  advertiseadlist_AwaitingPublication = "advertiseadlist_AwaitingPublication",
  advertiseadlist_rejectedlist = "advertiseadlist_rejectedlist",
  // advertise -> Properties
  advertiseProperties_Concurrentads = "advertiseProperties_Concurrentads",
  advertiseProperties_Concurrentadsexplain = "advertiseProperties_Concurrentadsexplain",
  advertiseProperties_numberofads = "advertiseProperties_numberofads",
  advertiseProperties_numberofadsexplain = "advertiseProperties_numberofadsexplain",
  advertiseProperties_campaign = "advertiseProperties_campaign",
  advertiseProperties_campaignexplain = "advertiseProperties_campaignexplain",
  advertiseProperties_adsoptions = "advertiseProperties_adsoptions",
  advertiseProperties_rejectreasonheader1 = "advertiseProperties_rejectreasonheader1",
  advertiseProperties_rejectreasonheader2 = "advertiseProperties_rejectreasonheader2",
  advertiseProperties_rejectreasonheader3 = "advertiseProperties_rejectreasonheader3",
  advertiseProperties_rejectreasonheader4 = "advertiseProperties_rejectreasonheader4",
  advertiseProperties_rejectreason1 = "advertiseProperties_rejectreason1",
  advertiseProperties_rejectreason2 = "advertiseProperties_rejectreason2",
  advertiseProperties_rejectreason3 = "advertiseProperties_rejectreason3",
  advertiseProperties_rejectreason4 = "advertiseProperties_rejectreason4",
  advertiseProperties_AdvertisingTerms = "advertiseProperties_AdvertisingTerms",
  advertiseProperties_AdvertisingTermsexplain = "advertiseProperties_AdvertisingTermsexplain",
  advertiseProperties_AdvertisingTerm1 = "advertiseProperties_AdvertisingTerm1",
  advertiseProperties_AdvertisingTerm2 = "advertiseProperties_AdvertisingTerm2",
  advertiseProperties_AdvertisingTerm3 = "advertiseProperties_AdvertisingTerm3",
  advertiseProperties_AdvertisingTerm4 = "advertiseProperties_AdvertisingTerm4",
  advertiseProperties_AdvertisingTermsave = "advertiseProperties_AdvertisingTermsave",
  advertiseProperties_businesshours = "advertiseProperties_businesshours",
  advertiseProperties_24hours = "advertiseProperties_24hours",
  advertiseProperties_close = "advertiseProperties_close",
  advertiseProperties_notifications = "advertiseProperties_notifications",
  advertiseProperties_notificationsSMS = "advertiseProperties_notificationsSMS",
  advertiseProperties_notificationsEmail = "advertiseProperties_notificationsEmail",
  advertiseProperties_notificationssystem = "advertiseProperties_notificationssystem",
  advertiseProperties_notificationsinstagramdirect = "advertiseProperties_notificationsinstagramdirect",
  advertiseProperties_notificationssystemticket = "advertiseProperties_notificationssystemticket",
  advertiseProperties_advertisetariff = "advertiseProperties_advertisetariff",
  advertiseProperties_onlyToday = "advertiseProperties_onlyToday",
  advertiseProperties_onlyTodayexplain = "advertiseProperties_onlyTodayexplain",
  advertiseProperties_12hours = "advertiseProperties_12hours",
  advertiseProperties_otherdays = "advertiseProperties_otherdays",
  advertiseProperties_otherdaysexplain = "advertiseProperties_otherdaysexplain",
  advertiseProperties_Campaign = "advertiseProperties_Campaign",
  advertiseProperties_Campaignexplain = "advertiseProperties_Campaignexplain",
  advertiseProperties_lastModified = "advertiseProperties_lastModified",
  advertiseProperties_tariff24hours = "advertiseProperties_tariff24hours",
  advertiseProperties_tariff12hours = "advertiseProperties_tariff12hours",
  advertiseProperties_userreport = "advertiseProperties_userreport",
  advertiseProperties_userID = "advertiseProperties_userID",
  advertiseProperties_reportexplain = "advertiseProperties_reportexplain",
  advertiseProperties_reportsubmit = "advertiseProperties_reportsubmit",
  Apply = "Apply",
  advertise_ADDetail = "advertise_ADDetail",
  content = "content",
  advertise_orderdate = "advertise_orderdate",
  advertise_duration = "advertise_duration",
  Remaining = "Remaining",
  createtime = "createtime",
  signinyouradvertise = "signinyouradvertise",
  signinyouradvertiseExplain = "signinyouradvertiseExplain",
  // #endregion advertise Section  // #region 7️⃣Store Section
  // Store -> product
  signinyourstore = "signinyourstore",
  signinyourstoreExplain = "signinyourstoreExplain",
  Storeproduct_activatestore = "Storeproduct_activatestore",
  Storeproduct_needyourID = "Storeproduct_needyourID",
  Storeproduct_needyourIDExplain = "Storeproduct_needyourIDExplain",
  Storeproduct_successyourID = "Storeproduct_successyourID",
  Storeproduct_NationalCardexplain = "Storeproduct_NationalCardexplain",
  Storeproduct_addcreditnumber = "Storeproduct_addcreditnumber",
  Storeproduct_addcreditnumberExplain = "Storeproduct_addcreditnumberExplain",
  Storeproduct_successnumber = "Storeproduct_successnumber",
  Storeproduct_shippingmethod = "Storeproduct_shippingmethod",
  Storeproduct_shippingmethodExplain = "Storeproduct_shippingmethodExplain",
  Storeproduct_shippingmethodsuccess = "Storeproduct_shippingmethodsuccess",
  Storeproduct_shippingmethodtooltip = "Storeproduct_shippingmethodtooltip",
  Storeproduct_uploadimagefirst = "Storeproduct_uploadimagefirst",
  Storeproduct_creditcardsameidcard = "Storeproduct_creditcardsameidcard",
  Storeproduct_postalcode = "Storeproduct_postalcode",
  Storeproduct_postalcodeExplain = "Storeproduct_postalcodeExplain",
  Storeproduct_postalcodesuccess = "Storeproduct_postalcodesuccess",
  Storeproduct_postalcodeinputExplain = "Storeproduct_postalcodeinputExplain",
  Storeproduct_TermsAndCondition = "Storeproduct_TermsAndCondition",
  Storeproduct_TermsAndConditionExplain = "Storeproduct_TermsAndConditionExplain",
  Storeproduct_TermsAndConditionesuccess = "Storeproduct_TermsAndConditionesuccess",
  Storeproduct_AcceptTermsAndCondition = "Storeproduct_AcceptTermsAndCondition",
  Storeproduct_notyet = "Storeproduct_notyet",
  Storeproduct_addnow = "Storeproduct_addnow",
  Storeproduct_addexplain = "Storeproduct_addexplain",
  Storeproduct_productlist = "Storeproduct_productlist",
  Storeproduct_search = "Storeproduct_search",
  Storeproduct_importproduct = "Storeproduct_importproduct",
  Storeproduct_importfrominsta = "Storeproduct_importfrominsta",
  Storeproduct_newproduct = "Storeproduct_newproduct",
  Storeproduct_addnewproduct = "Storeproduct_addnewproduct",
  Storeproduct_name = "Storeproduct_name",
  Storeproduct_weight = "Storeproduct_weight",
  Storeproduct_size = "Storeproduct_size",
  Storeproduct_color = "Storeproduct_color",
  Storeproduct_stock = "Storeproduct_stock",
  Storeproduct_price = "Storeproduct_price",
  Storeproduct_active = "Storeproduct_active",
  Storeproduct_gram = "Storeproduct_gram",
  loadingmoreproducts = "loadingmoreproducts",
  noMoreProducts = "noMoreProducts",
  // Store -> order
  addtocart = "addtocart",
  incartcount = "incartcount",
  AllProducts = "AllProducts",
  Storeproduct_inQueue = "Storeproduct_inQueue",
  Storeproduct_inprogress = "Storeproduct_inprogress",
  Storeproduct_pickingup = "Storeproduct_pickingup",
  Storeproduct_sent = "Storeproduct_sent",
  Storeproduct_delivered = "Storeproduct_delivered",
  Storeproduct_failed = "Storeproduct_failed",
  Storeproduct_canceledbyuser = "Storeproduct_canceledbyuser",
  Storeproduct_canceledbyadmin = "Storeproduct_canceledbyadmin",
  Storeproduct_returned = "Storeproduct_returned",
  Storeproduct_incart = "Storeproduct_incart",
  Storeorder_all = "Storeorder_all",
  Storeorder_ORDERID = "Storeorder_ORDERID",
  Storeorder_CUSTOMER = "Storeorder_CUSTOMER",
  Storeorder_ITEMS = "Storeorder_ITEMS",
  Storeorder_ITEM = "Storeorder_ITEM",
  Storeorder_PRICE = "Storeorder_PRICE",
  Storeorder_OrderDATE = "Storeorder_OrderDATE",
  copytrackingcode = "copytrackingcode",
  Storeorder_SentDATE = "Storeorder_SentDATE",
  Storeorder_DELIVERY = "Storeorder_DELIVERY",
  Storeorder_bymyself = "Storeorder_bymyself",
  Storeorder_Envelope = "Storeorder_Envelope",
  Storeorder_Invoice = "Storeorder_Invoice",
  Storeorder_DeliveryAmount = "Storeorder_DeliveryAmount",
  Storeorder_InsuranceAmount = "Storeorder_InsuranceAmount",
  Storeorder_Coupon = "Storeorder_Coupon",
  Storeorder_RemoveCoupon = "Storeorder_RemoveCoupon",
  Storeorder_Productsinyourshoppingcart = "Storeorder_Productsinyourshoppingcart",
  Storeorder_SendtotheAddress = "Storeorder_SendtotheAddress",
  Storeorder_changeofaddress = "Storeorder_changeofaddress",
  Storeorder_postparselbox = "Storeorder_postparselbox",
  Storeorder_pocketenveloptitle = "Storeorder_pocketenveloptitle",
  Storeorder_pocketenveloptitleExplain = "Storeorder_pocketenveloptitleExplain",
  Storeorder_deliverdate = "Storeorder_deliverdate",
  Storeorder_Destination = "Storeorder_Destination",
  Storeorder_STATUS = "Storeorder_STATUS",
  Storeorder_DETAILS = "Storeorder_DETAILS",
  Storeorder_PickupRequest = "Storeorder_PickupRequest",
  Storeorder_PrintWaybill = "Storeorder_PrintWaybill",
  Storeorder_Waybill = "Storeorder_Waybill",
  Storeorder_WaybillExplain = "Storeorder_WaybillExplain",
  Storeorder_noneSendExplain = "Storeorder_noneSendExplain",
  Storeorder_SendExplain = "Storeorder_SendExplain",
  Storeorder_ManualTrackingExplain = "Storeorder_ManualTrackingExplain",
  Storeorder_requestedpickup = "Storeorder_requestedpickup",
  Storeorder_TrackingCode = "Storeorder_TrackingCode",

  Storeorder_PostMan = "Storeorder_PostMan",
  Storeorder_from = "Storeorder_from",
  Storeorder_currentLocation = "Storeorder_currentLocation",
  Storeorder_lastUpdateTime = "Storeorder_lastUpdateTime",
  Storeorder_sender = "Storeorder_sender",

  Storeorder_Pickedup = "Storeorder_Pickedup",
  Storeorder_IssuingTrackingCode = "Storeorder_IssuingTrackingCode",
  Storeorder_orderDetailsStep = "Storeorder_orderDetailsStep",
  Storeorder_orderconfirmStep = "Storeorder_orderconfirmStep",
  Storeorder_ParselisConfirmed = "Storeorder_ParselisConfirmed",
  Storeorder_ParselisConfirmedExplain = "Storeorder_ParselisConfirmedExplain",
  Storeorder_CancelOrder = "Storeorder_CancelOrder",
  Storeorder_nextWaybill = "Storeorder_nextWaybill",
  Storeorder_orderlist = "Storeorder_orderlist",
  Storeorder_singleorder = "Storeorder_singleorder",
  Storeorder_quantityorder = "Storeorder_quantityorder",

  // store -> statistics
  // store -> statistics
  storestatistics_lasttwomonth = "storestatistics_lasttwomonth",
  storestatistics_lastmonth = "storestatistics_lastmonth",
  storestatistics_thismonth = "storestatistics_thismonth",
  storestatistics_sales = "storestatistics_sales",
  storestatistics_fromlast = "storestatistics_fromlast",
  storestatistics_totalSalesstatistics = "storestatistics_totalSalesstatistics",
  storestatistics_TotalSales = "storestatistics_TotalSales",
  storestatistics_TotalIncome = "storestatistics_TotalIncome",
  storestatistics_totalsalesreport = "storestatistics_totalsalesreport",
  storestatistics_buyer = "storestatistics_buyer",
  storestatistics_totalPurchases = "storestatistics_totalPurchases",
  storestatistics_totalAmount = "storestatistics_totalAmount",
  storestatistics_lastPurchase = "storestatistics_lastPurchase",
  storestatistics_saleno = "storestatistics_saleno",
  storestatistics_seller = "storestatistics_seller",
  storestatistics_type = "storestatistics_type",
  storestatistics_status = "storestatistics_status",
  storestatistics_price = "storestatistics_price",
  storestatistics_date = "storestatistics_date",
  storestatistics_share = "storestatistics_share",
  storestatistics_couponTitle = "storestatistics_couponTitle",
  storestatistics_addCoupon = "storestatistics_addCoupon",
  storestatistics_noCoupons = "storestatistics_noCoupons",
  storestatistics_couponCode = "storestatistics_couponCode",
  storestatistics_discountPercent = "storestatistics_discountPercent",
  storestatistics_maxUses = "storestatistics_maxUses",
  storestatistics_phoneNumber = "storestatistics_phoneNumber",
  storestatistics_maxDiscountOptional = "storestatistics_maxDiscountOptional",
  storestatistics_couponExpiry = "storestatistics_couponExpiry",
  storestatistics_showInBio = "storestatistics_showInBio",
  storestatistics_couponDeleted = "storestatistics_couponDeleted",
  storestatistics_couponExpired = "storestatistics_couponExpired",
  storestatistics_couponExhausted = "storestatistics_couponExhausted",
  storestatistics_couponActive = "storestatistics_couponActive",
  storestatistics_unlimited = "storestatistics_unlimited",
  storestatistics_couponUsage = "storestatistics_couponUsage",
  storestatistics_discountValue = "storestatistics_discountValue",
  storestatistics_maxDiscountValue = "storestatistics_maxDiscountValue",
  storestatistics_expiryValue = "storestatistics_expiryValue",
  storestatistics_private = "storestatistics_private",
  storestatistics_public = "storestatistics_public",

  Showmore = "Showmore",
  totalprice = "totalprice",
  note = "note",
  navbar_PaymentNumber = "navbar_PaymentNumber",
  Storeorder_receiver = "Storeorder_receiver",
  Storeorder_AcceptthisOrder = "Storeorder_AcceptthisOrder",
  SelectProduct = "SelectProduct",
  SelectedPosts = "SelectedPosts",
  SharedRemainingTimeBefore = "SharedRemainingTimeBefore",
  ShowUnprocessedItemsOnly = "ShowUnprocessedItemsOnly",
  pageStatistics_fromstore = "pageStatistics_fromstore",
  ordernumber = "ordernumber",
  BacktoProductList = "BacktoProductList",
  Backtocart = "Backtocart",
  product_BasicDetail = "product_BasicDetail",
  product_ProductID = "product_ProductID",
  product_Producttitle = "product_Producttitle",
  product_Product = "product_Product",
  product_Categories = "product_Categories",
  product_MainCategory = "product_MainCategory",
  product_Subcategory = "product_Subcategory",
  product_Subset = "product_Subset",
  product_Group = "product_Group",
  product_Branch = "product_Branch",
  product_Subbranch = "product_Subbranch",
  product_Dependency = "product_Dependency",
  product_Brand = "product_Brand",
  product_instagramcaption = "product_instagramcaption",
  product_productDescription = "product_productDescription",
  product_General = "product_General",
  product_Specifications = "product_Specifications",
  product_Information = "product_Information",
  product_addNewTable = "product_addNewTable",
  product_EditTable = "product_EditTable",
  product_PreviewTable = "product_PreviewTable",
  product_addtable = "product_addtable",
  product_tabletitle = "product_tabletitle",
  product_tabletitleExplain = "product_tabletitleExplain",
  product_tableheaderoption = "product_tableheaderoption",
  product_AddColumn = "product_AddColumn",
  product_DeleteColumn = "product_DeleteColumn",
  product_AddRow = "product_AddRow",
  product_DeleteRow = "product_DeleteRow",
  rowheader = "rowheader",
  cell = "cell",
  Nodescriptionavailable = "Nodescriptionavailable",
  NoSpecificationsavailable = "NoSpecificationsavailable",
  product_Media = "product_Media",
  product_Properties = "product_Properties",
  product_Setting = "product_Setting",
  product_SetProperties = "product_SetProperties",
  product_SetPropertiesexplain = "product_SetPropertiesexplain",
  product_AddNewproperty = "product_AddNewproperty",
  product_Nopropertyisset = "product_Nopropertyisset",
  product_Variation = "product_Variation",
  product_Discount = "product_Discount",
  product_PricewithDiscount = "product_PricewithDiscount",
  product_AddNewVariation = "product_AddNewVariation",
  product_Definenew = "product_Definenew",
  product_systemlist = "product_systemlist",
  product_itemlist = "product_itemlist",
  product_Informationplaceholder = "product_Informationplaceholder",
  product_Available = "product_Available",
  product_supplying = "product_supplying",
  product_OutOfStock = "product_OutOfStock",
  product_Stoppedsale = "product_Stoppedsale",
  product_draft = "product_draft",
  product_Amount = "product_Amount",
  product_NUMBEROFUSES = "product_NUMBEROFUSES",
  product_UNLIMITED = "product_UNLIMITED",
  product_LIMITED = "product_LIMITED",
  product_USINGTIMES = "product_USINGTIMES",
  product_UNLIMITEDTIME = "product_UNLIMITEDTIME",
  permanent = "permanent",
  product_LIMITEDTIME = "product_LIMITEDTIME",
  product_mediatitle = "product_mediatitle",
  product_clicktoupload = "product_clicktoupload",
  product_SuggestedImages = "product_SuggestedImages",
  product_SuggestedImagesExplain = "product_SuggestedImagesExplain",
  product_ordragdrop = "product_ordragdrop",
  product_productspecifications = "product_productspecifications",
  product_choosesystemlist = "product_choosesystemlist",
  product_choosesystemlistexplain = "product_choosesystemlistexplain",
  product_Definenewexplain = "product_Definenewexplain",
  product_importbatch = "product_importbatch",
  product_importbatchexplain = "product_importbatchexplain",
  Value = "Value",
  product_original = "product_original",
  product_HighCopy = "product_HighCopy",
  product_fake = "product_fake",
  product_notoriginal = "product_notoriginal",
  product_Corporate = "product_Corporate",
  product_Miscellaneous = "product_Miscellaneous",
  tomorrow = "tomorrow",
  NotSet = "NotSet",
  Yes = "Yes",
  No = "No",
  Storeproduct_OutOfStandardSize = "Storeproduct_OutOfStandardSize",
  product_box = "product_box",
  Product_Availablity = "Product_Availablity",
  Product_maxincart = "Product_maxincart",
  Product_originality = "Product_originality",
  Product_preperingforship = "Product_preperingforship",
  Product_Evat = "Product_Evat",
  Product_Evatcount = "Product_Evatcount",
  Product_Guarantee = "Product_Guarantee",
  Product_Guaranteelength = "Product_Guaranteelength",
  Product_packageshipping = "Product_packageshipping",
  Product_packageshippingexplain = "Product_packageshippingexplain",
  Product_titleExplain = "Product_titleExplain",
  Product_Breakable = "Product_Breakable",
  Product_Luquid = "Product_Luquid",
  Product_Productweights = "Product_Productweights",
  Product_Productweightsexplian = "Product_Productweightsexplian",
  Product_packaging = "Product_packaging",
  Product_packagingexplian = "Product_packagingexplian",
  Product_shippingSize = "Product_shippingSize",
  product_SuggestedPrice = "product_SuggestedPrice",
  product_MinimumPrice = "product_MinimumPrice",
  product_AveragePrice = "product_AveragePrice",
  product_MaximumPrice = "product_MaximumPrice",
  Product_sack = "Product_sack",
  Product_sackExplain = "Product_sackExplain",
  length = "length",
  width = "width",
  height = "height",
  Weight = "Weight ",
  finalWeight = "finalWeight ",
  product_deleteproductexplain = "product_deleteproductexplain",
  // #endregion Store Section  // #region 8️⃣Setting Section
  // Setting -> General -> System
  SettingGeneralSystemTitle = "SettingGeneralSystemTitle",
  SettingGeneralSystemlanguage = "SettingGeneralSystemlanguage",
  SettingGeneralSystemcalendar = "SettingGeneralSystemcalendar",
  SettingGeneralSystemGregorian = "SettingGeneralSystemGregorian",
  SettingGeneralSystemshamsi = "SettingGeneralSystemshamsi",
  SettingGeneralSystemHijri = "SettingGeneralSystemHijri",
  SettingGeneralSystemHindi = "SettingGeneralSystemHindi",
  SettingGeneralSystemStartWeek = "SettingGeneralSystemStartWeek",
  SettingGeneralSystemsaturday = "SettingGeneralSystemsaturday",
  SettingGeneralSystemmonday = "SettingGeneralSystemmonday",
  SettingGeneralSystemtuesday = "SettingGeneralSystemtuesday",
  SettingGeneralSystemwednesday = "SettingGeneralSystemwednesday",
  SettingGeneralSystemthursday = "SettingGeneralSystemthursday",
  SettingGeneralSystemfriday = "SettingGeneralSystemfriday",
  SettingGeneralSystemsunday = "SettingGeneralSystemsunday",
  SettingGeneralSystemtheme = "SettingGeneralSystemtheme",
  SettingGeneralSystemDarkmode = "SettingGeneralSystemDarkmode",
  SettingGeneralSystemlightmode = "SettingGeneralSystemlightmode",
  SettingGeneralSystemPrice = "SettingGeneralSystemPrice",
  SettingGeneralSystemDollar = "SettingGeneralSystemDollar",
  SettingGeneralSystemeuro = "SettingGeneralSystemeuro",
  SettingGeneralSystempound = "SettingGeneralSystempound",
  SettingGeneralSystemrial = "SettingGeneralSystemrial",
  SettingGeneralSystemtoman = "SettingGeneralSystemtoman",
  // Setting -> General -> AI Models
  SettingGeneralAiModelsTitle = "SettingGeneralAiModelsTitle",
  SettingGeneralAiModelsTextModels = "SettingGeneralAiModelsTextModels",
  SettingGeneralAiModelsVoiceModels = "SettingGeneralAiModelsVoiceModels",
  SettingGeneralAiModelsDirectVoiceSupport = "SettingGeneralAiModelsDirectVoiceSupport",
  // Setting -> General -> Profile
  SettingGeneralProfileTitle = "SettingGeneralProfileTitle",
  SettingGeneral_activedevice = "SettingGeneral_activedevice",
  SettingGeneral_leatestentery = "SettingGeneral_leatestentery",
  SettingGeneral_cantdeletesession = "SettingGeneral_cantdeletesession",
  SettingGeneral_deletesession = "SettingGeneral_deletesession",
  SettingGeneral_addSubAdmin = "SettingGeneral_addSubAdmin",
  SettingGeneral_addSubAdminExplain = "SettingGeneral_addSubAdminExplain",
  SettingGeneral_addSubAdminExplain2 = "SettingGeneral_addSubAdminExplain2",
  SettingGeneral_addSubAdmintitleExplain = "SettingGeneral_addSubAdmintitleExplain",
  SettingGeneral_accesslevel = "SettingGeneral_accesslevel",
  SettingGeneral_access = "SettingGeneral_access",
  SettingGeneral_partnertitle = "SettingGeneral_partnertitle",
  SettingGeneral_partnernumberexplain = "SettingGeneral_partnernumberexplain",
  SettingGeneral_contentTooltip = "SettingGeneral_contentTooltip",
  SettingGeneral_publishTooltip = "SettingGeneral_publishTooltip",
  SettingGeneral_automaticsTooltip = "SettingGeneral_automaticsTooltip",
  SettingGeneral_messageTooltip = "SettingGeneral_messageTooltip",
  SettingGeneral_commentTooltip = "SettingGeneral_commentTooltip",
  SettingGeneral_transactionTooltip = "SettingGeneral_transactionTooltip",
  SettingGeneral_adsTooltip = "SettingGeneral_adsTooltip",
  SettingGeneral_ordersTooltip = "SettingGeneral_ordersTooltip",
  SettingGeneral_bioTooltip = "SettingGeneral_bioTooltip",
  SettingGeneral_ticketTooltip = "SettingGeneral_ticketTooltip",
  SettingGeneral_productsTooltip = "SettingGeneral_productsTooltip",
  // Setting -> General -> support
  SettingGeneral_GeneralSupport = "SettingGeneral_GeneralSupport",
  SettingGeneral_Customerservices = "SettingGeneral_Customerservices",
  SettingGeneral_ReportBug = "SettingGeneral_ReportBug",
  SettingGeneral_Advertise = "SettingGeneral_Advertise",
  SettingGeneral_Store = "SettingGeneral_Store",
  SettingGeneral_biolink = "SettingGeneral_biolink",
  SettingGeneral_Walletandfinance = "SettingGeneral_Walletandfinance",
  SettingGeneral_MessageingandComment = "SettingGeneral_MessageingandComment",
  SettingGeneral_Support = "SettingGeneral_Support",
  SettingGeneral_Department = "SettingGeneral_Department",
  SettingGeneral_Title = "SettingGeneral_Title",
  SettingGeneral_Description = "SettingGeneral_Description",
  SettingGeneral_Send = "SettingGeneral_Send",
  // #endregion Setting Section  // #region 3️⃣ Message Section
  message_blockexplain = "message_blockexplain",
  message_deleteexplain = "message_deleteexplain",
  message_block = "message_block",
  notactivemessage = "notactivemessage",
  message_unblock = "message_unblock",
  message_youareattemptingto = "message_youareattemptingto",
  messagesetting_welcometext = "messagesetting_welcometext",
  messagesetting_goodbyetext = "messagesetting_goodbyetext",
  messagesetting_welcomingmessage = "messagesetting_welcomingmessage",
  messagesetting_welcome = "messagesetting_welcome",
  messagesetting_goodbye = "messagesetting_goodbye",
  messagesetting_Activewelcomingmessage = "messagesetting_Activewelcomingmessage",
  messagesetting_Activewelcomemessageexplain = "messagesetting_Activewelcomemessageexplain",
  messagesetting_Sentmessages = "messagesetting_Sentmessages",
  messagesetting_ActiveFarewellmessage = "messagesetting_ActiveFarewellmessage",
  messagesetting_ActiveFarewellmessageexplain = "messagesetting_ActiveFarewellmessageexplain",
  messagesetting_businessmessagefilter = "messagesetting_businessmessagefilter",
  messagesetting_businessmessagefiltering = "messagesetting_businessmessagefiltering",
  messagesetting_businessmessagefilteringexplain = "messagesetting_businessmessagefilteringexplain",
  messagesetting_specificwords = "messagesetting_specificwords",
  messagesetting_autofiltering = "messagesetting_autofiltering",
  messagesetting_selectedwords = "messagesetting_selectedwords",
  pageToolspopup_specificwordsexplain = "pageToolspopup_specificwordsexplain",
  messagesetting_specificwordsexplain = "messagesetting_specificwordsexplain",
  messagesetting_Createanewsupportticket = "messagesetting_Createanewsupportticket",
  messagesetting_CreateanewsupportticketExplain = "messagesetting_CreateanewsupportticketExplain",
  messagesetting_Changeapplicationlanguage = "messagesetting_Changeapplicationlanguage",
  messagesetting_ChangeapplicationlanguageExplain = "messagesetting_ChangeapplicationlanguageExplain",
  messagesetting_ViewStoreandproducts = "messagesetting_ViewStoreandproducts",
  messagesetting_ViewStoreandproductsExplain = "messagesetting_ViewStoreandproductsExplain",
  messagesetting_Visityourwebsite = "messagesetting_Visityourwebsite",
  messagesetting_VisityourwebsiteExplain = "messagesetting_VisityourwebsiteExplain",
  messagesetting_Viewuserrolesandpermissions = "messagesetting_Viewuserrolesandpermissions",
  messagesetting_ViewuserrolesandpermissionsExplain = "messagesetting_ViewuserrolesandpermissionsExplain",
  messagesetting_Viewbusinesshourschart = "messagesetting_Viewbusinesshourschart",
  messagesetting_ViewbusinesshourschartExplain = "messagesetting_ViewbusinesshourschartExplain",
  messagesetting_Viewpricinginformation = "messagesetting_Viewpricinginformation",
  messagesetting_ViewpricinginformationExplain = "messagesetting_ViewpricinginformationExplain",
  messagesetting_Searchforproducts = "messagesetting_Searchforproducts",
  messagesetting_SearchforproductsExplain = "messagesetting_SearchforproductsExplain",
  messagesetting_addautomaticreplysystemsystem = "messagesetting_addautomaticreplysystemsystem",
  messagesetting_HideRobotReply = "messagesetting_HideRobotReply",
  messagesetting_HideRobotReplyExplain = "messagesetting_HideRobotReplyExplain",
  messagesetting_LikeRobotReply = "messagesetting_LikeRobotReply",
  messagesetting_LikeRobotReplyExplain = "messagesetting_LikeRobotReplyExplain",
  messagesetting_HideRobotReplytooltip = "messagesetting_HideRobotReplytooltip",
  messagesetting_messagePanellanguage = "messagesetting_messagePanellanguage",
  messagesetting_messagePanellanguageExplain = "messagesetting_messagePanellanguageExplain",
  messagesetting_AutoReplyPerFollow = "messagesetting_AutoReplyPerFollow",
  messagesetting_AutoReplyPerFollowExplain = "messagesetting_AutoReplyPerFollowExplain",
  messagesetting_AutoReplyPerFollowtooltip = "messagesetting_AutoReplyPerFollowtooltip",
  messagesetting_AutoReplyPerFollowtitle = "messagesetting_AutoReplyPerFollowtitle",
  messagesetting_AutoReplyPerFollowtitlesample = "messagesetting_AutoReplyPerFollowtitlesample",
  messagesetting_AutoReplyPerFollowbtn = "messagesetting_AutoReplyPerFollowbtn",
  messagesetting_AutoReplyPerFollowbtnsample = "messagesetting_AutoReplyPerFollowbtnsample",
  messagesetting_automaticreplysystem = "messagesetting_automaticreplysystem",
  messagesetting_automaticreplysystemexplain = "messagesetting_automaticreplysystemexplain",
  messagesetting_automaticreplysystemforallpost = "messagesetting_automaticreplysystemforallpost",
  messagesetting_automaticreplysystemforallposttooltip = "messagesetting_automaticreplysystemforallposttooltip",
  messagesetting_KeywordSensitive = "messagesetting_KeywordSensitive",
  messagesetting_UseSystemButtonsExplain = "messagesetting_UseSystemButtonsExplain",
  messagesetting_UseAIPromptsExplain = "messagesetting_UseAIPromptsExplain",
  messagesetting_ButtonTitle = "messagesetting_ButtonTitle",
  messagesetting_NoPromptsFound = "messagesetting_NoPromptsFound",
  messagesetting_CreateNewPrompt = "messagesetting_CreateNewPrompt",
  messagesetting_SelectYourPrompt = "messagesetting_SelectYourPrompt",
  messagesetting_DefineCustomResponseExplain = "messagesetting_DefineCustomResponseExplain",
  messagesetting_SpecifyProductResponseExplain = "messagesetting_SpecifyProductResponseExplain",
  messagesetting_ProductResponseExplain = "messagesetting_ProductResponseExplain",
  messagesetting_ConnectProductResponseExplain = "messagesetting_ConnectProductResponseExplain",
  messagesetting_SelectPredefinedFlowExplain = "messagesetting_SelectPredefinedFlowExplain",
  messagesetting_NoFlowsFound = "messagesetting_NoFlowsFound",
  messagesetting_CreateNewFlow = "messagesetting_CreateNewFlow",
  messagesetting_SelectFlow = "messagesetting_SelectFlow",
  messagesetting_ViewFlow = "messagesetting_ViewFlow",
  messagesetting_UseGeneralAIExplain = "messagesetting_UseGeneralAIExplain",
  messagesetting_KeywordsSensitive = "messagesetting_KeywordsSensitive",
  sendreplydirectedsuccessfully = "sendreplydirectedsuccessfully",
  autoReplyFor = "autoReplyFor",
  selectnewmessage = "selectnewmessage",
  sendreplyticket = "sendreplyticket",

  emptyticketdirect = "emptyticketdirect",
  emptysystemticket = "emptysystemticket",
  emptycomment = "emptycomment",
  emptydirect = "emptydirect",

  autocommentReplyExplain = "autocommentReplyExplain",
  respondToAllComments = "respondToAllComments",
  sensitiveToSpecificKeywords = "sensitiveToSpecificKeywords",
  sensitiveToSpecificKeywordsExplain = "sensitiveToSpecificKeywordsExplain",
  contain = "contain",
  containExplain = "containExplain",
  replyMethod = "replyMethod",
  respondInSameComment = "respondInSameComment",
  respondDirectly = "respondDirectly",
  ticketID = "ticketID",
  Ticketclosedby = "Ticketclosedby",
  waitingforuserresponse = "waitingforuserresponse",
  inactiveticketexpired = "inactiveticketexpired",
  automaticreply = "automaticreply",
  specifickeywords = "specifickeywords",
  autodirectexplain = "autodirectexplain",
  adddirectexplain = "adddirectexplain",
  autocommentexplain = "autocommentexplain",
  addcommentexplain = "addcommentexplain",
  receivedmessage = "receivedmessage",
  Messageresponse = "Messageresponse",
  Sendresponseifthepageisfollowed = "Sendresponseifthepageisfollowed",
  Likethereceivedmessage = "Likethereceivedmessage",
  receivedcomment = "receivedcomment",
  commentresponse = "commentresponse",
  Likethereceivedcomment = "Likethereceivedcomment",
  unreadmessage = "unreadmessage",
  unreadcomment = "unreadcomment",
  hiddencommenttooltip = "hiddencommenttooltip",
  vanishmode = "vanishmode",
  vanishmodeexplain = "vanishmodeexplain",
  totalcomments = "totalcomments",
  unansweredcomments = "unansweredcomments",
  totalcommenters = "totalcommenters",
  Welcometodirectmessages = "Welcometodirectmessages",
  commentmanagement = "commentmanagement",
  ticketmanagement = "ticketmanagement",
  flowmanagement = "flowmanagement",
  QuickReplyexplain = "QuickReplyexplain",
  autocommentReply = "autocommentReply",
  // #endregion Message Section  // #region 5️⃣Market Section
  // 5️⃣ Market -> home
  biolinkHomerating = "biolinkHomerating",
  biolinkHomefollower = "biolinkHomefollower",
  biolinkHomepost = "biolinkHomepost",
  biolinkHomeAllMarkets = "biolinkHomeAllMarkets",
  biolinkHomeAdvertise = "biolinkHomeAdvertise",
  biolinkHomeAdvertiser = "biolinkHomeAdvertiser",
  biolinkHomeStore = "biolinkHomeStore",

  // 5️⃣ Market -> statistics

  biolinkStatisticsAllLinkclicks = "biolinkStatisticsAllLinkclicks",
  biolinkStatisticsMarketviews = "biolinkStatisticsMarketviews",
  biolinkStatisticsmostview = "biolinkStatisticsmostview",
  biolinkStatisticscouponcodeused = "biolinkStatisticscouponcodeused",
  biolinkStatisticslastupdate = "biolinkStatisticslastupdate",
  biolinkStatisticsAllsearches = "biolinkStatisticsAllsearches",
  biolinkStatisticsfeatures = "biolinkStatisticsfeatures",
  biolinkStatisticsVisits = "biolinkStatisticsVisits",
  biolinkStatisticsClicksAndInteractions = "biolinkStatisticsClicksAndInteractions",
  biolinkStatisticsVisitsConverted = "biolinkStatisticsVisitsConverted",
  biolinkStatisticsQuickUserExitAfterEntry = "biolinkStatisticsQuickUserExitAfterEntry",
  biolinkStatisticsNoInteractionExit = "biolinkStatisticsNoInteractionExit",
  biolinkStatisticsMaxClicksPerVisit = "biolinkStatisticsMaxClicksPerVisit",
  biolinkStatisticsAvgClicksAndInteractionsPerVisitor = "biolinkStatisticsAvgClicksAndInteractionsPerVisitor",
  biolinkStatisticsTotalVisitTime = "biolinkStatisticsTotalVisitTime",
  biolinkStatisticsAvgVisitTime = "biolinkStatisticsAvgVisitTime",
  biolinkStatisticsVideoPlatformsComparison = "biolinkStatisticsVideoPlatformsComparison",
  biolinkStatisticsYoutube = "biolinkStatisticsYoutube",
  biolinkStatisticsAparat = "biolinkStatisticsAparat",
  biolinkStatisticsTwitch = "biolinkStatisticsTwitch",
  biolinkStatisticsPlatformEntry = "biolinkStatisticsPlatformEntry",
  biolinkStatisticsRedirectEvent = "biolinkStatisticsRedirectEvent",
  biolinkStatisticsPlayVideo = "biolinkStatisticsPlayVideo",
  biolinkStatisticsPlayEvent = "biolinkStatisticsPlayEvent",
  biolinkStatisticsUniqueVisit = "biolinkStatisticsUniqueVisit",
  biolinkStatisticsDedicatedLinkVisits = "biolinkStatisticsDedicatedLinkVisits",
  biolinkStatisticsCombinedLinkVisits = "biolinkStatisticsCombinedLinkVisits",
  // 5️⃣ Market -> Properties
  biolinkPropertiesfeatures = "biolinkPropertiesfeatures",
  biolinkPropertiesProfileInfoBanner = "biolinkPropertiesProfileInfoBanner",
  biolinkPropertiesFeaturebox = "biolinkPropertiesFeaturebox",
  biolinkPropertiesTermsAndActiveTime = "biolinkPropertiesTermsAndActiveTime",
  biolinkPropertiesFeatureboxexplain = "biolinkPropertiesFeatureboxexplain",
  biolinkPropertiesBanner = "biolinkPropertiesBanner",
  biolinkPropertiesFeaturesBox = "biolinkPropertiesFeaturesBox",
  biolinkPropertiesReviews = "biolinkPropertiesReviews",
  biolinkPropertiesAnnouncements = "biolinkPropertiesAnnouncements",
  biolinkPropertiesAnnouncementsexplain = "biolinkPropertiesAnnouncementsexplain",
  biolinkPropertiesOnlineStream = "biolinkPropertiesOnlineStream",
  biolinkPropertiesOnlineStreamexplain = "biolinkPropertiesOnlineStreamexplain",
  biolinkPropertiesLastVideo = "biolinkPropertiesLastVideo",
  biolinkPropertiesLastVideoexplain = "biolinkPropertiesLastVideoexplain",
  biolinkPropertiesProducts = "biolinkPropertiesProducts",
  biolinkPropertiesProduct = "biolinkPropertiesProduct",
  biolinkProperties_showLast10Products = "biolinkProperties_showLast10Products",
  biolinkProperties_showBestSellingProducts = "biolinkProperties_showBestSellingProducts",
  biolinkPropertiesAdsTimeline = "biolinkPropertiesAdsTimeline",
  biolinkPropertiesQandABox = "biolinkPropertiesQandABox",
  biolinkPropertiesLinkShortcut = "biolinkPropertiesLinkShortcut",
  biolinkPropertiesContactAndMap = "biolinkPropertiesContactAndMap",
  biolinkPropertieslinks = "biolinkPropertieslinks",
  clickonstreamvideo = "clickonstreamvideo",
  live = "live",
  livestarted = "livestarted",
  biolinkPropertiesaddnew = "biolinkPropertiesaddnew",
  biolinkProperties_DomainManager = "biolinkProperties_DomainManager",
  biolinkProperties_DomainManagerexplain = "biolinkProperties_DomainManagerexplain",
  biolinkProperties_explain = "biolinkProperties_explain",
  biolinkProperties_rejected = "biolinkProperties_rejected",
  customDomain_inactive_title = "customDomain_inactive_title",
  customDomain_inactive_desc = "customDomain_inactive_desc",
  customDomain_noPackage_title = "customDomain_noPackage_title",
  customDomain_noPackage_desc = "customDomain_noPackage_desc",

  customDomain_rule_validChars = "customDomain_rule_validChars",
  customDomain_rule_noUnderscore = "customDomain_rule_noUnderscore",
  customDomain_rule_noSubdomain = "customDomain_rule_noSubdomain",
  biolinkProperties_followersrate = "biolinkProperties_followersrate",
  biolinkProperties_followersrateExplain = "biolinkProperties_followersrateExplain",
  biolinkProperties_successRating = "biolinkProperties_successRating",
  biolinkProperties_successRatingExplain = "biolinkProperties_successRatingExplain",
  biolinkProperties_bussinessHours = "biolinkProperties_bussinessHours",
  biolinkProperties_bussinessHoursExplain = "biolinkProperties_bussinessHoursExplain",
  biolinkProperties_Enamadverified = "biolinkProperties_Enamadverified",
  biolinkProperties_EnamadverifiedExplain = "biolinkProperties_EnamadverifiedExplain",
  biolinkProperties_BusinessTerms = "biolinkProperties_BusinessTerms",
  biolinkProperties_BusinessTermsExplain = "biolinkProperties_BusinessTermsExplain",
  biolinkProperties_tariff = "biolinkProperties_tariff",
  biolinkProperties_TariffExplain = "biolinkProperties_TariffExplain",
  biolinkProperties_StartADS = "biolinkProperties_StartADS",
  biolinkProperties_StartADSExplain = "biolinkProperties_StartADSExplain",
  biolinkProperties_StartSALES = "biolinkProperties_StartSALES",
  biolinkProperties_StartSALESExplain = "biolinkProperties_StartSALESExplain",
  biolinkProperties_NameServers = "biolinkProperties_NameServers",
  biolinkProperties_NameServersExplain = "biolinkProperties_NameServersExplain",
  customDomain_dnsError = "customDomain_dnsError",
  customDomain_active_desc = "customDomain_active_desc",
  biolinkProperties_NameServerstooltip = "biolinkProperties_NameServerstooltip",
  biolinkProperties_yourstore = "biolinkProperties_yourstore",
  biolinkProperties_yourads = "biolinkProperties_yourads",
  biolinkProperties_yourlottery = "biolinkProperties_yourlottery",
  biolinkProperties_yourtariff = "biolinkProperties_yourtariff",
  biolinkProperties_yourBusinessTerms = "biolinkProperties_yourBusinessTerms",
  biolinkProperties_yourBusinesshours = "biolinkProperties_yourBusinesshours",
  biolinkProperties_Request = "biolinkProperties_Request",
  biolinkProperties_Connect = "biolinkProperties_Connect",
  biolinkProperties_Requested = "biolinkProperties_Requested",
  biolinkProperties_Checking = "biolinkProperties_Checking",
  biolinkProperties_defaultAddress = "biolinkProperties_defaultAddress",
  biolinkProperties_DomainManagerexplain2 = "biolinkProperties_DomainManagerexplain2",
  biolinkProperties_CustomAddress = "biolinkProperties_CustomAddress",
  biolinkPropertiespopup_GeneralCustom = "biolinkPropertiespopup_GeneralCustom",
  biolinkPropertiespopup_socialmedia = "biolinkPropertiespopup_socialmedia",
  biolinkPropertiespopup_mediastream = "biolinkPropertiespopup_mediastream",
  biolinkPropertiespopup_clouddrivecontent = "biolinkPropertiespopup_clouddrivecontent",
  biolinkPropertiespopup_Finance = "biolinkPropertiespopup_Finance",
  Browse = "Browse",
  biolinkPropertiespopup_yourcustomIcon = "biolinkPropertiespopup_yourcustomIcon",
  linkURL = "linkURL",
  searchID = "searchID",
  searchIDexplain = "searchIDexplain",
  Boldit = "Boldit",
  Scheduletime = "Scheduletime",
  biolinkPropertiespopup_ProfileInfo = "biolinkPropertiespopup_ProfileInfo",
  biolinkPropertiespopup_Banner = "biolinkPropertiespopup_Banner",
  biolinkPropertiespopup_Personal = "biolinkPropertiespopup_Personal",
  biolinkPropertiespopup_SameasInstagramProfile = "biolinkPropertiespopup_SameasInstagramProfile",
  custom = "custom",
  advertiseProperties_biography = "advertiseProperties_biography",
  uploadbannerexplain = "uploadbannerexplain",
  Recommended = "Recommended",
  VERFIED = "VERFIED",
  SuccessADS = "SuccessADS",
  SuccessSALES = "SuccessSALES",
  StartOrder = "StartOrder",
  Startshoping = "Startshoping",
  Embed = "Embed",
  Embedexplain = "Embedexplain",
  notfound = "notfound",
  Map = "Map",
  Contact = "Contact",
  Showmap = "Showmap",
  location = "location",
  phone = "phone",
  invalidphone = "invalidphone",
  email = "email",
  invalidemail = "invalidemail",
  Address = "Address",
  showsavecontactbutton = "showsavecontactbutton",
  searching = "searching",
  copylist = "copylist",
  question = "question",
  Answer = "Answer",
  filter_most_expensive = "filter_most_expensive",
  filter_cheapest = "filter_cheapest",
  filter_newest = "filter_newest",
  filter_highest_discount = "filter_highest_discount",
  filter_all_products = "filter_all_products",
  filter_only_available = "filter_only_available",
  filter_reset = "filter_reset",
  filter_sortby = "filter_sortby",
  filter_category = "filter_category",
  filter_price = "filter_price",
  Pricerange = "Pricerange",
  from = "from",
  to = "to",
  filter_rating = "filter_rating",
  filter_followers = "filter_followers",
  default = "default",
  lowtohigh = "lowtohigh",
  hightolow = "hightolow",
  Undefined = "Undefined",
  // 6 notifications
  // #endregion Market Section
  // #region userpanel Section
  // Home
  //setting
  userpanel_market = "userpanel_market",
  userpanel_order = "userpanel_order",
  userpanel_Messages = "userpanel_Messages",
  userpanel_Settings = "userpanel_Settings",
  userpanel_PersonalInfo = "userpanel_PersonalInfo",
  userpanel_UploadNewPicture = "userpanel_UploadNewPicture",
  userpanel_Instagramid = "userpanel_Instagramid",
  userpanel_Nameandfamily = "userpanel_Nameandfamily",
  userpanel_NationalCode = "userpanel_NationalCode",
  userpanel_BirthDay = "userpanel_BirthDay",
  userpanel_MobileNumber = "userpanel_MobileNumber",
  userpanel_Email = "userpanel_Email",
  userpanel_CreditNumber = "userpanel_CreditNumber",
  userpanel_Addresses = "userpanel_Addresses",
  userpanel_AddNewAddress = "userpanel_AddNewAddress",
  userpanel_ZipCode = "userpanel_ZipCode",
  userpanel_Address = "userpanel_Address",
  userpanel_EditAddress = "userpanel_EditAddress",
  userpanel_AddNewAddressexplain = "userpanel_AddNewAddressexplain",
  userpanel_yourorders = "userpanel_yourorders",
  userpanel_SavedProducts = "userpanel_SavedProducts",
  userpanel_NoSavedProducts = "userpanel_NoSavedProducts",
  userpanel_Startexplore = "userpanel_Startexplore",
  userpanel_Startexploreexplain = "userpanel_Startexploreexplain",
  userpanel_TicketSupportExplain = "userpanel_TicketSupportExplain",
  userpanel_TicketSupport = "userpanel_TicketSupport",
  userpanel_UseInstagram = "userpanel_UseInstagram",
  userpanel_FreeProPanel = "userpanel_FreeProPanel",
  userpanel_Premiumaccount = "userpanel_Premiumaccount",
  userpanel_daysFreePremium = "userpanel_daysFreePremium",
  userpanel_LimitedOffer = "userpanel_LimitedOffer",
  Dashboard = "Dashboard",
  greeting1 = "greeting1",
  greeting2 = "greeting2",
  greeting3 = "greeting3",
  greeting4 = "greeting4",
  greeting5 = "greeting5",
  greeting6 = "greeting6",
  greeting7 = "greeting7",
  greetingtext1 = "greetingtext1",
  greetingtext2 = "greetingtext2",
  greetingtext3 = "greetingtext3",
  greetingtext4 = "greetingtext4",
  greetingtext5 = "greetingtext5",
  greetingtext6 = "greetingtext6",
  greetingtext7 = "greetingtext7",
  product_productdeleted = "product_productdeleted",
  undo = "undo",
  redo = "redo",
  notactivemessageexplain = "notactivemessageexplain",
  waitingforconnection = "waitingforconnection",
  SetScheduledPostexplain = "SetScheduledPostexplain",
  SetScheduledStoryexplain = "SetScheduledStoryexplain",
  addtoproduct = "addtoproduct",
  addtoproductexplain = "addtoproductexplain",
  TurnoffCommentingexplain = "TurnoffCommentingexplain",
  Retry = "Retry",
  page2_text1 = "page2_text1",
  page2_text2 = "page2_text2",
  // Page2 Services - Add these to your LanguageKey enum
  page2_ads_statistics_title = "page2_ads_statistics_title",
  page2_ads_statistics_description = "page2_ads_statistics_description",
  page2_ads_statistics_servicedescription = "page2_ads_statistics_servicedescription",
  page2_ads_calendar_title = "page2_ads_calendar_title",
  page2_ads_calendar_description = "page2_ads_calendar_description",
  page2_ads_calendar_servicedescription = "page2_ads_calendar_servicedescription",
  page2_ads_adlist_title = "page2_ads_adlist_title",
  page2_ads_adlist_description = "page2_ads_adlist_description",
  page2_ads_adlist_servicedescription = "page2_ads_adlist_servicedescription",
  page2_store_addproduct_title = "page2_store_addproduct_title",
  page2_store_addproduct_description = "page2_store_addproduct_description",
  page2_store_addproduct_servicedescription = "page2_store_addproduct_servicedescription",
  page2_store_productlist_title = "page2_store_productlist_title",
  page2_store_productlist_description = "page2_store_productlist_description",
  page2_store_productlist_servicedescription = "page2_store_productlist_servicedescription",
  page2_store_orders_title = "page2_store_orders_title",
  page2_store_orders_description = "page2_store_orders_description",
  page2_store_orders_servicedescription = "page2_store_orders_servicedescription",
  page2_store_statistics_title = "page2_store_statistics_title",
  page2_store_statistics_description = "page2_store_statistics_description",
  page2_store_statistics_servicedescription = "page2_store_statistics_servicedescription",
  page2_delivery_smartshipping_title = "page2_delivery_smartshipping_title",
  page2_delivery_smartshipping_description = "page2_delivery_smartshipping_description",
  page2_delivery_smartshipping_servicedescription = "page2_delivery_smartshipping_servicedescription",
  page2_delivery_postalservice_title = "page2_delivery_postalservice_title",
  page2_delivery_postalservice_description = "page2_delivery_postalservice_description",
  page2_delivery_postalservice_servicedescription = "page2_delivery_postalservice_servicedescription",
  page2_delivery_tracking_title = "page2_delivery_tracking_title",
  page2_delivery_tracking_description = "page2_delivery_tracking_description",
  page2_delivery_tracking_servicedescription = "page2_delivery_tracking_servicedescription",
  page2_jobs_subadmin_title = "page2_jobs_subadmin_title",
  page2_jobs_subadmin_description = "page2_jobs_subadmin_description",
  page2_jobs_subadmin_servicedescription = "page2_jobs_subadmin_servicedescription",
  page2_ids_store_title = "page2_ids_store_title",
  page2_ids_store_description = "page2_ids_store_description",
  page2_ids_store_servicedescription = "page2_ids_store_servicedescription",
  page2_publish_contentmanagement_title = "page2_publish_contentmanagement_title",
  page2_publish_contentmanagement_description = "page2_publish_contentmanagement_description",
  page2_publish_contentmanagement_servicedescription = "page2_publish_contentmanagement_servicedescription",
  page2_publish_contentpublishing_title = "page2_publish_contentpublishing_title",
  page2_publish_contentpublishing_description = "page2_publish_contentpublishing_description",
  page2_publish_contentpublishing_servicedescription = "page2_publish_contentpublishing_servicedescription",
  page2_publish_analytics_title = "page2_publish_analytics_title",
  page2_publish_analytics_description = "page2_publish_analytics_description",
  page2_publish_analytics_servicedescription = "page2_publish_analytics_servicedescription",
  page2_publish_statistics_title = "page2_publish_statistics_title",
  page2_publish_statistics_description = "page2_publish_statistics_description",
  page2_publish_statistics_servicedescription = "page2_publish_statistics_servicedescription",
  page2_extension_biolink_title = "page2_extension_biolink_title",
  page2_extension_biolink_description = "page2_extension_biolink_description",
  page2_extension_biolink_servicedescription = "page2_extension_biolink_servicedescription",
  page2_extension_paymentgateway_title = "page2_extension_paymentgateway_title",
  page2_extension_paymentgateway_description = "page2_extension_paymentgateway_description",
  page2_extension_paymentgateway_servicedescription = "page2_extension_paymentgateway_servicedescription",
  page2_extension_customwebsite_title = "page2_extension_customwebsite_title",
  page2_extension_customwebsite_description = "page2_extension_customwebsite_description",
  page2_extension_customwebsite_servicedescription = "page2_extension_customwebsite_servicedescription",
  // Page4 - Menu Items
  page4_menu_instagram_management = "page4_menu_instagram_management",
  page4_menu_admin_subadmin = "page4_menu_admin_subadmin",
  page4_menu_store_shipping = "page4_menu_store_shipping",
  page4_menu_advertising = "page4_menu_advertising",
  page4_menu_hashtag_management = "page4_menu_hashtag_management",
  page4_menu_ai_analysis = "page4_menu_ai_analysis",
  page4_menu_ad_scheduling = "page4_menu_ad_scheduling",
  page4_menu_financial_wallet = "page4_menu_financial_wallet",
  page4_menu_page_statistics = "page4_menu_page_statistics",
  page4_menu_professional_messaging = "page4_menu_professional_messaging",

  // Page4 - Content Data
  page4_content_instagram_management_text = "page4_content_instagram_management_text",
  page4_content_admin_subadmin_text = "page4_content_admin_subadmin_text",
  page4_content_store_shipping_text = "page4_content_store_shipping_text",
  page4_content_advertising_text = "page4_content_advertising_text",
  page4_content_hashtag_management_text = "page4_content_hashtag_management_text",
  page4_content_ai_analysis_text = "page4_content_ai_analysis_text",
  page4_content_ad_scheduling_text = "page4_content_ad_scheduling_text",
  page4_content_financial_wallet_text = "page4_content_financial_wallet_text",
  page4_content_page_statistics_text = "page4_content_page_statistics_text",
  page4_content_professional_messaging_text = "page4_content_professional_messaging_text",
  shipping = "shipping",
  jobs = "jobs",
  IDstore = "IDstore",
  page3_text1 = "page3_text1",
  page5_whyBrancy = "page5_whyBrancy",
  page9_planheader = "page9_planheader",
  page9_planexplain = "page9_planexplain",
  page9_plantitle = "page9_plantitle",

  page9_freeplan = "page9_freeplan",
  page9_proplan = "page9_proplan",
  page9_adsplan = "page9_adsplan",
  page9_storeplan = "page9_storeplan",
  page9_basicplan = "page9_basicplan",
  page9_monthly = "page9_monthly",
  page9_Compare = "page9_Compare",
  page9_content_management = "page9_content_management",
  page9_analize_management = "page9_analize_management",
  page9_message_management = "page9_message_management",
  page9_biolink_management = "page9_biolink_management",
  page9_subadmin_management = "page9_subadmin_management",
  page9_basicoption = "page9_basicoption",
  page9_ticket_management = "page9_ticket_management",
  page9_finance_management = "page9_finance_management",
  page9_store_management = "page9_store_management",
  page9_logestic_management = "page9_logestic_management",
  page9_storeanalize_management = "page9_storeanalize_management",
  page9_calendar_management = "page9_calendar_management",
  page9_advertise_management = "page9_advertise_management",
  page9_adsanalize_management = "page9_adsanalize_management",
  page9_campagin_management = "page9_campagin_management",
  page9_adsticket_management = "page9_adsticket_management",
  Beginner = "Beginner",
  Basic = "Basic",
  Growing = "Growing",
  Advanced = "Advanced",
  Professional = "Professional",

  Special = "Special",
  page6_Header = "page6_Header",
  page6_Explain = "page6_Explain",
  page5_title1 = "page5_title1",
  page5_explain1 = "page5_explain1",
  page5_title2 = "page5_title2",
  page5_explain2 = "page5_explain2",
  page5_title3 = "page5_title3",
  page5_explain3 = "page5_explain3",
  page5_title4 = "page5_title4",
  page5_explain4 = "page5_explain4",
  page5_title5 = "page5_title5",
  page5_explain5 = "page5_explain5",
  page5_title6 = "page5_title6",
  page5_explain6 = "page5_explain6",
  page10_header = "page10_header",
  footer_Brancy = "footer_Brancy",
  footer_AboutUs = "footer_AboutUs",
  // About Us Page
  aboutUs_pageTitle = "aboutUs_pageTitle",
  aboutUs_metaDescription = "aboutUs_metaDescription",
  aboutUs_subtitle = "aboutUs_subtitle",
  aboutUs_ourStoryTitle = "aboutUs_ourStoryTitle",
  aboutUs_ourStoryPara1 = "aboutUs_ourStoryPara1",
  aboutUs_ourStoryPara2 = "aboutUs_ourStoryPara2",
  aboutUs_innovationTitle = "aboutUs_innovationTitle",
  aboutUs_innovationPara1 = "aboutUs_innovationPara1",
  aboutUs_innovationPara2 = "aboutUs_innovationPara2",
  aboutUs_coreValuesTitle = "aboutUs_coreValuesTitle",
  aboutUs_innovationFirstTitle = "aboutUs_innovationFirstTitle",
  aboutUs_innovationFirstDesc = "aboutUs_innovationFirstDesc",
  aboutUs_trustSecurityTitle = "aboutUs_trustSecurityTitle",
  aboutUs_trustSecurityDesc = "aboutUs_trustSecurityDesc",
  aboutUs_globalCommunityTitle = "aboutUs_globalCommunityTitle",
  aboutUs_globalCommunityDesc = "aboutUs_globalCommunityDesc",
  aboutUs_sustainableGrowthTitle = "aboutUs_sustainableGrowthTitle",
  aboutUs_sustainableGrowthDesc = "aboutUs_sustainableGrowthDesc",
  aboutUs_userEmpowermentTitle = "aboutUs_userEmpowermentTitle",
  aboutUs_userEmpowermentDesc = "aboutUs_userEmpowermentDesc",
  aboutUs_continuousEvolutionTitle = "aboutUs_continuousEvolutionTitle",
  aboutUs_continuousEvolutionDesc = "aboutUs_continuousEvolutionDesc",
  aboutUs_globalImpactTitle = "aboutUs_globalImpactTitle",
  aboutUs_globalImpactPara = "aboutUs_globalImpactPara",
  aboutUs_activeUsers = "aboutUs_activeUsers",
  aboutUs_countries = "aboutUs_countries",
  aboutUs_uptime = "aboutUs_uptime",
  aboutUs_support = "aboutUs_support",
  aboutUs_teamTitle = "aboutUs_teamTitle",
  aboutUs_teamPara1 = "aboutUs_teamPara1",
  aboutUs_teamPara2 = "aboutUs_teamPara2",
  footer_ContactUs = "footer_ContactUs",
  footer_JoinUs = "footer_JoinUs",
  footer_OrgChart = "footer_OrgChart",
  footer_FollowUs = "footer_FollowUs",
  footer_Solutions = "footer_Solutions",
  footer_HelpCenter = "footer_HelpCenter",
  footer_Support = "footer_Support",
  footer_FAQ = "footer_FAQ",
  footer_ReportAnIssue = "footer_ReportAnIssue",
  footer_TrustLegal = "footer_TrustLegal",
  footer_TermsAndConditions = "footer_TermsAndConditions",
  footer_PrivacyNotice = "footer_PrivacyNotice",
  footer_CookieNotice = "footer_CookieNotice",
  footer_Blog = "footer_Blog",
  footer_ProductUpdates = "footer_ProductUpdates",
  footer_Articles = "footer_Articles",
  footer_LatestNews = "footer_LatestNews",

  // Join Us page
  joinUs_subtitle = "joinUs_subtitle",
  joinUs_whyWorkWithUs = "joinUs_whyWorkWithUs",
  joinUs_whyWorkWithUsDescription = "joinUs_whyWorkWithUsDescription",
  joinUs_openPositions = "joinUs_openPositions",
  joinUs_openPositionsDescription = "joinUs_openPositionsDescription",
  joinUs_frontendDeveloper = "joinUs_frontendDeveloper",
  joinUs_frontendDeveloperDescription = "joinUs_frontendDeveloperDescription",
  joinUs_backendDeveloper = "joinUs_backendDeveloper",
  joinUs_backendDeveloperDescription = "joinUs_backendDeveloperDescription",
  joinUs_uiUxDesigner = "joinUs_uiUxDesigner",
  joinUs_uiUxDesignerDescription = "joinUs_uiUxDesignerDescription",
  joinUs_productManager = "joinUs_productManager",
  joinUs_productManagerDescription = "joinUs_productManagerDescription",
  joinUs_marketingSpecialist = "joinUs_marketingSpecialist",
  joinUs_marketingSpecialistDescription = "joinUs_marketingSpecialistDescription",
  joinUs_customerSupport = "joinUs_customerSupport",
  joinUs_customerSupportDescription = "joinUs_customerSupportDescription",
  joinUs_engineering = "joinUs_engineering",
  joinUs_design = "joinUs_design",
  joinUs_product = "joinUs_product",
  joinUs_marketing = "joinUs_marketing",
  joinUs_support = "joinUs_support",
  joinUs_remoteOnsite = "joinUs_remoteOnsite",
  joinUs_onsite = "joinUs_onsite",
  joinUs_remote = "joinUs_remote",
  joinUs_fullTime = "joinUs_fullTime",
  joinUs_partTimeFullTime = "joinUs_partTimeFullTime",
  joinUs_applyNow = "joinUs_applyNow",
  joinUs_applicationProcess = "joinUs_applicationProcess",
  joinUs_submitApplication = "joinUs_submitApplication",
  joinUs_submitApplicationDescription = "joinUs_submitApplicationDescription",
  joinUs_initialScreening = "joinUs_initialScreening",
  joinUs_initialScreeningDescription = "joinUs_initialScreeningDescription",
  joinUs_technicalInterview = "joinUs_technicalInterview",
  joinUs_technicalInterviewDescription = "joinUs_technicalInterviewDescription",
  joinUs_finalInterview = "joinUs_finalInterview",
  joinUs_finalInterviewDescription = "joinUs_finalInterviewDescription",
  joinUs_welcomeAboard = "joinUs_welcomeAboard",
  joinUs_welcomeAboardDescription = "joinUs_welcomeAboardDescription",
  joinUs_readyToJoinUs = "joinUs_readyToJoinUs",
  joinUs_readyToJoinUsDescription = "joinUs_readyToJoinUsDescription",
  joinUs_sendYourResume = "joinUs_sendYourResume",

  page8_HelpCenter = "page8_HelpCenter",
  page8_Community = "page8_Community",
  page8_learn = "page8_learn",
  page8_Blog = "page8_Blog",
  page8_FAQ = "page8_FAQ",
  page8_Support = "page8_Support",
  support_Online = "support_Online",
  support_EnterBlog = "support_EnterBlog",
  page8_CommunityExplain = "page8_CommunityExplain",
  page8_learnExplain = "page8_learnExplain",
  page8_BlogExplain = "page8_BlogExplain",
  page8_FAQExplain = "page8_FAQExplain",
  page8_SupportExplain = "page8_SupportExplain",
  page8_CommunityBTN = "page8_CommunityBTN",
  page8_learnBTN = "page8_learnBTN",
  page8_BlogBTN = "page8_BlogBTN",
  page8_FAQBTN = "page8_FAQBTN",
  page8_SupportBTN = "page8_SupportBTN",
  page1_text1 = "page1_text1",
  page1_text2 = "page1_text2",
  page1_services = "page1_services",
  page1_analytics = "page1_analytics",
  page1_transportation = "page1_transportation",
  page1_financial_solutions = "page1_financial_solutions",
  page1_customer_communication = "page1_customer_communication",
  page1_content_management = "page1_content_management",
  page1_artificial_intelligence = "page1_artificial_intelligence",
  page1_tools = "page1_tools",
  page1_advertises = "page1_advertises",
  page1_StartNow = "page1_StartNow",
  Storeproduct_yourcartisempty = "Storeproduct_yourcartisempty",
  Storeproduct_noitemfounded = "Storeproduct_noitemfounded",
  startbusiness = "startbusiness",
  AI = "AI",
  ExtraTokens = "ExtraTokens",
  TokenUsage = "TokenUsage",
  aiSuggestedPrompts_title = "aiSuggestedPrompts_title",
  aiSuggestedPrompts_openImage = "aiSuggestedPrompts_openImage",
  aiSuggestedPrompts_explain = "aiSuggestedPrompts_explain",
  aiSuggestedPrompts_category = "aiSuggestedPrompts_category",
  aiSuggestedPrompts_subCategory = "aiSuggestedPrompts_subCategory",
  aiSuggestedPrompts_allCategories = "aiSuggestedPrompts_allCategories",
  aiSuggestedPrompts_loading = "aiSuggestedPrompts_loading",
  aiSuggestedPrompts_empty = "aiSuggestedPrompts_empty",
  aiSuggestedPrompts_loadMore = "aiSuggestedPrompts_loadMore",
  aiSuggestedPrompts_prompt = "aiSuggestedPrompts_prompt",
  aiSuggestedPrompts_copy = "aiSuggestedPrompts_copy",
  aiSuggestedPrompts_showMore = "aiSuggestedPrompts_showMore",
  aiSuggestedPrompts_showLess = "aiSuggestedPrompts_showLess",
  AdvancedAnalytics = "AdvancedAnalytics",
  AIResponse = "AIResponse",
  CustomSupport = "CustomSupport",
  CustomDomain = "CustomDomain",
  WinnerPicker = "WinnerPicker",
  WinnerPickerReserve = "WinnerPickerReserve",

  dataTable1_feature1 = "dataTable1_feature1",
  dataTable1_tooltip1 = "dataTable1_tooltip1",
  dataTable1_feature2 = "dataTable1_feature2",
  dataTable1_tooltip2 = "dataTable1_tooltip2",
  dataTable1_feature3 = "dataTable1_feature3",
  dataTable1_tooltip3 = "dataTable1_tooltip3",
  dataTable1_feature4 = "dataTable1_feature4",
  dataTable1_tooltip4 = "dataTable1_tooltip4",
  dataTable1_feature5 = "dataTable1_feature5",
  dataTable1_tooltip5 = "dataTable1_tooltip5",
  dataTable1_feature6 = "dataTable1_feature6",
  dataTable1_tooltip6 = "dataTable1_tooltip6",
  dataTable1_feature7 = "dataTable1_feature7",
  dataTable1_tooltip7 = "dataTable1_tooltip7",
  dataTable1_feature8 = "dataTable1_feature8",
  dataTable1_tooltip8 = "dataTable1_tooltip8",
  dataTable1_feature9 = "dataTable1_feature9",
  dataTable1_tooltip9 = "dataTable1_tooltip9",
  SwitchtoUserpanel = "SwitchtoUserpanel",
  marketpropertise_aboutus = "marketpropertise_aboutus",
  marketpropertise_copyright = "marketpropertise_copyright",
  marketpropertise_aboutusslogan = "marketpropertise_aboutusslogan",
  marketpropertise_madeby = "marketpropertise_madeby",
  addnewaccount = "addnewaccount",
  addedaccounts = "addedaccounts",
  SwitchtoAccount = "SwitchtoAccount",
  accountmanagement = "accountmanagement",
  SwitchtoAccountexplain = "SwitchtoAccountexplain",
  subadmininvitation = "subadmininvitation",
  subadmininvitationexplain = "subadmininvitationexplain",
  Addfaq = "Addfaq",
  addfaqexplain = "addfaqexplain",
  faqEmptyState = "faqEmptyState",
  chooselanguage = "chooselanguage",
  chooselanguageExplain = "chooselanguageExplain",
  chooseTheme = "chooseTheme",
  chooseThemeExplain = "chooseThemeExplain",
  chooseCalendar = "chooseCalendar",
  chooseCalendarExplain = "chooseCalendarExplain",
  setupchooseexplain = "setupchooseexplain",
  upgradeyouraccount = "upgradeyouraccount",
  featureNotAvailable = "featureNotAvailable",
  featureNotAvailableDesc = "featureNotAvailableDesc",
  likeaprouser = "likeaprouser",
  followerrate = "followerrate",
  bestposts = "bestposts",
  Unavailable = "Unavailable ",
  shoppertitle = "shoppertitle",
  advertisertitle = "advertisertitle",
  shopperdescription = "shopperdescription",
  advertiserdescription = "advertiserdescription",
  syncingAccountTitle = "syncingAccountTitle",
  syncingAccountDescriptiontooltip = "syncingAccountDescriptiontooltip",
  syncingAccountDescription = "syncingAccountDescription",
  subscriptionExpiringTitle = "subscriptionExpiringTitle",
  subscriptionExpiringDescription = "subscriptionExpiringDescription",
  subscriptionDaysRemaining = "subscriptionDaysRemaining",
  order_addressSubject = "order_addressSubject",
  order_addressReceiver = "order_addressReceiver",
  order_addressNote = "order_addressNote",
  level = "level",
  economy = "economy",
  professional = "professional",
  Generating = "Generating",
  ImagineSomething = "ImagineSomething",
  Aipromptexplain = "Aipromptexplain",
  WithStrongCallToAction = "WithStrongCallToAction",
  WithProsAndCons = "WithProsAndCons",
  ForComparison = "ForComparison",
  WithKeyPoints = "WithKeyPoints",
  ForPromotionalPost = "ForPromotionalPost",
  WithDetailedExplanation = "WithDetailedExplanation",
  PersuasiveStyle = "PersuasiveStyle",
  ForProductIntroduction = "ForProductIntroduction",
  LongText = "LongText",
  AccessAndManageComments = "AccessAndManageComments",
  AccessAndManageCommentsExplain = "AccessAndManageCommentsExplain",
  AccessAndManageMessages = "AccessAndManageMessages",
  AccessAndManageMessagesExplain = "AccessAndManageMessagesExplain",
  AccessAndPublishContent = "AccessAndPublishContent",
  AccessAndPublishContentExplain = "AccessAndPublishContentExplain",
  AccessAndManageInsights = "AccessAndManageInsights",
  AccessAndManageInsightsExplain = "AccessAndManageInsightsExplain",
  EnablePermission = "EnablePermission",
  connectTutorial = "connectTutorial",
  invalidcode = "invalidcode",
  instagramremoveStep1Title = "instagramremoveStep1Title",
  instagramremoveStep1text = "instagramremoveStep1text",
  instagramremoveStep2Title = "instagramremoveStep2Title",
  instagramremoveStep2text = "instagramremoveStep2text",
  wearesorry = "wearesorry",
  PaymentFailed = "PaymentFailed",
  TransactionNumber = "TransactionNumber",
  TransactiontrackingNumber = "TransactiontrackingNumber",
  InvoiceNumber = "InvoiceNumber",
  thankyou = "thankyou",
  Paymentsuccess = "Paymentsuccess",
  mainSubscriptionPlan = "mainSubscriptionPlan",
  Tokens = "Tokens",
  ReserveToken = "ReserveToken",
  tokenExplain = "tokenExplain",
  packageTokenExplain = "packageTokenExplain",
  ReserveTokenExplain = "ReserveTokenExplain",
  pageTools_Months = "pageTools_Months",
  subscriptionExpired = "subscriptionExpired",
  subscriptionExpireSoon = "subscriptionExpireSoon",
  subscriptionManagement = "subscriptionManagement",
  subscription = "subscription",
  AIAssisment = "AIAssisment",
  timeperiod = "timeperiod",
  domain = "domain",
  winnerpickerexpired = "winnerpickerexpired",
  winnerpickerexpiresoon = "winnerpickerexpiresoon",
  Aiexpired = "Aiexpired",
  Aiexpiresoon = "Aiexpiresoon",
  followercount = "followercount",
  yourCurrentSubscription = "yourCurrentSubscription",
  notimelimit = "notimelimit",
  noItemsAvailableContactSupport = "noItemsAvailableContactSupport",
  // #endregion userpanel Section
  autosave = "autosave",
  // #region AIFlow Section
  AIAssismentexplain = "AIAssismentexplain",
  livetest = "livetest",
  promptmode = "promptmode",
  promptanalysis = "promptanalysis",
  promptanalysisplaceholder = "promptanalysisplaceholder",
  reanalyze = "reanalyze",
  shouldFollowerexplain = "shouldFollowerexplain",
  RenewForThread = "RenewForThread",
  RenewForThreadexplain = "RenewForThreadexplain",
  prompt = "prompt",
  testlab = "testlab",
  Flow = "Flow",
  Restrictorzoom = "Restrictorzoom",
  flowtitle = "flowtitle",
  snapGrid = "snapGrid",
  PanningBoundary = "PanningBoundary",
  AIFlow_input_message_block = "AIFlow_input_message_block",
  AIFlow_Deleteallblocks_alert = "AIFlow_Deleteallblocks_alert",
  AIFlow_onmessage = "AIFlow_onmessage",
  AIFlow_onmessage_description = "AIFlow_onmessage_description",
  AIFlow_input = "AIFlow_input",
  AIFlow_output = "AIFlow_output",
  AIFlow_text = "AIFlow_text",
  AIFlow_text_block = "AIFlow_text_block",
  AIFlow_weblink_block = "AIFlow_weblink_block",
  AIFlow_image_block = "AIFlow_image_block",
  AIFlow_generic_block = "AIFlow_generic_block",
  AIFlow_voice_block = "AIFlow_voice_block",
  AIFlow_quick_reply_block = "AIFlow_quick_reply_block",
  AIFlow_image_uploaded = "AIFlow_image_uploaded",
  AIFlow_upload_image = "AIFlow_upload_image",
  AIFlow_voice_recorded = "AIFlow_voice_recorded",
  AIFlow_record_voice = "AIFlow_record_voice",
  AIFlow_record_voice_confirm = "AIFlow_record_voice_confirm",
  AIFlow_play_voice = "AIFlow_play_voice",
  AIFlow_quick_reply = "AIFlow_quick_reply",
  AIFlow_block_title_required = "AIFlow_block_title_required",
  AIFlow_item_title = "AIFlow_item_title",
  AIFlow_show_graph = "AIFlow_show_graph",
  AIFlow_connect_post = "AIFlow_connect_post",
  AIFlow_connect_post_access = "AIFlow_connect_post_access",
  AIFlow_connect_post_save_first = "AIFlow_connect_post_save_first",
  AIFlow_connect_post_confirm = "AIFlow_connect_post_confirm",
  AIFlow_connect_post_resume = "AIFlow_connect_post_resume",
  AIFlow_connect_post_incompatible = "AIFlow_connect_post_incompatible",
  AIFlow_retry = "AIFlow_retry",
  AIPrompt_connect_post_access = "AIPrompt_connect_post_access",
  AIPrompt_connect_post_confirm = "AIPrompt_connect_post_confirm",
  AIPrompt_connect_post_resume = "AIPrompt_connect_post_resume",
  messagesetting_PhoneNumbers = "messagesetting_PhoneNumbers",
  messagesetting_PhoneNumbersExplain = "messagesetting_PhoneNumbersExplain",
  messagesetting_PhoneNumbersEmpty = "messagesetting_PhoneNumbersEmpty",
  AIFlow_item_subtitle = "AIFlow_item_subtitle",
  AIFlow_link = "AIFlow_link",
  AIFlow_option_title = "AIFlow_option_title",
  AIFlow_output_title = "AIFlow_output_title",
  AIFlow_add_output = "AIFlow_add_output",
  AIFlow_add_image = "AIFlow_add_image",
  AIFlow_add_subtitle = "AIFlow_add_subtitle",
  AIFlow_delete_all_block = "AIFlow_delete_all_block",
  AIFlow_delete = "AIFlow_delete",
  AIFlow_delete_image = "AIFlow_delete_image",
  AIFlow_add_text_block = "AIFlow_add_text_block",
  AIFlow_add_image_block = "AIFlow_add_image_block",
  AIFlow_add_voice_block = "AIFlow_add_voice_block",
  AIFlow_add_quick_reply_block = "AIFlow_add_quick_reply_block",
  AIFlow_add_general_block = "AIFlow_add_general_block",
  AIFlow_delete_all_blocks = "AIFlow_delete_all_blocks",
  AIFlow_save_all_blocks = "AIFlow_save_all_blocks",
  AIFlow_add_weblink_block = "AIFlow_add_weblink_block",
  AIFlow_live_test_block = "AIFlow_live_test_block",
  AIFlow_option_default = "AIFlow_option_default",
  AIFlow_general_type = "AIFlow_general_type",
  AIFlow_upload_image_button = "AIFlow_upload_image_button",
  AIFlow_delete_image_button = "AIFlow_delete_image_button",
  AIFlow_voice_fetch_error = "AIFlow_voice_fetch_error",
  AIFlow_add_new_item = "AIFlow_add_new_item",
  AIFlow_delete_confirm = "AIFlow_delete_confirm",
  AIFlow_delete_image_text = "AIFlow_delete_image_text",
  AIFlow_upload_image_text = "AIFlow_upload_image_text",
  AIFlow_general_emoji = "AIFlow_general_emoji",
  AutoLayout_block = "AutoLayout_block",
  AIFlow_general_option = "AIFlow_general_option",
  AIFlow_add_output_error = "AIFlow_add_output_error",
  AIFlow_subtitle_input = "AIFlow_subtitle_input",
  AIFlow_subtitle_success = "AIFlow_subtitle_success",
  AIFlow_media_recorder_error = "AIFlow_media_recorder_error",
  AIFlow_voice_record_error = "AIFlow_voice_record_error",
  AIFlow_upload_error = "AIFlow_upload_error",
  AIFlow_file_upload_error = "AIFlow_file_upload_error",
  AIFlow_editor_init_error = "AIFlow_editor_init_error",
  AIFlow_json_parse_error = "AIFlow_json_parse_error",
  AIFlow_position_error = "AIFlow_position_error",
  AIFlow_node_remove_error = "AIFlow_node_remove_error",
  AIFlow_connection_error = "AIFlow_connection_error",
  AIFlow_generic_connection_error = "AIFlow_generic_connection_error",
  AIFlow_voice_play_error = "AIFlow_voice_play_error",
  AIFlow_node_connection_warning = "AIFlow_node_connection_warning",
  AIFlow_unknown_value_type = "AIFlow_unknown_value_type",
  AIFlow_unknown_block_type_alert = "AIFlow_unknown_block_type_alert",
  AIFlow_min_output_required = "AIFlow_min_output_required",
  AIFlow_generic_item_connection_only = "AIFlow_generic_item_connection_only",
  AIFlow_weblink_generic_item_only = "AIFlow_weblink_generic_item_only",
  AIFlow_voice_record_failed = "AIFlow_voice_record_failed",
  AIFlow_voice_record_success = "AIFlow_voice_record_success",
  AIFlow_voice_upload_failed = "AIFlow_voice_upload_failed",
  AIFlow_voice_record_empty = "AIFlow_voice_record_empty",
  AIFlow_voice_record_start = "AIFlow_voice_record_start",
  AIFlow_quick_reply_validation_error = "AIFlow_quick_reply_validation_error",
  AIFlow_generic_item_validation_error = "AIFlow_generic_item_validation_error",
  AIFlow_weblink_validation_error = "AIFlow_weblink_validation_error",
  AIFlow_no_on_message_node = "AIFlow_no_on_message_node",
  AIFlow_max_quick_reply_outputs = "AIFlow_max_quick_reply_outputs",
  AIFlow_max_generic_outputs = "AIFlow_max_generic_outputs",
  AIFlow_session_invalid = "AIFlow_session_invalid",
  AIFlow_add_output_error_alert = "AIFlow_add_output_error_alert",
  AIFlow_empty_title_for_flow_alert = "AIFlow_empty_title_for_flow_alert",
  AIFlow_multiple_flow_for_private_reply_alert = "AIFlow_multiple_flow_for_private_reply_alert",
  AIFlow_success = "AIFlow_success",
  AIFlow_unexpected_error = "AIFlow_unexpected_error",
  AIFlow_validation_warning = "AIFlow_validation_warning",
  AIFlow_server_error = "AIFlow_server_error",
  AIFlow_quick_reply_block_title_empty = "AIFlow_quick_reply_block_title_empty",
  AIFlow_quick_reply_option_title_empty = "AIFlow_quick_reply_option_title_empty",
  AIFlow_generic_item_title_empty_alert = "AIFlow_generic_item_title_empty_alert",
  AIFlow_generic_item_output_title_empty_alert = "AIFlow_generic_item_output_title_empty_alert",
  AIFlow_weblink_empty_alert = "AIFlow_weblink_empty_alert",
  AIFlow_weblink_incomplete_alert = "AIFlow_weblink_incomplete_alert",
  AIFlow_weblink_invalid_format_alert = "AIFlow_weblink_invalid_format_alert",
  AIFlow_weblink_non_english_alert = "AIFlow_weblink_non_english_alert",
  AIFlow_weblink_has_hyphen_alert = "AIFlow_weblink_has_hyphen_alert",
  AIFlow_item_text = "AIFlow_item_text",
  AIFlow_general_block = "AIFlow_general_block",
  AIFlow_delete_image_button_text = "AIFlow_delete_image_button_text",
  AIFlow_upload_image_button_text = "AIFlow_upload_image_button_text",
  AIFlow_weblink_connection_error = "AIFlow_weblink_connection_error",
  AI_live_test = "AI_live_test",
  Flow_imageorvideo_block = "Flow_imageorvideo_block",
  Flow_upload_imageorvideo = "Flow_upload_imageorvideo",
  flow_shortcuts_explain = "flow_shortcuts_explain",
  Flow_unsupportedbrowser = "Flow_unsupportedbrowser",
  Flow_uploadfilefailed = "Flow_uploadfilefailed",
  Flow_uploadmaxsizeexceeded = "Flow_uploadmaxsizeexceeded",
  Flow_upload_unsupported_media = "Flow_upload_unsupported_media",
  Flow_micphoneaccessdenied = "Flow_micphoneaccessdenied",
  Flow_upload_audio = "Flow_upload_audio",
  Flow_record_voice = "Flow_record_voice",
  Flow_stop_record_voice = "Flow_stop_record_voice",
  Flow_voice_recording_started = "Flow_voice_recording_started",
  Flow_areyoureadytorecord = "Flow_areyoureadytorecord",
  Flow_add_generic_sub_block = "Flow_add_generic_sub_block",
  Flow_generic_sub = "Flow_generic_sub",
  Flow_add_button = "Flow_add_button",
  Flow_quick_reply_title_placeholder = "Flow_quick_reply_title_placeholder",
  Flow_message_title = "Flow_message_title",
  Flow_message_description = "Flow_message_description",
  New_Flow_unsavedChanges = "New_Flow_unsavedChanges",
  New_Flow_addedNodes = "New_Flow_addedNodes",
  New_Flow_removedNodes = "New_Flow_removedNodes",
  New_Flow_modifiedNodes = "New_Flow_modifiedNodes",
  New_Flow_invalidFlow_explain = "New_Flow_invalidFlow_explain",
  New_Flow_input_message_block = "New_Flow_input_message_block",
  New_Flow_general_block = "New_Flow_general_block",
  New_Flow_text_block = "New_Flow_text_block",
  New_Flow_voice_block = "New_Flow_voice_block",
  New_Flow_imageorvideo_block = "New_Flow_imageorvideo_block",
  New_Flow_quick_reply_block = "New_Flow_quick_reply_block",
  New_Flow_weblink_block = "New_Flow_weblink_block",
  New_Flow_phonenumbergrabber_block = "New_Flow_phonenumbergrabber_block",
  New_Flow_ai_block = "New_Flow_ai_block",
  New_Flow_ai_select = "New_Flow_ai_select",
  New_Flow_ai_livetest = "New_Flow_ai_livetest",
  New_Flow_masterflow_block = "New_Flow_masterflow_block",
  New_Flow_masterflow_select = "New_Flow_masterflow_select",
  New_Flow_masterflow_livetest = "New_Flow_masterflow_livetest",
  New_Flow_Tutorials_buttongroup_title = "New_Flow_Tutorials_buttongroup_title",
  New_Flow_Tutorials_buttongroup_description = "New_Flow_Tutorials_buttongroup_description",
  New_Flow_Tutorials_buttongroup_usageType = "New_Flow_Tutorials_buttongroup_usageType",
  New_Flow_Tutorials_buttongroup_feature_1 = "New_Flow_Tutorials_buttongroup_feature_1",
  New_Flow_Tutorials_buttongroup_feature_2 = "New_Flow_Tutorials_buttongroup_feature_2",
  New_Flow_Tutorials_buttongroup_feature_3 = "New_Flow_Tutorials_buttongroup_feature_3",
  New_Flow_Tutorials_buttongroup_tip_1 = "New_Flow_Tutorials_buttongroup_tip_1",
  New_Flow_Tutorials_buttongroup_tip_2 = "New_Flow_Tutorials_buttongroup_tip_2",
  New_Flow_Tutorials_buttongroup_tip_3 = "New_Flow_Tutorials_buttongroup_tip_3",
  New_Flow_Tutorials_buttongroup_limitation_1 = "New_Flow_Tutorials_buttongroup_limitation_1",
  New_Flow_Tutorials_buttongroup_limitation_2 = "New_Flow_Tutorials_buttongroup_limitation_2",
  New_Flow_Tutorials_buttongroup_limitation_3 = "New_Flow_Tutorials_buttongroup_limitation_3",
  New_Flow_Tutorials_buttongroup_limitation_4 = "New_Flow_Tutorials_buttongroup_limitation_4",
  New_Flow_Tutorials_ai_title = "New_Flow_Tutorials_ai_title",
  New_Flow_Tutorials_ai_description = "New_Flow_Tutorials_ai_description",
  New_Flow_Tutorials_ai_usageType = "New_Flow_Tutorials_ai_usageType",
  New_Flow_Tutorials_ai_feature_1 = "New_Flow_Tutorials_ai_feature_1",
  New_Flow_Tutorials_ai_feature_2 = "New_Flow_Tutorials_ai_feature_2",
  New_Flow_Tutorials_ai_tip_1 = "New_Flow_Tutorials_ai_tip_1",
  New_Flow_Tutorials_ai_tip_2 = "New_Flow_Tutorials_ai_tip_2",
  New_Flow_Tutorials_ai_limitation_1 = "New_Flow_Tutorials_ai_limitation_1",
  New_Flow_Tutorials_ai_limitation_2 = "New_Flow_Tutorials_ai_limitation_2",
  New_Flow_Tutorials_ai_limitation_3 = "New_Flow_Tutorials_ai_limitation_3",
  New_Flow_Tutorials_masterflow_title = "New_Flow_Tutorials_masterflow_title",
  New_Flow_Tutorials_masterflow_description = "New_Flow_Tutorials_masterflow_description",
  New_Flow_Tutorials_masterflow_usageType = "New_Flow_Tutorials_masterflow_usageType",
  New_Flow_Tutorials_masterflow_feature_1 = "New_Flow_Tutorials_masterflow_feature_1",
  New_Flow_Tutorials_masterflow_feature_2 = "New_Flow_Tutorials_masterflow_feature_2",
  New_Flow_Tutorials_masterflow_tip_1 = "New_Flow_Tutorials_masterflow_tip_1",
  New_Flow_Tutorials_masterflow_tip_2 = "New_Flow_Tutorials_masterflow_tip_2",
  New_Flow_Tutorials_masterflow_limitation_1 = "New_Flow_Tutorials_masterflow_limitation_1",
  New_Flow_Tutorials_masterflow_limitation_2 = "New_Flow_Tutorials_masterflow_limitation_2",
  New_Flow_Tutorials_masterflow_limitation_3 = "New_Flow_Tutorials_masterflow_limitation_3",
  New_Flow_Tutorials_masterflow_connection_1 = "New_Flow_Tutorials_masterflow_connection_1",
  New_Flow_Tutorials_masterflow_connection_2 = "New_Flow_Tutorials_masterflow_connection_2",
  New_Flow_Tutorials_masterflow_connection_3 = "New_Flow_Tutorials_masterflow_connection_3",
  New_Flow_generic_block = "New_Flow_generic_block",
  New_Flow_add_general_block = "New_Flow_add_general_block",
  New_Flow_add_text_block = "New_Flow_add_text_block",
  New_Flow_add_image_block = "New_Flow_add_image_block",
  New_Flow_add_voice_block = "New_Flow_add_voice_block",
  New_Flow_add_quick_reply_block = "New_Flow_add_quick_reply_block",
  New_Flow_add_weblink_block = "New_Flow_add_weblink_block",
  New_Flow_upload_imageorvideo = "New_Flow_upload_imageorvideo",
  New_Flow_upload_image = "New_Flow_upload_image",
  New_Flow_upload_unsupported_media = "New_Flow_upload_unsupported_media",
  New_Flow_uploadmaxsizeexceeded = "New_Flow_uploadmaxsizeexceeded",
  New_Flow_uploadfilefailed = "New_Flow_uploadfilefailed",
  invalidFlowDetected = "invalidFlowDetected",
  New_Flow_unsupportedbrowser = "New_Flow_unsupportedbrowser",
  New_Flow_micphoneaccessdenied = "New_Flow_micphoneaccessdenied",
  New_Flow_upload_audio = "New_Flow_upload_audio",
  New_Flow_record_voice = "New_Flow_record_voice",
  New_Flow_stop_record_voice = "New_Flow_stop_record_voice",
  New_Flow_areyoureadytorecord = "New_Flow_areyoureadytorecord",
  New_Flow_voice_recording_started = "New_Flow_voice_recording_started",
  New_Flow_add_generic_sub_block = "New_Flow_add_generic_sub_block",
  New_Flow_generic_sub = "New_Flow_generic_sub",
  New_Flow_add_button = "New_Flow_add_button",
  New_Flow_quick_reply_title_placeholder = "New_Flow_quick_reply_title_placeholder",
  New_Flow_buttongroup_block = "New_Flow_buttongroup_block",
  New_Flow_add_buttongroup_block = "New_Flow_add_buttongroup_block",
  New_Flow_buttongroup_title_placeholder = "New_Flow_buttongroup_title_placeholder",
  New_Flow_imagegallery_block = "New_Flow_imagegallery_block",
  New_Flow_add_imagegallery_block = "New_Flow_add_imagegallery_block",
  New_Flow_imagegallery_max_reached = "New_Flow_imagegallery_max_reached",
  New_Flow_Tutorials_imagegallery_title = "New_Flow_Tutorials_imagegallery_title",
  New_Flow_Tutorials_imagegallery_description = "New_Flow_Tutorials_imagegallery_description",
  New_Flow_Tutorials_imagegallery_usageType = "New_Flow_Tutorials_imagegallery_usageType",
  New_Flow_Tutorials_imagegallery_feature_1 = "New_Flow_Tutorials_imagegallery_feature_1",
  New_Flow_Tutorials_imagegallery_limitation_1 = "New_Flow_Tutorials_imagegallery_limitation_1",
  New_Flow_message_title = "New_Flow_message_title",
  New_Flow_message_description = "New_Flow_message_description",
  New_Flow_live_test_block = "New_Flow_live_test_block",
  New_Flow_delete_all_blocks = "New_Flow_delete_all_blocks",
  New_Flow_shortcuts_explain = "New_Flow_shortcuts_explain",
  New_Flow_Tutorials_Not_Available = "New_Flow_Tutorials_Not_Available",
  New_Flow_Tutorials_Not_Available_Description = "New_Flow_Tutorials_Not_Available_Description",
  New_Flow_Tutorials_Usage_Type = "New_Flow_Tutorials_Usage_Type",
  New_Flow_Tutorials_Features = "New_Flow_Tutorials_Features",
  New_Flow_Tutorials_Tips = "New_Flow_Tutorials_Tips",
  New_Flow_Tutorials_Limitations = "New_Flow_Tutorials_Limitations",
  New_Flow_Tutorials_Connections = "New_Flow_Tutorials_Connections",
  sendsms = "sendsms",
  sendtotelegram = "sendtotelegram",
  senderusername = "senderusername",
  addtools = "addtools",
  generatebyai = "generatebyai",

  //tutorials
  New_Flow_Tutorials_onmessage_title = "New_Flow_Tutorials_onmessage_title",
  New_Flow_Tutorials_onmessage_description = "New_Flow_Tutorials_onmessage_description",
  New_Flow_Tutorials_onmessage_feature_1 = "New_Flow_Tutorials_onmessage_feature_1",
  New_Flow_Tutorials_onmessage_tip_1 = "New_Flow_Tutorials_onmessage_tip_1",
  New_Flow_Tutorials_onmessage_connection_1 = "New_Flow_Tutorials_onmessage_connection_1",
  New_Flow_Tutorials_onmessage_connection_2 = "New_Flow_Tutorials_onmessage_connection_2",
  New_Flow_Tutorials_onmessage_connection_3 = "New_Flow_Tutorials_onmessage_connection_3",
  New_Flow_Tutorials_onmessage_connection_4 = "New_Flow_Tutorials_onmessage_connection_4",
  New_Flow_Tutorials_onmessage_connection_5 = "New_Flow_Tutorials_onmessage_connection_5",
  New_Flow_Tutorials_onmessage_connection_6 = "New_Flow_Tutorials_onmessage_connection_6",
  New_Flow_Tutorials_text_title = "New_Flow_Tutorials_text_title",
  New_Flow_Tutorials_text_description = "New_Flow_Tutorials_text_description",
  New_Flow_Tutorials_text_usageType = "New_Flow_Tutorials_text_usageType",
  New_Flow_Tutorials_text_feature_1 = "New_Flow_Tutorials_text_feature_1",
  New_Flow_Tutorials_text_feature_2 = "New_Flow_Tutorials_text_feature_2",
  New_Flow_Tutorials_text_tip_1 = "New_Flow_Tutorials_text_tip_1",
  New_Flow_Tutorials_text_tip_2 = "New_Flow_Tutorials_text_tip_2",
  New_Flow_Tutorials_text_tip_3 = "New_Flow_Tutorials_text_tip_3",
  New_Flow_Tutorials_text_tip_4 = "New_Flow_Tutorials_text_tip_4",
  New_Flow_Tutorials_text_tip_5 = "New_Flow_Tutorials_text_tip_5",
  New_Flow_Tutorials_text_limitation_1 = "New_Flow_Tutorials_text_limitation_1",
  New_Flow_Tutorials_text_limitation_2 = "New_Flow_Tutorials_text_limitation_2",
  New_Flow_Tutorials_text_limitation_3 = "New_Flow_Tutorials_text_limitation_3",
  New_Flow_Tutorials_text_connection_1 = "New_Flow_Tutorials_text_connection_1",
  New_Flow_Tutorials_text_connection_2 = "New_Flow_Tutorials_text_connection_2",
  New_Flow_Tutorials_text_connection_3 = "New_Flow_Tutorials_text_connection_3",
  New_Flow_Tutorials_text_connection_4 = "New_Flow_Tutorials_text_connection_4",
  New_Flow_Tutorials_text_connection_5 = "New_Flow_Tutorials_text_connection_5",
  New_Flow_Tutorials_text_connection_6 = "New_Flow_Tutorials_text_connection_6",
  New_Flow_Tutorials_text_connection_7 = "New_Flow_Tutorials_text_connection_7",
  New_Flow_Tutorials_text_connection_8 = "New_Flow_Tutorials_text_connection_8",

  New_Flow_Tutorials_image_title = "New_Flow_Tutorials_image_title",
  New_Flow_Tutorials_image_description = "New_Flow_Tutorials_image_description",
  New_Flow_Tutorials_image_usageType = "New_Flow_Tutorials_image_usageType",
  New_Flow_Tutorials_image_feature_1 = "New_Flow_Tutorials_image_feature_1",
  New_Flow_Tutorials_image_feature_2 = "New_Flow_Tutorials_image_feature_2",
  New_Flow_Tutorials_image_feature_3 = "New_Flow_Tutorials_image_feature_3",
  New_Flow_Tutorials_image_tip_1 = "New_Flow_Tutorials_image_tip_1",
  New_Flow_Tutorials_image_tip_2 = "New_Flow_Tutorials_image_tip_2",
  New_Flow_Tutorials_image_tip_3 = "New_Flow_Tutorials_image_tip_3",
  New_Flow_Tutorials_image_tip_4 = "New_Flow_Tutorials_image_tip_4",
  New_Flow_Tutorials_image_tip_5 = "New_Flow_Tutorials_image_tip_5",
  New_Flow_Tutorials_image_limitation_1 = "New_Flow_Tutorials_image_limitation_1",
  New_Flow_Tutorials_image_limitation_2 = "New_Flow_Tutorials_image_limitation_2",
  New_Flow_Tutorials_image_limitation_3 = "New_Flow_Tutorials_image_limitation_3",
  New_Flow_Tutorials_image_connection_1 = "New_Flow_Tutorials_image_connection_1",
  New_Flow_Tutorials_image_connection_2 = "New_Flow_Tutorials_image_connection_2",
  New_Flow_Tutorials_image_connection_3 = "New_Flow_Tutorials_image_connection_3",
  New_Flow_Tutorials_image_connection_4 = "New_Flow_Tutorials_image_connection_4",
  New_Flow_Tutorials_image_connection_5 = "New_Flow_Tutorials_image_connection_5",
  New_Flow_Tutorials_image_connection_6 = "New_Flow_Tutorials_image_connection_6",
  New_Flow_Tutorials_image_connection_7 = "New_Flow_Tutorials_image_connection_7",
  New_Flow_Tutorials_image_connection_8 = "New_Flow_Tutorials_image_connection_8",

  New_Flow_Tutorials_voice_title = "New_Flow_Tutorials_voice_title",
  New_Flow_Tutorials_voice_description = "New_Flow_Tutorials_voice_description",
  New_Flow_Tutorials_voice_usageType = "New_Flow_Tutorials_voice_usageType",
  New_Flow_Tutorials_voice_feature_1 = "New_Flow_Tutorials_voice_feature_1",
  New_Flow_Tutorials_voice_feature_2 = "New_Flow_Tutorials_voice_feature_2",
  New_Flow_Tutorials_voice_feature_3 = "New_Flow_Tutorials_voice_feature_3",
  New_Flow_Tutorials_voice_tip_1 = "New_Flow_Tutorials_voice_tip_1",
  New_Flow_Tutorials_voice_tip_2 = "New_Flow_Tutorials_voice_tip_2",
  New_Flow_Tutorials_voice_tip_3 = "New_Flow_Tutorials_voice_tip_3",
  New_Flow_Tutorials_voice_tip_4 = "New_Flow_Tutorials_voice_tip_4",
  New_Flow_Tutorials_voice_limitation_1 = "New_Flow_Tutorials_voice_limitation_1",
  New_Flow_Tutorials_voice_limitation_2 = "New_Flow_Tutorials_voice_limitation_2",
  New_Flow_Tutorials_voice_limitation_3 = "New_Flow_Tutorials_voice_limitation_3",
  New_Flow_Tutorials_voice_connection_1 = "New_Flow_Tutorials_voice_connection_1",
  New_Flow_Tutorials_voice_connection_2 = "New_Flow_Tutorials_voice_connection_2",
  New_Flow_Tutorials_voice_connection_3 = "New_Flow_Tutorials_voice_connection_3",
  New_Flow_Tutorials_voice_connection_4 = "New_Flow_Tutorials_voice_connection_4",
  New_Flow_Tutorials_voice_connection_5 = "New_Flow_Tutorials_voice_connection_5",
  New_Flow_Tutorials_voice_connection_6 = "New_Flow_Tutorials_voice_connection_6",
  New_Flow_Tutorials_voice_connection_7 = "New_Flow_Tutorials_voice_connection_7",
  New_Flow_Tutorials_voice_connection_8 = "New_Flow_Tutorials_voice_connection_8",
  New_Flow_Tutorials_quickreply_title = "New_Flow_Tutorials_quickreply_title",
  New_Flow_Tutorials_quickreply_description = "New_Flow_Tutorials_quickreply_description",
  New_Flow_Tutorials_quickreply_usageType = "New_Flow_Tutorials_quickreply_usageType",
  New_Flow_Tutorials_quickreply_feature_1 = "New_Flow_Tutorials_quickreply_feature_1",
  New_Flow_Tutorials_quickreply_feature_2 = "New_Flow_Tutorials_quickreply_feature_2",
  New_Flow_Tutorials_quickreply_feature_3 = "New_Flow_Tutorials_quickreply_feature_3",
  New_Flow_Tutorials_quickreply_tip_1 = "New_Flow_Tutorials_quickreply_tip_1",
  New_Flow_Tutorials_quickreply_tip_2 = "New_Flow_Tutorials_quickreply_tip_2",
  New_Flow_Tutorials_quickreply_tip_3 = "New_Flow_Tutorials_quickreply_tip_3",
  New_Flow_Tutorials_quickreply_tip_4 = "New_Flow_Tutorials_quickreply_tip_4",
  New_Flow_Tutorials_quickreply_tip_5 = "New_Flow_Tutorials_quickreply_tip_5",
  New_Flow_Tutorials_quickreply_limitation_1 = "New_Flow_Tutorials_quickreply_limitation_1",
  New_Flow_Tutorials_quickreply_limitation_2 = "New_Flow_Tutorials_quickreply_limitation_2",
  New_Flow_Tutorials_quickreply_limitation_3 = "New_Flow_Tutorials_quickreply_limitation_3",
  New_Flow_Tutorials_quickreply_limitation_4 = "New_Flow_Tutorials_quickreply_limitation_4",
  New_Flow_Tutorials_quickreply_connection_1 = "New_Flow_Tutorials_quickreply_connection_1",
  New_Flow_Tutorials_quickreply_connection_2 = "New_Flow_Tutorials_quickreply_connection_2",
  New_Flow_Tutorials_quickreply_connection_3 = "New_Flow_Tutorials_quickreply_connection_3",
  New_Flow_Tutorials_quickreply_connection_4 = "New_Flow_Tutorials_quickreply_connection_4",
  New_Flow_Tutorials_quickreply_connection_5 = "New_Flow_Tutorials_quickreply_connection_5",
  New_Flow_Tutorials_quickreply_connection_6 = "New_Flow_Tutorials_quickreply_connection_6",
  New_Flow_Tutorials_quickreply_connection_7 = "New_Flow_Tutorials_quickreply_connection_7",
  New_Flow_Tutorials_quickreply_connection_8 = "New_Flow_Tutorials_quickreply_connection_8",

  New_Flow_Tutorials_generic_title = "New_Flow_Tutorials_generic_title",
  New_Flow_Tutorials_generic_description = "New_Flow_Tutorials_generic_description",
  New_Flow_Tutorials_generic_usageType = "New_Flow_Tutorials_generic_usageType",
  New_Flow_Tutorials_generic_tip_1 = "New_Flow_Tutorials_generic_tip_1",
  New_Flow_Tutorials_generic_tip_2 = "New_Flow_Tutorials_generic_tip_2",
  New_Flow_Tutorials_generic_tip_3 = "New_Flow_Tutorials_generic_tip_3",
  New_Flow_Tutorials_generic_tip_4 = "New_Flow_Tutorials_generic_tip_4",
  New_Flow_Tutorials_generic_limitation_1 = "New_Flow_Tutorials_generic_limitation_1",
  New_Flow_Tutorials_generic_connection_1 = "New_Flow_Tutorials_generic_connection_1",
  New_Flow_Tutorials_generic_connection_2 = "New_Flow_Tutorials_generic_connection_2",
  New_Flow_Tutorials_generic_connection_3 = "New_Flow_Tutorials_generic_connection_3",
  New_Flow_Tutorials_generic_connection_4 = "New_Flow_Tutorials_generic_connection_4",
  New_Flow_Tutorials_generic_connection_5 = "New_Flow_Tutorials_generic_connection_5",
  New_Flow_Tutorials_generic_connection_6 = "New_Flow_Tutorials_generic_connection_6",
  New_Flow_Tutorials_generic_connection_7 = "New_Flow_Tutorials_generic_connection_7",
  New_Flow_Tutorials_genericitem_title = "New_Flow_Tutorials_genericitem_title",
  New_Flow_Tutorials_genericitem_description = "New_Flow_Tutorials_genericitem_description",
  New_Flow_Tutorials_genericitem_usageType = "New_Flow_Tutorials_genericitem_usageType",
  New_Flow_Tutorials_genericitem_feature_1 = "New_Flow_Tutorials_genericitem_feature_1",
  New_Flow_Tutorials_genericitem_feature_2 = "New_Flow_Tutorials_genericitem_feature_2",
  New_Flow_Tutorials_genericitem_feature_3 = "New_Flow_Tutorials_genericitem_feature_3",
  New_Flow_Tutorials_genericitem_feature_4 = "New_Flow_Tutorials_genericitem_feature_4",
  New_Flow_Tutorials_genericitem_tip_1 = "New_Flow_Tutorials_genericitem_tip_1",
  New_Flow_Tutorials_genericitem_tip_2 = "New_Flow_Tutorials_genericitem_tip_2",
  New_Flow_Tutorials_genericitem_tip_3 = "New_Flow_Tutorials_genericitem_tip_3",
  New_Flow_Tutorials_genericitem_tip_4 = "New_Flow_Tutorials_genericitem_tip_4",
  New_Flow_Tutorials_genericitem_tip_5 = "New_Flow_Tutorials_genericitem_tip_5",
  New_Flow_Tutorials_genericitem_limitation_1 = "New_Flow_Tutorials_genericitem_limitation_1",
  New_Flow_Tutorials_genericitem_limitation_2 = "New_Flow_Tutorials_genericitem_limitation_2",
  New_Flow_Tutorials_genericitem_limitation_3 = "New_Flow_Tutorials_genericitem_limitation_3",
  New_Flow_Tutorials_genericitem_limitation_4 = "New_Flow_Tutorials_genericitem_limitation_4",
  New_Flow_Tutorials_genericitem_limitation_5 = "New_Flow_Tutorials_genericitem_limitation_5",
  New_Flow_Tutorials_genericitem_limitation_6 = "New_Flow_Tutorials_genericitem_limitation_6",
  New_Flow_Tutorials_genericitem_connection_1 = "New_Flow_Tutorials_genericitem_connection_1",
  New_Flow_Tutorials_genericitem_connection_2 = "New_Flow_Tutorials_genericitem_connection_2",
  New_Flow_Tutorials_genericitem_connection_3 = "New_Flow_Tutorials_genericitem_connection_3",
  New_Flow_Tutorials_genericitem_connection_4 = "New_Flow_Tutorials_genericitem_connection_4",
  New_Flow_Tutorials_genericitem_connection_5 = "New_Flow_Tutorials_genericitem_connection_5",
  New_Flow_Tutorials_genericitem_connection_6 = "New_Flow_Tutorials_genericitem_connection_6",
  New_Flow_Tutorials_weblink_title = "New_Flow_Tutorials_weblink_title",
  New_Flow_Tutorials_phonenumbergrabber_title = "New_Flow_Tutorials_phonenumbergrabber_title",
  New_Flow_Tutorials_phonenumbergrabber_description = "New_Flow_Tutorials_phonenumbergrabber_description",
  New_Flow_Tutorials_phonenumbergrabber_usageType = "New_Flow_Tutorials_phonenumbergrabber_usageType",
  New_Flow_Tutorials_phonenumbergrabber_feature_1 = "New_Flow_Tutorials_phonenumbergrabber_feature_1",
  New_Flow_Tutorials_phonenumbergrabber_feature_2 = "New_Flow_Tutorials_phonenumbergrabber_feature_2",
  New_Flow_Tutorials_phonenumbergrabber_tip_1 = "New_Flow_Tutorials_phonenumbergrabber_tip_1",
  New_Flow_Tutorials_phonenumbergrabber_tip_2 = "New_Flow_Tutorials_phonenumbergrabber_tip_2",
  New_Flow_Tutorials_phonenumbergrabber_tip_3 = "New_Flow_Tutorials_phonenumbergrabber_tip_3",
  New_Flow_Tutorials_phonenumbergrabber_limitation_1 = "New_Flow_Tutorials_phonenumbergrabber_limitation_1",
  New_Flow_Tutorials_phonenumbergrabber_limitation_2 = "New_Flow_Tutorials_phonenumbergrabber_limitation_2",
  New_Flow_Tutorials_phonenumbergrabber_limitation_3 = "New_Flow_Tutorials_phonenumbergrabber_limitation_3",
  New_Flow_Tutorials_phonenumbergrabber_connection_3 = "New_Flow_Tutorials_phonenumbergrabber_connection_3",
  New_Flow_Tutorials_phonenumbergrabber_connection_2 = "New_Flow_Tutorials_phonenumbergrabber_connection_2",
  New_Flow_Tutorials_phonenumbergrabber_connection_1 = "New_Flow_Tutorials_phonenumbergrabber_connection_1",
  New_Flow_Tutorials_weblink_description = "New_Flow_Tutorials_weblink_description",
  New_Flow_Tutorials_weblink_usageType = "New_Flow_Tutorials_weblink_usageType",
  New_Flow_Tutorials_weblink_feature_1 = "New_Flow_Tutorials_weblink_feature_1",
  New_Flow_Tutorials_weblink_feature_2 = "New_Flow_Tutorials_weblink_feature_2",
  New_Flow_Tutorials_weblink_tip_1 = "New_Flow_Tutorials_weblink_tip_1",
  New_Flow_Tutorials_weblink_tip_2 = "New_Flow_Tutorials_weblink_tip_2",
  New_Flow_Tutorials_weblink_tip_3 = "New_Flow_Tutorials_weblink_tip_3",
  New_Flow_Tutorials_weblink_tip_4 = "New_Flow_Tutorials_weblink_tip_4",
  New_Flow_Tutorials_weblink_tip_5 = "New_Flow_Tutorials_weblink_tip_5",
  New_Flow_Tutorials_weblink_limitation_1 = "New_Flow_Tutorials_weblink_limitation_1",
  New_Flow_Tutorials_weblink_limitation_2 = "New_Flow_Tutorials_weblink_limitation_2",
  New_Flow_Tutorials_weblink_limitation_3 = "New_Flow_Tutorials_weblink_limitation_3",
  New_Flow_Tutorials_weblink_connection_1 = "New_Flow_Tutorials_weblink_connection_1",
  New_Flow_Tutorials_weblink_connection_2 = "New_Flow_Tutorials_weblink_connection_2",

  // #endregion AIFlow Section

  // #region Notification Section
  Notify_Ok = "Notify_Ok",
  Notify_InternalException = "Notify_InternalException",
  Notify_CannotSendSmsNow = "Notify_CannotSendSmsNow",
  Notify_InvalidPhoneNumber = "Notify_InvalidPhoneNumber",
  Notify_InvalidCountryCode = "Notify_InvalidCountryCode",
  Notify_PhoneNumberNotAvailableInThisCountry = "Notify_PhoneNumberNotAvailableInThisCountry",
  Notify_InstagramerIdNotExist = "Notify_InstagramerIdNotExist",
  Notify_EmptyProductList = "Notify_EmptyProductList",
  Notify_InvalidVerificationCode = "Notify_InvalidVerificationCode",
  Notify_LowQuality = "Notify_LowQuality",
  Notify_CannotEmptyChildren = "Notify_CannotEmptyChildren",
  Notify_InvalidAspectRatio = "Notify_InvalidAspectRatio",
  Notify_InvalidMediaCodec = "Notify_InvalidMediaCodec",
  Notify_InvalidMediaType = "Notify_InvalidMediaType",
  Notify_MediaUrlNotAccessible = "Notify_MediaUrlNotAccessible",
  Notify_CannotCreatePrePostNow = "Notify_CannotCreatePrePostNow",
  Notify_InvalidMediaContent = "Notify_InvalidMediaContent",
  Notify_Unexpected = "Notify_Unexpected",
  Notify_TooManyRequestForImageHashtagGenerator = "Notify_TooManyRequestForImageHashtagGenerator",
  Notify_LoginFailed = "Notify_LoginFailed",
  Notify_NullUserId = "Notify_NullUserId",
  Notify_RealtimeSocketNotExist = "Notify_RealtimeSocketNotExist",
  Notify_PushSocketNotExist = "Notify_PushSocketNotExist",
  Notify_InstaApiNotFoundForConnect = "Notify_InstaApiNotFoundForConnect",
  Notify_EmptyHashtagList = "Notify_EmptyHashtagList",
  Notify_InvalidHashtagListId = "Notify_InvalidHashtagListId",
  Notify_DeleteHashtagFail = "Notify_DeleteHashtagFail",
  Notify_InvalidBase64Content = "Notify_InvalidBase64Content",
  Notify_InvalidTermsAndConditionSvgType = "Notify_InvalidTermsAndConditionSvgType",
  Notify_InvalidLotteryAnnouncementBannerId = "Notify_InvalidLotteryAnnouncementBannerId",
  Notify_InvalidLotteryAnnouncementBannerStr = "Notify_InvalidLotteryAnnouncementBannerStr",
  Notify_InvalidPostId = "Notify_InvalidPostId",
  Notify_TooSoonLotteryInfo = "Notify_TooSoonLotteryInfo",
  Notify_InvalidDirectParams = "Notify_InvalidDirectParams",
  Notify_NoInstagramerExists = "Notify_NoInstagramerExists",
  Notify_PropertyNotFoundOrNull = "Notify_PropertyNotFoundOrNull",
  Notify_ReachNumberOfPinDirect = "Notify_ReachNumberOfPinDirect",
  Notify_InvalidStoryId = "Notify_InvalidStoryId",
  Notify_MaxPrePostReach = "Notify_MaxPrePostReach",
  Notify_InvalidDraftId = "Notify_InvalidDraftId",
  Notify_InvalidPrePostId = "Notify_InvalidPrePostId",
  Notify_ReachHashtagListLimit = "Notify_ReachHashtagListLimit",
  Notify_EmptyUsername = "Notify_EmptyUsername",
  Notify_TooManyRequestForPageHashtagAnalysis = "Notify_TooManyRequestForPageHashtagAnalysis",
  Notify_PasswordRequired = "Notify_PasswordRequired",
  Notify_PackageRequiredInThisTime = "Notify_PackageRequiredInThisTime",
  Notify_FeatureRequiredInThisTime = "Notify_FeatureRequiredInThisTime",
  Notify_NoShopperExist = "Notify_NoShopperExist",
  Notify_FollowerLotteryTypeRandomlyWithoutLoginForVerifiedOrPrivateAccount = "Notify_FollowerLotteryTypeRandomlyWithoutLoginForVerifiedOrPrivateAccount",
  Notify_FollowerLotteryTypeEngagmentWithoutLoginForPrivateAccount = "Notify_FollowerLotteryTypeEngagmentWithoutLoginForPrivateAccount",
  Notify_InvalidLinkId = "Notify_InvalidLinkId",
  Notify_ReachMaxBioLink = "Notify_ReachMaxBioLink",
  Notify_OnlyBusinessAccountHasThisAccess = "Notify_OnlyBusinessAccountHasThisAccess",
  Notify_NoYoutubeChannelFound = "Notify_NoYoutubeChannelFound",
  Notify_CannotGetYoutubeRightNow = "Notify_CannotGetYoutubeRightNow",
  Notify_AparatUsernameNotFound = "Notify_AparatUsernameNotFound",
  Notify_AparatChannelHasNotAnyVideo = "Notify_AparatChannelHasNotAnyVideo",
  Notify_InvalidYoutubeChannelId = "Notify_InvalidYoutubeChannelId",
  Notify_NoAparatChannelFound = "Notify_NoAparatChannelFound",
  Notify_CannotGetAparatRightNow = "Notify_CannotGetAparatRightNow",
  Notify_NotSettedCustomDomain = "Notify_NotSettedCustomDomain",
  Notify_CannotStoryWithoutWinnerBanner = "Notify_CannotStoryWithoutWinnerBanner",
  Notify_ExceedMaxStoryWinnerLotteryBanner = "Notify_ExceedMaxStoryWinnerLotteryBanner",
  Notify_LotteryOnProcessingOrEnded = "Notify_LotteryOnProcessingOrEnded",
  Notify_CannotAbortLotteryOneHourBefore = "Notify_CannotAbortLotteryOneHourBefore",
  Notify_CannotAbortFollowerLottery = "Notify_CannotAbortFollowerLottery",
  Notify_InvalidImageOrExceedMaxSize = "Notify_InvalidImageOrExceedMaxSize",
  Notify_ExceedLoginAttempt = "Notify_ExceedLoginAttempt",
  Notify_NotExistComment = "Notify_NotExistComment",
  Notify_UserNotFound = "Notify_UserNotFound",
  Notify_ExistInstagramerBefore = "Notify_ExistInstagramerBefore",
  Notify_CannotChangeBusinessAccountType = "Notify_CannotChangeBusinessAccountType",
  Notify_InvalidProductId = "Notify_InvalidProductId",
  Notify_InvalidTrendHashtagPeriod = "Notify_InvalidTrendHashtagPeriod",
  Notify_InvalidLanguageId = "Notify_InvalidLanguageId",
  Notify_CannotStoryWithoutTermsBanner = "Notify_CannotStoryWithoutTermsBanner",
  Notify_ExceedMaxStoryTermsLotteryBanner = "Notify_ExceedMaxStoryTermsLotteryBanner",
  Notify_LotteryTermsIsNull = "Notify_LotteryTermsIsNull",
  Notify_CanShareTermsBefore6HoursOfStartLottery = "Notify_CanShareTermsBefore6HoursOfStartLottery",
  Notify_CanShareTermForOnlyDefinedStatusLotteries = "Notify_CanShareTermForOnlyDefinedStatusLotteries",
  Notify_SharedRemainingTimeBefore = "Notify_SharedRemainingTimeBefore",
  Notify_ShareRemainingTimeOnlyActiveForScoreLottery = "Notify_ShareRemainingTimeOnlyActiveForScoreLottery",
  Notify_CanShareTermsBefore1HoursOfStartLottery = "Notify_CanShareTermsBefore1HoursOfStartLottery",
  Notify_InvalidSubProductIds = "Notify_InvalidSubProductIds",
  Notify_ReachMaxProductMedia = "Notify_ReachMaxProductMedia",
  Notify_InvalidMediaProductId = "Notify_InvalidMediaProductId",
  Notify_AccountNotABusiness = "Notify_AccountNotABusiness",
  Notify_NotFoundProductWithThisTempId = "Notify_NotFoundProductWithThisTempId",
  Notify_InvalidAvailabilityStatus = "Notify_InvalidAvailabilityStatus",
  Notify_InvalidIbanNumber = "Notify_InvalidIbanNumber",
  Notify_ExistedIbanNumber = "Notify_ExistedIbanNumber",
  Notify_IbanMethodNotAvailableForNotTomanPriceUser = "Notify_IbanMethodNotAvailableForNotTomanPriceUser",
  Notify_SearchQueryIsEmpty = "Notify_SearchQueryIsEmpty",
  Notify_ExceedMaxInEachCard = "Notify_ExceedMaxInEachCard",
  Notify_ProductNotAlbumPost = "Notify_ProductNotAlbumPost",
  Notify_InvalidChildrenId = "Notify_InvalidChildrenId",
  Notify_NotAvailableProduct = "Notify_NotAvailableProduct",
  Notify_ExceedStockCount = "Notify_ExceedStockCount",
  Notify_CannotUnloadAnInstanceProduct = "Notify_CannotUnloadAnInstanceProduct",
  Notify_InvalidCategoryId = "Notify_InvalidCategoryId",
  Notify_NotFoundAnyProductOnThisCategory = "Notify_NotFoundAnyProductOnThisCategory",
  Notify_NotFoundAnyNextProduct = "Notify_NotFoundAnyNextProduct",
  Notify_NotFoundAnyPreviousProduct = "Notify_NotFoundAnyPreviousProduct",
  Notify_InvalidItemId = "Notify_InvalidItemId",
  Notify_IpInvalid = "Notify_IpInvalid",
  Notify_InstagramRedirectInTenSeconds = "Notify_InstagramRedirectInTenSeconds",
  Notify_InstagramRedirect = "Notify_InstagramRedirect",
  Notify_InstagramRedirectExplain = "Notify_InstagramRedirectExplain",
  Notify_ThisInstagramAccountAddedBefore = "Notify_ThisInstagramAccountAddedBefore",
  Notify_InvalidTicketId = "Notify_InvalidTicketId",
  Notify_ExpiredSignature = "Notify_ExpiredSignature",
  Notify_Forbidden = "Notify_Forbidden",
  Notify_ConnectedInstagramPageNotFound = "Notify_ConnectedInstagramPageNotFound",
  Notify_AllInstagramAccountConnectedAddedBefore = "Notify_AllInstagramAccountConnectedAddedBefore",
  Notify_SelectInstagramPageToConnect = "Notify_SelectInstagramPageToConnect",
  Notify_InstagramRedirectRoleNotFound = "Notify_InstagramRedirectRoleNotFound",
  Notify_FacebookLoginNotFound = "Notify_FacebookLoginNotFound",
  Notify_SelectedPageNotFound = "Notify_SelectedPageNotFound",
  Notify_ShouldConnectInstaPageAgain = "Notify_ShouldConnectInstaPageAgain",
  Notify_InvalidProductSuggestionId = "Notify_InvalidProductSuggestionId",
  Notify_NotSavedSuggestions = "Notify_NotSavedSuggestions",
  Notify_ExistedSuggestedMedia = "Notify_ExistedSuggestedMedia",
  Notify_InvalidUploadMediaUrl = "Notify_InvalidUploadMediaUrl",
  Notify_SuggestedPostAutoReplyKeyNotExist = "Notify_SuggestedPostAutoReplyKeyNotExist",
  Notify_UploadingTimeIsSoSoon = "Notify_UploadingTimeIsSoSoon",
  Notify_InvalidPreStoryId = "Notify_InvalidPreStoryId",
  Notify_NotProvidedInstagramerId = "Notify_NotProvidedInstagramerId",
  Notify_InvalidInstagramerId = "Notify_InvalidInstagramerId",
  Notify_InvalidThreadId = "Notify_InvalidThreadId",
  Notify_InvalidLiveMediaId = "Notify_InvalidLiveMediaId",
  Notify_NotCreatedExportComment = "Notify_NotCreatedExportComment",
  Notify_CreateExportAvailableWith24HourPeriod = "Notify_CreateExportAvailableWith24HourPeriod",
  Notify_NotSetted = "Notify_NotSetted",
  Notify_ExceedGeneralAutoReplyCount = "Notify_ExceedGeneralAutoReplyCount",
  Notify_InvalidTransactionId = "Notify_InvalidTransactionId",
  Notify_CannotRenewalPackageWith1MonthTimeExist = "Notify_CannotRenewalPackageWith1MonthTimeExist",
  Notify_CannotDeleteCurrentSession = "Notify_CannotDeleteCurrentSession",
  Notify_InvalidSessionId = "Notify_InvalidSessionId",
  Notify_CannotDeleteCurrentSessionForNewSessionFor1Day = "Notify_CannotDeleteCurrentSessionForNewSessionFor1Day",
  Notify_UpgradedBefore = "Notify_UpgradedBefore",
  Notify_PermissionNotExist = "Notify_PermissionNotExist",
  Notify_NotExistUser = "Notify_NotExistUser",
  Notify_UserAlreadyAsPartner = "Notify_UserAlreadyAsPartner",
  Notify_ReachMaxPartnerCount = "Notify_ReachMaxPartnerCount",
  Notify_InvalidPartnerRoleProvided = "Notify_InvalidPartnerRoleProvided",
  Notify_PartnerRolesLengthIsZero = "Notify_PartnerRolesLengthIsZero",
  Notify_PartnerNotExist = "Notify_PartnerNotExist",
  Notify_CannotMakeYourSelfPartnerAsPartnerForYourSelf = "Notify_CannotMakeYourSelfPartnerAsPartnerForYourSelf",
  Notify_PartnerExpireTimeMustBeBiggerThan1HourFromNow = "Notify_PartnerExpireTimeMustBeBiggerThan1HourFromNow",
  Notify_PartnerNameCannotExceed100 = "Notify_PartnerNameCannotExceed100",
  Notify_ProductIsMultiSubproducted = "Notify_ProductIsMultiSubproducted",
  Notify_InvalidSubProductId = "Notify_InvalidSubProductId",
  Notify_ProductIdOutOfStock = "Notify_ProductIdOutOfStock",
  Notify_SubProductIdRequired = "Notify_SubProductIdRequired",
  Notify_CardIsEmpty = "Notify_CardIsEmpty",
  Notify_InvalidAddressId = "Notify_InvalidAddressId",
  Notify_ExceedTotalCreateAddress = "Notify_ExceedTotalCreateAddress",
  Notify_NotSupportedCountry = "Notify_NotSupportedCountry",
  Notify_CannotFetchAddressInThisEndpoint = "Notify_CannotFetchAddressInThisEndpoint",
  Notify_InvalidPostalCode = "Notify_InvalidPostalCode",
  Notify_NeedCompleteAddress = "Notify_NeedCompleteAddress",
  Notify_CannotBuyFromYourSelf = "Notify_CannotBuyFromYourSelf",
  Notify_AllReadyIsBusiness = "Notify_AllReadyIsBusiness",
  Notify_InvalidBusinessType = "Notify_InvalidBusinessType",
  Notify_UserAlreadyAuthorized = "Notify_UserAlreadyAuthorized",
  Notify_InstagramerNotInfluencer = "Notify_InstagramerNotInfluencer",
  Notify_InstagramerNotShopper = "Notify_InstagramerNotShopper",
  Notify_AuthorizedInstagramerBefore = "Notify_AuthorizedInstagramerBefore",
  Notify_UserNotAuthorizedYet = "Notify_UserNotAuthorizedYet",
  Notify_InstagramerNotAuthorized = "Notify_InstagramerNotAuthorized",
  Notify_InvalidBankCardNumber = "Notify_InvalidBankCardNumber",
  Notify_TheOwnerOfPhoneNumberNotBlongsNationalNumber = "Notify_TheOwnerOfPhoneNumberNotBlongsNationalNumber",
  Notify_CouponCodeAlreadyExists = "Notify_CouponCodeAlreadyExists",
  Notify_InvalidCouponId = "Notify_InvalidCouponId",
  Notify_CannotChangeShowPrivateCouponInBio = "Notify_CannotChangeShowPrivateCouponInBio",
  Notify_InvalidCouponCode = "Notify_InvalidCouponCode",
  Notify_CouponForAnotherPerson = "Notify_CouponForAnotherPerson",
  Notify_CouponExpired = "Notify_CouponExpired",
  Notify_CouponDeleted = "Notify_CouponDeleted",
  Notify_CouponUsedUp = "Notify_CouponUsedUp",
  Notify_InvalidUsernameSearchQuery = "Notify_InvalidUsernameSearchQuery",
  Notify_PreviouslyAddedShopAddress = "Notify_PreviouslyAddedShopAddress",
  Notify_NotSettedShopperAddress = "Notify_NotSettedShopperAddress",
  Notify_NotExistAnyLogesticInYourCountry = "Notify_NotExistAnyLogesticInYourCountry",
  Notify_InvalidLogesticIds = "Notify_InvalidLogesticIds",
  Notify_LogsticsNotSetted = "Notify_LogsticsNotSetted",
  Notify_NotCommpletedAllBusinessVerification = "Notify_NotCommpletedAllBusinessVerification",
  Notify_ThisParcelNotSupportedByAnySelectedAvailableLogestic = "Notify_ThisParcelNotSupportedByAnySelectedAvailableLogestic",
  Notify_NotSupportedLogestic = "Notify_NotSupportedLogestic",
  Notify_ExceedLogesticHeight = "Notify_ExceedLogesticHeight",
  Notify_ExceedLogesticWidth = "Notify_ExceedLogesticWidth",
  Notify_ExceedLogesticLength = "Notify_ExceedLogesticLength",
  Notify_ExceedLogesticTotalLength = "Notify_ExceedLogesticTotalLength",
  Notify_ExceedLogesticWeight = "Notify_ExceedLogesticWeight",
  Notify_UserAddressesIsEmptyOrNotSetDefaultAddress = "Notify_UserAddressesIsEmptyOrNotSetDefaultAddress",
  Notify_NotSupportedBoxByThisDimensions = "Notify_NotSupportedBoxByThisDimensions",
  Notify_CannotAvailableOutOfStackProduct = "Notify_CannotAvailableOutOfStackProduct",
  Notify_YouAreDeadInCivilRegistration = "Notify_YouAreDeadInCivilRegistration",
  Notify_InstagramerAlreadyAuthorized = "Notify_InstagramerAlreadyAuthorized",
  Notify_ThreadShouldBeActiveForSendMessage = "Notify_ThreadShouldBeActiveForSendMessage",
  Notify_PreviouslyClosedTicket = "Notify_PreviouslyClosedTicket",
  Notify_NotMatchedCart = "Notify_NotMatchedCart",
  Notify_PhoneNumberNotBlongsNationalNumber = "Notify_PhoneNumberNotBlongsNationalNumber",
  Notify_NotMatchedCardNumberAndIdentity = "Notify_NotMatchedCardNumberAndIdentity",
  Notify_SuspendedShop = "Notify_SuspendedShop",
  Notify_LogesticIdNotSpecifiedForaPostParcel = "Notify_LogesticIdNotSpecifiedForaPostParcel",
  Notify_LogesticNotInAvailableLogestics = "Notify_LogesticNotInAvailableLogestics",
  Notify_ExceedProductReportForLast24Hour = "Notify_ExceedProductReportForLast24Hour",
  Notify_PreviouslyReportedThisProduct = "Notify_PreviouslyReportedThisProduct",
  Notify_InvalidOrderId = "Notify_InvalidOrderId",
  Notify_NotPendingPayRequest = "Notify_NotPendingPayRequest",
  Notify_NotExistShopAddress = "Notify_NotExistShopAddress",
  Notify_InvalidOrderStatus = "Notify_InvalidOrderStatus",
  Notify_CancelInvoiceFailed = "Notify_CancelInvoiceFailed",
  Notify_PaymentSystemNotSupportedThisPriceType = "Notify_PaymentSystemNotSupportedThisPriceType",
  Notify_InvalidSentOrderType = "Notify_InvalidSentOrderType",
  Notify_InvalidParcelId = "Notify_InvalidParcelId",
  Notify_AddedParcelIdBefore = "Notify_AddedParcelIdBefore",
  Notify_InvoiceNotOnPaid = "Notify_InvoiceNotOnPaid",
  Notify_CreatedSystemTicketOnOrderBefore = "Notify_CreatedSystemTicketOnOrderBefore",
  Notify_PaymentServiceNotResponding = "Notify_PaymentServiceNotResponding",
  Notify_YouAreNotAdmin = "Notify_YouAreNotAdmin",
  Notify_YouAreNotASubAdmin = "Notify_YouAreNotASubAdmin",
  Notify_InvalidFbId = "Notify_InvalidFbId",
  Notify_InvalidFeatureId = "Notify_InvalidFeatureId",
  Notify_InActiveFeature = "Notify_InActiveFeature",
  Notify_FeaturePaused = "Notify_FeaturePaused",
  Notify_InvalidPromptInput = "Notify_InvalidPromptInput",
  Notify_PromptNotGenerated = "Notify_PromptNotGenerated",
  Notify_AIGeneratorFailed = "Notify_AIGeneratorFailed",
  Notify_NotExecutedPromptForCommentYet = "Notify_NotExecutedPromptForCommentYet",
  Notify_InstagramPermissionNotExist = "Notify_InstagramPermissionNotExist",
  Notify_InvalidTimeZone = "Notify_InvalidTimeZone",
  Notify_PromptCaptionExampleNotGenerated = "Notify_PromptCaptionExampleNotGenerated",
  Notify_InvalidMasterFlowId = "Notify_InvalidMasterFlowId",
  Notify_InvalidFlowId = "Notify_InvalidFlowId",
  Notify_EmptySubFlows = "Notify_EmptySubFlows",
  Notify_InvalidFlowObject = "Notify_InvalidFlowObject",
  Notify_InvalidMasterFlowTitle = "Notify_InvalidMasterFlowTitle",
  Notify_InvalidPromptId = "Notify_InvalidPromptId",
  Notify_ExceedThreadTokenLimit = "Notify_ExceedThreadTokenLimit",
  Notify_InvalidMediaId = "Notify_InvalidMediaId",
  Notify_InvalidLotteryId = "Notify_InvalidLotteryId",
  Notify_CannotAbortNonUpcomingLottery = "Notify_CannotAbortNonUpcomingLottery",
  Notify_CommentCountExceedFreeExport = "Notify_CommentCountExceedFreeExport",
  Notify_InvalidReserveFeatureId = "Notify_InvalidReserveFeatureId",
  Notify_CannotRenewalThisFeatureNow = "Notify_CannotRenewalThisFeatureNow",
  Notify_InvalidLotteryStatus = "Notify_InvalidLotteryStatus",
  Notify_PublishedLotteryBannerBefore = "Notify_PublishedLotteryBannerBefore",
  Notify_LotteryWinnerBannerIsNull = "Notify_LotteryWinnerBannerIsNull",
  Notify_InvalidCustomPromptSigniture = "Notify_InvalidCustomPromptSigniture",
  Notify_ServiceTemporarilyUnavailable = "Notify_ServiceTemporarilyUnavailable",
  Notify_PageSummaryNotGenerated = "Notify_PageSummaryNotGenerated",
  Notify_GenerateAIFail = "Notify_GenerateAIFail",
  Notify_InvalidPageAnalysis = "Notify_InvalidPageAnalysis",
  Notify_InvalidCustomPrompt = "Notify_InvalidCustomPrompt",
  Notify_AIModelNotSupportImage = "Notify_AIModelNotSupportImage",
  Notify_PromptNotSupportImage = "Notify_PromptNotSupportImage",
  Notify_AIModelNotSupportAudio = "Notify_AIModelNotSupportAudio",
  Notify_PromptNotSupportVoice = "Notify_PromptNotSupportVoice",
  Notify_AIModelNotSupportVideo = "Notify_AIModelNotSupportVideo",
  Notify_InvalidPrompt = "Notify_InvalidPrompt",
  Notify_InvalidImageGeneratorInput = "Notify_InvalidImageGeneratorInput",
  Notify_InSuffcientNumberOfImage = "Notify_InSuffcientNumberOfImage",
  Notify_CreateImageExceedLimit = "Notify_CreateImageExceedLimit",
  Notify_InvalidPromptType = "Notify_InvalidPromptType",
  Notify_UnSupportedAIInputType = "Notify_UnSupportedAIInputType",
  Notify_UnSupportedOrientationType = "Notify_UnSupportedOrientationType",
  Notify_SoraFailedAiCall = "Notify_SoraFailedAiCall",
  Notify_AIVideoSecondNotSupported = "Notify_AIVideoSecondNotSupported",
  Notify_FailedToTraslateDescription = "Notify_FailedToTraslateDescription",
  Notify_FailedToGenerateEmbedVector = "Notify_FailedToGenerateEmbedVector",
  Notify_NotGeneratedSummaryYet = "Notify_NotGeneratedSummaryYet",
  Notify_NoEventsFoundForTheGivenTimeRange = "Notify_NoEventsFoundForTheGivenTimeRange",
  Notify_NoEventsFoundForThisPrompt = "Notify_NoEventsFoundForThisPrompt",
  Notify_PageAnalysisNotExist = "Notify_PageAnalysisNotExist",
  Notify_NoEventIdeaGenerated = "Notify_NoEventIdeaGenerated",
  Notify_ThisCustomDomainCreatedBefore = "Notify_ThisCustomDomainCreatedBefore",
  Notify_ThisCustomDomainBelongsToAnother = "Notify_ThisCustomDomainBelongsToAnother",
  Notify_YouCustomDomainRequestedBeforeWaitATimeToRequestAgain = "Notify_YouCustomDomainRequestedBeforeWaitATimeToRequestAgain",
  Notify_LetsEncryptError = "Notify_LetsEncryptError",
  Notify_NoPendingCustomDomain = "Notify_NoPendingCustomDomain",
  Notify_YouCustomDomainCheckedBeforeWaitATimeToCheckAgain = "Notify_YouCustomDomainCheckedBeforeWaitATimeToCheckAgain",
  Notify_CustomDomainVerificationNotPassed = "Notify_CustomDomainVerificationNotPassed",
  Notify_InvalidProductTempId = "Notify_InvalidProductTempId",
  Notify_InvalidPriceType = "Notify_InvalidPriceType",
  Notify_AuthorizeCountryRequired = "Notify_AuthorizeCountryRequired",
  Notify_ProperyMustBeNumeric = "Notify_ProperyMustBeNumeric",
  Notify_PhoneNumberAddedBefore = "Notify_PhoneNumberAddedBefore",
  Notify_WhatsAppCodeSendedBeforeAndWait1Day = "Notify_WhatsAppCodeSendedBeforeAndWait1Day",
  Notify_WhatsAppCodeNotRequested = "Notify_WhatsAppCodeNotRequested",
  Notify_WhatsAppCodeMaxInvalidCountReach = "Notify_WhatsAppCodeMaxInvalidCountReach",
  Notify_UserWithThisPhoneNumberAlreadyExist = "Notify_UserWithThisPhoneNumberAlreadyExist",
  Notify_InvalidAIToolId = "Notify_InvalidAIToolId",
  Notify_AIToolParameterRequired = "Notify_AIToolParameterRequired",
  Notify_AIToolParameterNotRequired = "Notify_AIToolParameterNotRequired",
  Notify_ExceedDailyLimit = "Notify_ExceedDailyLimit",
  Notify_CannotGetTwitchRightNow = "Notify_CannotGetTwitchRightNow",
  Notify_InvalidTwitchChannelId = "Notify_InvalidTwitchChannelId",
  Notify_PhoneNumberRequired = "Notify_PhoneNumberRequired",
  Notify_NotVerifiedHost = "Notify_NotVerifiedHost",
  Notify_NotBusinesser = "Notify_NotBusinesser",
  Notify_NotFoundAnySuggestedCategory = "Notify_NotFoundAnySuggestedCategory",
  Notify_NoInvoiceExist = "Notify_NoInvoiceExist",
  Notify_InvalidMediaAiCreatorKey = "Notify_InvalidMediaAiCreatorKey",
  Notify_InvalidMediaAiVersionKey = "Notify_InvalidMediaAiVersionKey",
  Notify_InvalidMediaAiRequestModel = "Notify_InvalidMediaAiRequestModel",
  Notify_MediaAIError = "Notify_MediaAIError",
  Notify_TwitchChannelDoestHaveAnyVideo = "Notify_TwitchChannelDoestHaveAnyVideo",
  Notify_CouponAlreadyDeleted = "Notify_CouponAlreadyDeleted",
  Notify_CouponNotDeleted = "Notify_CouponNotDeleted",
  Notify_ExceedSubFlowCount = "Notify_ExceedSubFlowCount",
  Notify_ExceedFlowDepth = "Notify_ExceedFlowDepth",
  Notify_ExceedFlowItemCount = "Notify_ExceedFlowItemCount",
  Notify_ExceedFlowMediaAudioCount = "Notify_ExceedFlowMediaAudioCount",
  Notify_OneFlowButtonHasEmptyItem = "Notify_OneFlowButtonHasEmptyItem",

  // Internal Notifications
  InternalNotify_Ok = "InternalNotify_Ok",
  InternalNotify_RepetitiveHashtagInput = "InternalNotify_RepetitiveHashtagInput",
  InternalNotify_NotFoundDevice = "InternalNotify_NotFoundDevice",
  InternalNotify_EmptyHashtagList = "InternalNotify_EmptyHashtagList",
  InternalNotify_CannotCreatePrePostNow = "InternalNotify_CannotCreatePrePostNow",
  InternalNotify_PrivateAccountSelectedForCheckHashtag = "InternalNotify_PrivateAccountSelectedForCheckHashtag",
  InternalNotify_InstagramLoginRequired = "InternalNotify_InstagramLoginRequired",
  InternalNotify_InstagramLoginRequiredForVerifiedAccount = "InternalNotify_InstagramLoginRequiredForVerifiedAccount",
  InternalNotify_PrivateOrVerifiedSponsor = "InternalNotify_PrivateOrVerifiedSponsor",
  InternalNotify_InstagramLoginRequiredForPrivateAccount = "InternalNotify_InstagramLoginRequiredForPrivateAccount",
  InternalNotify_StartUploadingPost = "InternalNotify_StartUploadingPost",
  InternalNotify_UploadingPostError = "InternalNotify_UploadingPostError",
  InternalNotify_PostUploaded = "InternalNotify_PostUploaded",
  InternalNotify_ExceededMedia = "InternalNotify_ExceededMedia",
  InternalNotify_More4IceBreaker = "InternalNotify_More4IceBreaker",
  InternalNotify_CopyLink = "InternalNotify_CopyLink",
  InternalNotify_copy = "InternalNotify_copy",
  InternalNotify_CopyTrackingpost = "InternalNotify_CopyTrackingpost",
  InternalNotify_Network = "InternalNotify_Network",
  InternalNotify_TimeExpire = "InternalNotify_TimeExpire",
  InternalNotify_ExceedPermittedHashtagNumber = "InternalNotify_ExceedPermittedHashtagNumber",
  InternalNotify_ExceedPermittedUploadMedia = "InternalNotify_ExceedPermittedUploadMedia",
  InternalNotify_UnexpectedError = "InternalNotify_UnexpectedError",
  InternalNotify_CopyToClipboard = "InternalNotify_CopyToClipboard",
  InternalNotify_FillRedBorderFields = "InternalNotify_FillRedBorderFields",
  InternalNotify_RepeatedVariation = "InternalNotify_RepeatedVariation",
  InternalNotify_NeedOneProduct = "InternalNotify_NeedOneProduct",
  InternalNotify_UploadMedia = "InternalNotify_UploadMedia",
  InternalNotify_TurnOnProxy = "InternalNotify_TurnOnProxy",
  InternalNotify_ExceedPermittedLiveTime = "InternalNotify_ExceedPermittedLiveTime",
  InternalNotify_CommentDisabled = "InternalNotify_CommentDisabled",
  InternalNotify_ExceedSelectedCollaboratorPage = "InternalNotify_ExceedSelectedCollaboratorPage",
  InternalNotify_RepetitiveCollaboratorPage = "InternalNotify_RepetitiveCollaboratorPage",
  InternalNotify_ExceedPermittedSizeOfImage = "InternalNotify_ExceedPermittedSizeOfImage",
  InternalNotify_ExceedPermittedAspectRatioAlbum = "InternalNotify_ExceedPermittedAspectRatioAlbum",
  InternalNotify_ExceedPermittedSizeOfVideoAlbum = "InternalNotify_ExceedPermittedSizeOfVideoAlbum",
  InternalNotify_ExceedPermittedDurationOfVideoAlbum = "InternalNotify_ExceedPermittedDurationOfVideoAlbum",
  InternalNotify_ExceedPermittedAspectRatioReels = "InternalNotify_ExceedPermittedAspectRatioReels",
  InternalNotify_ExceedPermittedSizeOfVideoReels = "InternalNotify_ExceedPermittedSizeOfVideoReels",
  InternalNotify_ExceedPermittedDurationOfVideoReels = "InternalNotify_ExceedPermittedDurationOfVideoReels",
  InternalNotify_NotPermittedMediaType = "InternalNotify_NotPermittedMediaType",
  InternalNotify_InvalidMetaData = "InternalNotify_InvalidMetaData",
  InternalNotify_ExceedSelectedMaxTaggedPeople = "InternalNotify_ExceedSelectedMaxTaggedPeople",
  InternalNotify_ExceedSelectedMaxHashtags = "InternalNotify_ExceedSelectedMaxHashtags",
  InternalNotify_ExistedInCollaborate = "InternalNotify_ExistedInCollaborate",
  InternalNotify_ExceedPermittedAspectRatioStory = "InternalNotify_ExceedPermittedAspectRatioStory",
  InternalNotify_ExceedPermittedSizeOfVideoStory = "InternalNotify_ExceedPermittedSizeOfVideoStory",
  InternalNotify_ExceedPermittedWidthOfVideo = "InternalNotify_ExceedPermittedWidthOfVideo",
  InternalNotify_ExceedPermittedDurationOfVideoStory = "InternalNotify_ExceedPermittedDurationOfVideoStory",
  InternalNotify_BelowMinimumDurationOfVideoStory = "InternalNotify_BelowMinimumDurationOfVideoStory",
  InternalNotify_ExceedPermittedSpecificWordForAutoreply = "InternalNotify_ExceedPermittedSpecificWordForAutoreply",
  InternalNotify_ExceedPermittedAspectRatioImage = "InternalNotify_ExceedPermittedAspectRatioImage",
  InternalNotify_Success = "InternalNotify_Success",
  InternalNotify_CreateExportAvailableWith24HourPeriod = "InternalNotify_CreateExportAvailableWith24HourPeriod",
  InternalNotify_SaveIceBreaker = "InternalNotify_SaveIceBreaker",
  InternalNotify_deleteIceBreaker = "InternalNotify_deleteIceBreaker",
  InternalNotify_SavePersistenceMenu = "InternalNotify_SavePersistenceMenu",
  InternalNotify_SelectLanguage = "InternalNotify_SelectLanguage",
  InternalNotify_SaveFollowTemplate = "InternalNotify_SaveFollowTemplate",
  InternalNotify_AutoReplyOn = "InternalNotify_AutoReplyOn",
  InternalNotify_AutoReplyOff = "InternalNotify_AutoReplyOff",
  InternalNotify_AutoGeneralOn = "InternalNotify_AutoGeneralOn",
  InternalNotify_AutoGeneralOff = "InternalNotify_AutoGeneralOff",
  InternalNotify_MaxInEachCard = "InternalNotify_MaxInEachCard",
  InternalNotify_ExceedStockCard = "InternalNotify_ExceedStockCard",
  InternalNotify_DefaultAddress = "InternalNotify_DefaultAddress",
  InternalNotify_FetchingYourData = "InternalNotify_FetchingYourData",
  InternalNotify_EmptyTitleInQuickReply = "InternalNotify_EmptyTitleInQuickReply",
  InternalNotify_EmptyTitleForOutputsInQuickReply = "InternalNotify_EmptyTitleForOutputsInQuickReply",
  InternalNotify_EmptyTitleForFlow = "InternalNotify_EmptyTitleForFlow",
  InternalNotify_MultipleFlowForPrivateReply = "InternalNotify_MultipleFlowForPrivateReply",
  InternalNotify_NotPermittedForDownload = "InternalNotify_NotPermittedForDownload",
  InternalNotify_NotFeature = "InternalNotify_NotFeature",
  InternalNotify_ExceedBasefeatureTime = "InternalNotify_ExceedBasefeatureTime",
  InternalNotify_ChannelIdNotStartedWithUC = "InternalNotify_ChannelIdNotStartedWithUC",
  InternalNotify_PageAnalysisNotCompleted = "InternalNotify_PageAnalysisNotCompleted",
  usersettingexplain = "usersettingexplain",
  Responded = "Responded",
  Nodetutorial = "Nodetutorial",
  Dublicate = "Dublicate",
  zoomout = "zoomout",
  fitscreen = "fitscreen",
  zoomin = "zoomin",
  shortcuts = "shortcuts",
  Workflow_Statistics = "Workflow_Statistics",
  Nodes = "Nodes",
  Connections = "Connections",
  History_saved = "History_saved",
  Last_Auto_saved = "Last_Auto_saved",
  Canvas_Behavior = "Canvas_Behavior",
  Canvas_Behavior_explain = "Canvas_Behavior_explain",
  Data_Management = "Data_Management",
  Data_Management_explain = "Data_Management_explain",
  exportJSON = "exportJSON",
  importJSON = "importJSON",
  importJSON_success = "importJSON_success",
  importJSON_error = "importJSON_error",
  noNewAnsweredTickets = "noNewAnsweredTickets",
  noNewPendingTickets = "noNewPendingTickets",
  noNewClosedTickets = "noNewClosedTickets",
  JustCreated = "JustCreated",
  AdminReplied = "AdminReplied",
  UserReplied = "UserReplied",
  AdminClosed = "AdminClosed",
  UserClosed = "UserClosed",
  TimerClosed = "TimerClosed",
  closethisticket = "closethisticket",
  promptanalysisexplain = "promptanalysisexplain",

  // #region Direct Chat - aria labels
  backToUserList = "Back to user list",
  chatMessages = "Chat messages",
  goToLatestMessage = "Go to latest message",
  typeAMessage = "Type a message",
  uploadFile = "Upload file",
  recordVoiceMessage = "Record voice message",
  sendMessage = "Send message",
  // #endregion

  // #region Support / FAQ / Report
  support = "support",
  supportDescription = "supportDescription",
  supportKeywords = "supportKeywords",
  reportIssue = "reportIssue",
  reportIssueDescription = "reportIssueDescription",
  reportIssueKeywords = "reportIssueKeywords",
  faq = "faq",
  faqDescription = "faqDescription",
  faqKeywords = "faqKeywords",
  allCategories = "allCategories",
  financial = "financial",
  account = "account",
  payments = "payments",
  security = "security",
  features = "features",
  technical = "technical",
  faq_q1 = "faq_q1",
  faq_q2 = "faq_q2",
  faq_q3 = "faq_q3",
  faq_q4 = "faq_q4",
  faq_q5 = "faq_q5",
  faq_a1 = "faq_a1",
  faq_a2 = "faq_a2",
  faq_a3 = "faq_a3",
  faq_a4 = "faq_a4",
  faq_a5 = "faq_a5",
  faq_account_q1 = "faq_account_q1",
  faq_account_q2 = "faq_account_q2",
  faq_account_a1 = "faq_account_a1",
  faq_account_a2 = "faq_account_a2",
  faq_payments_q1 = "faq_payments_q1",
  faq_payments_a1 = "faq_payments_a1",
  faq_security_q1 = "faq_security_q1",
  faq_security_a1 = "faq_security_a1",
  faq_features_q1 = "faq_features_q1",
  faq_features_a1 = "faq_features_a1",
  faq_technical_q1 = "faq_technical_q1",
  faq_technical_a1 = "faq_technical_a1",
  searchFAQ = "searchFAQ",
  questionsFound = "questionsFound",
  expandAll = "expandAll",
  collapseAll = "collapseAll",
  noQuestionsFound = "noQuestionsFound",
  tryAdjustingSearch = "tryAdjustingSearch",
  stillHaveQuestions = "stillHaveQuestions",
  supportTeamHelp = "supportTeamHelp",
  startLiveChat = "startLiveChat",
  sendEmail = "sendEmail",
  callSupport = "callSupport",
  popularHelpTopics = "popularHelpTopics",
  gettingStarted = "gettingStarted",
  gettingStartedDesc = "gettingStartedDesc",
  viewGuide = "viewGuide",
  teamManagement = "teamManagement",
  teamManagementDesc = "teamManagementDesc",
  integrations = "integrations",
  integrationsDesc = "integrationsDesc",
  analytics = "analytics",

  // #endregion

  pageSummary = "pageSummary",
  summaryGeneralIntro = "summaryGeneralIntro",
  summaryUserEngagement = "summaryUserEngagement",
  summaryContentStrategy = "summaryContentStrategy",
  summaryPostingSchedule = "summaryPostingSchedule",
  summaryImprovementSuggestions = "summaryImprovementSuggestions",

  // #endregion General Section
  // 1️⃣ Home -> cards

  // #endregion Notification Section
  AIFlow_weblink_validation_error_alert = "AIFlow_weblink_validation_error_alert",
  New_Flow_Tutorials_onmessage_connection_7 = "New_Flow_Tutorials_onmessage_connection_7",
  New_Flow_Tutorials_genericitem_connection_7 = "New_Flow_Tutorials_genericitem_connection_7",
  papageTools_Lottery = "papageTools_Lottery",
  Notify_InvalidBankCardNotify_InvalidBankCardNumber = "Notify_InvalidBankCardNotify_InvalidBankCardNumber",
  analyticsDesc = "analyticsDesc",
  AudienceTooltip = "AudienceTooltip",

  history = "history",
  Suspended = "Suspended",
  BankCards = "BankCards",
  Transactions = "Transactions",
  Settlements = "Settlements",
  AddNewBankCard = "AddNewBankCard",
  RegisterANewCard = "RegisterANewCard",
  CardBankNumber = "CardBankNumber",
  CardNumberExplain = "CardNumberExplain",
  RegisterBankCard = "RegisterBankCard",
  CardNumber = "CardNumber",
  DefaultBankCard = "DefaultBankCard",
  SetAsDefaultBankCard = "SetAsDefaultBankCard",
  Type = "Type",
  Amount = "Amount",
  Time = "Time",
  Order = "Order",
  User = "User",
  NotAvailable = "NotAvailable",
  Unsettled = "Unsettled",
  AwaitingSettled = "AwaitingSettled",
  Settled = "Settled",
  SettlementFailed = "SettlementFailed",
  SettleRequest = "SettleRequest",
  emptyInvoice = "emptyInvoice",
  InvoiceID = "InvoiceID",
  InvoiceType = "InvoiceType",
  InvoiceHistory = "InvoiceHistory",
  OrderDetails = "OrderDetails",
  InvoiceDetails = "InvoiceDetails",
  Paid = "Paid",
  Success = "Success",
  RefundRequest = "RefundRequest",
  Refunding = "Refunding",
  Refunded = "Refunded",
  RefundFailed = "RefundFailed",
  Failed = "Failed",
  status = "status",
  Package = "Package",
  Product = "Product",
  Feature = "Feature",
  Custom = "Custom",
  Invoice = "Invoice",
  UnknownStatus = "UnknownStatus",
  NoSettlementsRegisteredYet = "NoSettlementsRegisteredYet",
  LogesticPayment = "LogesticPayment",
  ProductIncome = "ProductIncome",
  BrancyFeatureIncome = "BrancyFeatureIncome",
  BrancyLogesticPayment = "BrancyLogesticPayment",
  BrancyPackageIncome = "BrancyPackageIncome",
  BrancyProductIncome = "BrancyProductIncome",
  BrancyTransferPayment = "BrancyTransferPayment",
  WalletBalance = "WalletBalance",
  TotalWithdrawn = "TotalWithdrawn",
  FailedTransactions = "FailedTransactions",
  PendingSettlement = "PendingSettlement",
  OrderInProgress = "OrderInProgress",
  OrderPickup = "OrderPickup",
  OrderDelivery = "OrderDelivery",
  createdtime = "createdtime",
  SubInvoiceHistory = "SubInvoiceHistory",
  SmartPageAnalysis = "SmartPageAnalysis",
  EducationAndGuidance = "EducationAndGuidance",
  HowToUseBrancy = "HowToUseBrancy",
  CreateYourDigitalVersion = "CreateYourDigitalVersion",
  BrancyKnowsYou = "BrancyKnowsYou",
  BrancyKnowsYouExplain = "BrancyKnowsYouExplain",
  Postnotvisible = "Postnotvisible",
  Storynotvisible = "Storynotvisible",
  promptanalysisExplain = "promptanalysisExplain",
}
